// AUTO-GENERATED by scripts/design/build-themes.ts — DO NOT EDIT BY HAND.
// Re-run with: pnpm tsx scripts/design/build-themes.ts
//
// Source: design/refs/<slug>/analysed/* (designlang outputs)

import type { BrandTheme } from "./types";

export const PRESETS: BrandTheme[] = [
  {
    "slug": "firecrawl",
    "name": "Firecrawl",
    "source": "https://firecrawl.dev",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "suisse",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Geist Mono",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Geist+Mono:wght@100..900&display=swap",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "foreground": "hsl(0, 0%, 0%)",
          "border": "hsl(0, 0%, 93%)",
          "primary": "hsl(18, 96%, 54%)",
          "primary-foreground": "hsl(0, 0%, 0%)",
          "background": "hsl(0, 0%, 98%)"
        },
        "allVars": {
          "--color-neutral-50": "#e5e7eb",
          "--color-neutral-100": "#000000",
          "--color-neutral-200": "#c2c2c2",
          "--color-neutral-300": "#110805",
          "--color-neutral-400": "#fdfdfd",
          "--color-neutral-500": "#999999",
          "--color-text": "#000000",
          "--color-text-1": "#c2c2c2",
          "--color-text-2": "#999999",
          "--color-text-3": "#080605",
          "--color-text-4": "#110805",
          "--font-sans": "'suisse', sans-serif",
          "--font-body": "'Times', sans-serif",
          "--font-size-60": "60px",
          "--font-size-52": "52px",
          "--font-size-40": "40px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-16": "16px",
          "--font-size-15": "15px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--font-size-10": "10px",
          "--spacing-1": "1px",
          "--spacing-32": "32px",
          "--spacing-40": "40px",
          "--spacing-56": "56px",
          "--spacing-64": "64px",
          "--spacing-68": "68px",
          "--spacing-72": "72px",
          "--spacing-76": "76px",
          "--spacing-80": "80px",
          "--spacing-84": "84px",
          "--spacing-88": "88px",
          "--spacing-109": "109px",
          "--spacing-119": "119px",
          "--spacing-143": "143px",
          "--spacing-151": "151px",
          "--spacing-165": "165px",
          "--spacing-188": "188px",
          "--spacing-231": "231px",
          "--spacing-248": "248px",
          "--spacing-254": "254px",
          "--radius-sm": "4px",
          "--radius-md": "8px",
          "--radius-lg": "16px",
          "--radius-xl": "20px",
          "--radius-full": "999px",
          "--shadow-sm": "rgb(249, 249, 249) 0px 0px 0px 6px",
          "--shadow-lg": "rgba(255, 0, 0, 0.2) 0px -6px 12px 0px inset, rgba(255, 77, 0, 0.16) 0px 3px 6px 0px, rgba(255, 77, 0, 0.12) 0px 2px 4px 0px, rgba(255, 77, 0, 0.12) 0px 1px 1px 0px, rgba(255, 77, 0, 0.16) 0px 0.5px 0.5px 0px, rgba(255, 77, 0, 0.2) 0px 0.25px 0.25px 0px, rgb(249, 249, 249) 0px 0px 0px 4px, rgba(255, 76, 0, 0.1) 0px 0px 0px 5px, rgb(249, 249, 249) 0px 0px 0px 10px",
          "--shadow-xl": "rgba(0, 0, 0, 0.02) 0px 40px 48px -20px, rgba(0, 0, 0, 0.03) 0px 32px 32px -20px, rgba(0, 0, 0, 0.03) 0px 16px 24px -12px, rgba(0, 0, 0, 0.03) 0px 0px 0px 1px, rgb(249, 249, 249) 0px 0px 0px 12px",
          "--accent-black": "#262626ff",
          "--accent-white": "#ffffffff",
          "--accent-amethyst": "#9061ffff",
          "--accent-bluetron": "#2a6dfbff",
          "--accent-crimson": "#eb3424ff",
          "--accent-forest": "#42c366ff",
          "--accent-honey": "#ecb730ff",
          "--border-faint": "#edededff",
          "--border-muted": "#e8e8e8ff",
          "--border-loud": "#e6e6e6ff",
          "--illustrations-muted": "#e6e6e6ff",
          "--tw-ring-offset-shadow": "0 0 #0000",
          "--tw-ring-shadow": "0 0 #0000",
          "--tw-ring-inset": "",
          "--tw-border-spacing-x": "0",
          "--tw-ring-color": "#3b82f680",
          "--tw-ring-offset-color": "#fff",
          "--tw-ring-offset-width": "0px",
          "--tw-shadow-colored": "0 0 #0000",
          "--tw-border-spacing-y": "0",
          "--tw-numeric-spacing": "",
          "--container-width-padding": "1144px",
          "--tw-contain-size": "",
          "--tw-drop-shadow": "",
          "--tw-shadow": "0 0 #0000",
          "--heat-4": "#fa5d190a",
          "--heat-8": "#fa5d1914",
          "--heat-12": "#fa5d191f",
          "--heat-16": "#fa5d1929",
          "--heat-20": "#fa5d1933",
          "--heat-40": "#fa5d1966",
          "--heat-90": "#fa5d19e6",
          "--heat-100": "#fa5d19ff",
          "--surface": "#ffffffff",
          "--surface-raised": "#ffffffff",
          "--black-alpha-1": "#00000003",
          "--black-alpha-2": "#00000005",
          "--black-alpha-3": "#00000008",
          "--black-alpha-4": "#0000000a",
          "--black-alpha-5": "#0000000d",
          "--black-alpha-6": "#0000000f",
          "--black-alpha-7": "#00000012",
          "--black-alpha-8": "#00000014",
          "--black-alpha-10": "#0000001a",
          "--black-alpha-12": "#0000001f",
          "--black-alpha-16": "#00000029",
          "--black-alpha-20": "#00000033",
          "--black-alpha-24": "#0000003d",
          "--black-alpha-32": "#26262652",
          "--black-alpha-40": "#26262666",
          "--black-alpha-48": "#2626267a",
          "--black-alpha-56": "#2626268f",
          "--black-alpha-64": "#262626a3",
          "--black-alpha-72": "#262626b8",
          "--black-alpha-88": "#262626e0",
          "--white-alpha-56": "#ffffff8f",
          "--white-alpha-72": "#ffffffb8",
          "--illustrations-faint": "#edededff",
          "--illustrations-default": "#dbdbdbff",
          "--background-base": "#f9f9f9ff",
          "--background-lighter": "#fbfbfbff",
          "--tw-backdrop-sepia": "",
          "--tw-sepia": "",
          "--tw-ordinal": "",
          "--tw-backdrop-saturate": "",
          "--tw-contain-style": "",
          "--tw-backdrop-invert": "",
          "--tw-brightness": "",
          "--tw-backdrop-grayscale": "",
          "--tw-hue-rotate": "",
          "--tw-scale-y": "1",
          "--tw-pan-y": "",
          "--tw-backdrop-contrast": "",
          "--tw-backdrop-brightness": "",
          "--tw-pan-x": "",
          "--tw-translate-y": "0",
          "--tw-rotate": "0",
          "--tw-contrast": "",
          "--tw-skew-x": "0",
          "--tw-backdrop-blur": "",
          "--tw-translate-x": "0",
          "--tw-gradient-via-position": "",
          "--tw-saturate": "",
          "--tw-scroll-snap-strictness": "proximity",
          "--tw-grayscale": "",
          "--tw-scale-x": "1",
          "--tw-backdrop-hue-rotate": "",
          "--tw-gradient-to-position": "",
          "--tw-numeric-fraction": "",
          "--tw-skew-y": "0",
          "--tw-slashed-zero": "",
          "--tw-blur": "",
          "--tw-invert": "",
          "--tw-backdrop-opacity": "",
          "--container-width": "1112px",
          "--tw-gradient-from-position": "",
          "--tw-numeric-figure": "",
          "--tw-pinch-zoom": "",
          "--tw-contain-paint": "",
          "--tw-contain-layout": "",
          "--stack-heading-size": "60px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "64px",
          "--stack-heading-tracking": "-0.3px",
          "--stack-body-size": "16px",
          "--stack-body-weight": "400",
          "--stack-body-line-height": "24px",
          "--eyebrow-size": "12px",
          "--eyebrow-weight": "450",
          "--eyebrow-color": "color(display-p3 0.14902 0.14902 0.14902)"
        },
        "meta": {
          "extractedAt": "2026-05-08T22:30:47.733Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "body font \"suisse\" not on Google Fonts — fallback to sans-serif"
    ]
  },
  {
    "slug": "linear",
    "name": "Linear",
    "source": "https://linear.app",
    "radius": "7px",
    "fonts": {
      "body": {
        "name": "Inter Variable",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Berkeley Mono",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 100%)",
          "foreground": "hsl(225, 9%, 17%)",
          "primary": "hsl(240, 100%, 72%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(64, 89%, 54%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "accent": "hsl(121, 100%, 50%)",
          "accent-foreground": "hsl(0, 0%, 0%)",
          "border": "hsla(0, 0%, 0%, 0.08)"
        },
        "allVars": {
          "--color-primary": "#7070ff",
          "--color-secondary": "#e4f222",
          "--color-accent": "#7170ff",
          "--color-neutral-50": "#282a30",
          "--color-neutral-100": "#86848d",
          "--color-neutral-200": "#3c4149",
          "--color-neutral-300": "#000000",
          "--color-neutral-400": "#e9e8ea",
          "--color-neutral-500": "#ffffff",
          "--color-neutral-600": "#6f6e77",
          "--color-neutral-700": "#090a0b",
          "--color-neutral-800": "#121414",
          "--color-bg": "#ffffff",
          "--color-bg-1": "#090a0b",
          "--color-bg-2": "#101112",
          "--color-bg-3": "#121314",
          "--color-bg-4": "#161718",
          "--color-bg-5": "#f8f8f8",
          "--color-bg-6": "#e4f222",
          "--color-text": "#282a30",
          "--color-text-1": "#ffffff",
          "--color-text-2": "#000000",
          "--color-text-3": "#6f6e77",
          "--color-text-4": "#3c4149",
          "--font-sans": "'Inter Variable', sans-serif",
          "--font-body": "'Berkeley Mono', sans-serif",
          "--font-size-64": "64px",
          "--font-size-40": "40px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-17": "17px",
          "--font-size-16": "16px",
          "--font-size-15": "15px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--spacing-1": "1px",
          "--spacing-39": "39px",
          "--spacing-47": "47px",
          "--spacing-51": "51px",
          "--spacing-56": "56px",
          "--spacing-69": "69px",
          "--spacing-79": "79px",
          "--spacing-91": "91px",
          "--spacing-95": "95px",
          "--spacing-99": "99px",
          "--spacing-111": "111px",
          "--spacing-123": "123px",
          "--spacing-127": "127px",
          "--spacing-131": "131px",
          "--spacing-135": "135px",
          "--spacing-152": "152px",
          "--spacing-155": "155px",
          "--spacing-159": "159px",
          "--spacing-166": "166px",
          "--spacing-199": "199px",
          "--radius-xs": "1px",
          "--radius-sm": "4px",
          "--radius-md": "7px",
          "--radius-lg": "16px",
          "--radius-xl": "20px",
          "--radius-full": "9999px",
          "--shadow-sm": "rgba(0, 0, 0, 0.4) 0px 2px 4px 0px",
          "--shadow-xs": "rgba(0, 0, 0, 0.03) 0px 1.2px 0px 0px",
          "--shadow-md": "rgba(0, 0, 0, 0.2) 0px 0px 12px 0px inset",
          "--shadow-xl": "rgba(8, 9, 10, 0.6) 0px 4px 32px 0px",
          "--color-text-tertiary": "#6f6e77",
          "--color-white": "#fff",
          "--color-border-translucent": "rgba(0,0,0,0.05)",
          "--color-bg-level-3": "#f0f0f0",
          "--editor-text-color": "#e4e5e9",
          "--color-border-secondary": "#e4e2e4",
          "--btn-highlight-bg": "transparent",
          "--color-accent-hover": "#8989f0",
          "--color-border-tertiary": "#dcdbdd",
          "--color-button-invert-bg-hover": "#1f2024",
          "--color-button-invert-bg": "#282a30",
          "--color-fg-quaternary": "#86848d",
          "--color-overlay-primary": "rgba(255,255,255,0.65)",
          "--btn-highlight-color": "inherit",
          "--color-border-primary": "#e9e8ea",
          "--color-link-primary": "#7070ff",
          "--color-line-tint": "#f4f4f5",
          "--color-green": "#27a644",
          "--color-text-primary": "#282a30",
          "--color-brand-bg": "#7070ff",
          "--color-linear-security": "#7a7fad",
          "--scrollbar-color-active": "rgba(0,0,0,0.3)",
          "--color-bg-tint": "#f4f4f5",
          "--header-border": "rgba(0,0,0,0.08)",
          "--focus-ring-width": "1px",
          "--border-hairline": "1px",
          "--color-bg-level-2": "#f4f4f4",
          "--focus-ring-color": "#5e69d1",
          "--color-indigo": "#5e6ad2",
          "--color-border-translucent-strong": "rgba(0,0,0,0.08)",
          "--color-overlay-dim-rgb": "0,0,0",
          "--color-text-secondary": "#3c4149",
          "--color-line-tertiary": "#f0f0f0",
          "--color-selection-bg": "color-mix(in lch,#7070ff,transparent 64%)",
          "--color-line-secondary": "#eaeaeb",
          "--color-line-primary": "#d4d4d6",
          "--color-fg-primary": "#282a2f",
          "--color-bg-quinary": "#e9e8ea",
          "--color-text-quaternary": "#86848d",
          "--color-alpha": "0",
          "--layer-popover": "600",
          "--color-accent-tint": "#f1f1ff",
          "--header-bg": "#fff",
          "--color-line-quaternary": "#f4f4f4",
          "--color-black": "#000",
          "--scrollbar-color-hover": "rgba(0,0,0,0.2)",
          "--color-link-hover": "#282a30",
          "--color-bg-level-1": "#f8f8f8",
          "--color-brand-text": "#fff",
          "--color-teal": "#00b8cc",
          "--color-linear-plan": "#68cc58",
          "--color-orange": "#fc7840",
          "--color-selection-text": "currentColor",
          "--color-fg-secondary": "#3c4149",
          "--color-bg-translucent": "rgba(0,0,0,0.02)",
          "--color-red": "#eb5757",
          "--color-blue": "#4ea7fc",
          "--color-selection-dim": "color-mix(in lch,#7070ff,transparent 80%)",
          "--color-bg-tertiary": "#f4f2f4",
          "--focus-ring-outline": "1px solid #5e69d1",
          "--color-bg-quaternary": "#eeedef",
          "--color-bg-primary": "#fff",
          "--focus-ring-offset": "2px",
          "--color-yellow": "#f0bf00",
          "--color-fg-tertiary": "#6f6e77",
          "--color-bg-level-0": "#ffffff",
          "--scrollbar-color": "rgba(0,0,0,0.1)",
          "--color-linear-build": "#d4b144",
          "--color-bg-secondary": "#f9f8f9",
          "--text-micro-size": "0.75rem",
          "--font-size-title1": "2.25rem",
          "--title-3-letter-spacing": "-0.012em",
          "--editor-block-menu-size": "20px",
          "--scrollbar-size-active": "10px",
          "--text-regular-size": "0.9375rem",
          "--text-regular-letter-spacing": "-0.011em",
          "--font-size-miniPlus": "0.75rem",
          "--editor-block-spacing-small": "calc(0.375 * 1rem)",
          "--font-size-microPlus": "0.6875rem",
          "--title-7-size": "3.5rem",
          "--text-small-size": "0.875rem",
          "--page-padding-block": "64px",
          "--text-micro-letter-spacing": "0",
          "--title-6-letter-spacing": "-0.022em",
          "--title-9-letter-spacing": "-0.022em",
          "--title-8-size": "4rem",
          "--font-size-largePlus": "1.125rem",
          "--font-size-smallPlus": "0.8125rem",
          "--title-7-letter-spacing": "-0.022em",
          "--title-1-size": "1.0625rem",
          "--font-size-title3": "1.25rem",
          "--editor-block-spacing": "1rem",
          "--text-tiny-size": "0.625rem",
          "--font-size-regular": "0.9375rem",
          "--font-size-mini": "0.75rem",
          "--editor-last-invisible-paragraph-spacing": "10px",
          "--text-mini-letter-spacing": "-0.01em",
          "--text-tiny-letter-spacing": "-0.015em",
          "--editor-font-size": "0.9375rem",
          "--title-2-letter-spacing": "-0.012em",
          "--title-2-size": "1.25rem",
          "--title-4-size": "2rem",
          "--editor-letter-spacing": "-0.00666667em",
          "--font-size-micro": "0.6875rem",
          "--font-size-title2": "1.5rem",
          "--homepage-outer-padding": "10px",
          "--title-5-letter-spacing": "-0.022em",
          "--font-size-small": "0.8125rem",
          "--font-size-large": "1.125rem",
          "--font-size-regularPlus": "0.9375rem",
          "--page-padding-right": "max(0px,24px)",
          "--text-mini-size": "0.8125rem",
          "--page-padding-left": "max(0px,24px)",
          "--font-monospace": "\"Berkeley Mono\",ui-monospace,\"SF Mono\",\"Menlo\",monospace",
          "--title-6-size": "3rem",
          "--title-5-size": "2.5rem",
          "--title-1-letter-spacing": "-0.012em",
          "--scrollbar-size": "6px",
          "--min-tap-size": "44px",
          "--text-large-size": "1.0625rem",
          "--page-padding-inline": "24px",
          "--title-8-letter-spacing": "-0.022em",
          "--text-large-letter-spacing": "0",
          "--text-small-letter-spacing": "-0.013em",
          "--title-9-size": "4.5rem",
          "--title-3-size": "1.5rem",
          "--scrollbar-gap": "4px",
          "--homepage-padding-inset": "32px",
          "--title-4-letter-spacing": "-0.022em",
          "--editor-block-spacing-large": "calc(1.375 * 1rem)",
          "--page-padding-y": "48px",
          "--font-variations": "\"opsz\" auto",
          "--title-1-line-height": "1.4",
          "--font-emoji": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--text-tiny": "0.625rem /1.5 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--text-small-line-height": "calc(21 / 14)",
          "--text-large": "1.0625rem /1.6 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--font-regular": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-3-line-height": "1.33",
          "--text-micro-line-height": "1.4",
          "--text-tiny-line-height": "1.5",
          "--title-8-line-height": "1.06",
          "--text-regular-line-height": "1.6",
          "--text-small": "0.875rem /calc(21 / 14) \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-7-line-height": "1.1",
          "--title-5-line-height": "1.1",
          "--layer-context-menu": "1200",
          "--font-weight-medium": "510",
          "--font-weight-normal": "400",
          "--text-large-line-height": "1.6",
          "--font-settings": "\"cv01\",\"ss03\"",
          "--title-9-line-height": "1",
          "--editor-line-height": "1.6",
          "--font-weight-bold": "680",
          "--text-micro": "0.75rem /1.4 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-2-line-height": "1.33",
          "--text-mini": "0.8125rem /1.5 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-4-line-height": "1.125",
          "--text-regular": "0.9375rem /1.6 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-6-line-height": "1",
          "--font-weight-light": "300",
          "--font-serif-display": "\"Tiempos Headline\",ui-serif,Georgia,Cambria,\"Times New Roman\",Times,serif",
          "--font-weight-semibold": "590",
          "--text-mini-line-height": "1.5",
          "--btn-overlay-shadow-hover": "none",
          "--shadow-low": "0px 1px 4px -1px rgba(0,0,0,0.09)",
          "--btn-overlay-shadow": "none",
          "--shadow-medium": "0px 3px 12px rgba(0,0,0,0.09)",
          "--shadow-stack-low": "0px -1px 1px 0px rgba(0,0,0,0.11) inset,0px 8px 2px 0px rgba(0,0,0,0),0px 5px 2px 0px rgba(0,0,0,0.01),0px 3px 2px 0px rgba(0,0,0,0.04),0px 1px 1px 0px rgba(0,0,0,0.07),0px 0px 1px 0px rgba(0,0,0,0.08)",
          "--shadow-high": "0px 7px 24px rgba(0,0,0,0.06)",
          "--shadow-tiny": "0px 1px 1px 0px rgba(0,0,0,0.09)",
          "--shadow-none": "0px 0px 0px transparent",
          "--radius-rounded": "9999px",
          "--radius-circle": "50%",
          "--radius-8": "8px",
          "--radius-12": "12px",
          "--rounded-full": "9999px",
          "--radius-24": "24px",
          "--radius-4": "4px",
          "--radius-6": "6px",
          "--radius-16": "16px",
          "--editor-block-radius": "6px",
          "--radius-32": "32px",
          "--x1cxqmhc": "",
          "--x15hezws": "transparent",
          "--zoom-in": "default",
          "--xd1bcc1": "",
          "--sx-1ijrdvx": "#ff8849",
          "--sx-1uv3w6h": "#2c2d32",
          "--xn768d": "100%",
          "--speed-highlightFadeOut": "0.15s",
          "--xkthb5v": "",
          "--sx-138kmyo": "#424449",
          "--xaxo4ug": "",
          "--sx-1mc3c6y": "#1e2022",
          "--cursor-disabled": "not-allowed",
          "--xq9soxx": "inherit",
          "--x1fphd1n": "",
          "--layer-tooltip": "1100",
          "--ease-in-out-quart": "cubic-bezier(0.77,0,0.175,1)",
          "--x5igtf4": "",
          "--x7ide1": "",
          "--sx-vatjr0": "#34353a",
          "--x1mc3c6y": "",
          "--x1ikf7kw": "",
          "--sx-tw6awd": "#ffe7de",
          "--x1gm0lru": "",
          "--x1jffjrl": "",
          "--sx-kthb5v": "#6c76e0",
          "--sx-183dfpr": "#ff9958",
          "--x35jz1e": "",
          "--ease-in-out-circ": "cubic-bezier(0.785,0.135,0.15,0.86)",
          "--title-7": "590 3.5rem /1.1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x8gevfv": "",
          "--speed-quickTransition": "0.1s",
          "--sx-jw5zf4": "#39b350",
          "--xkbzynh": "transparent",
          "--sx-pqiwo2": "#373a56",
          "--title-1": "590 1.0625rem /1.4 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x13kjjc4": "",
          "--xds2y8i": "5px",
          "--x1ele6il": "",
          "--xw1p5jj": "",
          "--x1hz3utq": "",
          "--x1urpf9d": "",
          "--transparent": "rgba(255,255,255,0)",
          "--layer-2": "2",
          "--sx-6zt3z6": "1px solid #28292e",
          "--editor-bullet-disc-offset": "0.5em",
          "--xcx2ark": "",
          "--sx-1fh23cp": "#9c9da1",
          "--xohseg1": "",
          "--xtw6awd": "",
          "--xx7veac": "transparent",
          "--xickszr": "",
          "--sx-1vyp3gc": "#ffeac6",
          "--x1yxqotz": "",
          "--x1m4y240": "",
          "--x7jk47a": "",
          "--sx-ay0skx": "#fefeff",
          "--x16hn3q3": "",
          "--sx-or1tl7": "#55ccff",
          "--sx-ys2i3t": "#ffffff",
          "--x1gakdvt": "",
          "--sx-umgfby": "0 1px 1px inset #00000011, 0 1px 3px inset #00000011, 0 2px 5px inset #00000019",
          "--xjw5zf4": "",
          "--sx-1rzu7x2": "#626366",
          "--xbpgheo": "",
          "--x1s7kw6p": "transparent",
          "--x11lpf43": "0.8125rem",
          "--ease-out-circ": "cubic-bezier(0.075,0.82,0.165,1)",
          "--ease-out-quint": "cubic-bezier(0.23,1,0.32,1)",
          "--sx-1n1r1h9": "#ffffff0d",
          "--title-5": "590 2.5rem /1.1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-1cxqmhc": "#00e8ff",
          "--sx-5t1vcl": "#00ceff",
          "--1fr": "minmax(0,1fr)",
          "--xirmyh9": "",
          "--sx-2icmlu": "#08080826",
          "--sx-cx2ark": "#37393e",
          "--title-6": "590 3rem /1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x1qdowq0": "",
          "--dvh": "1dvh",
          "--xykavoc": "5px",
          "--xn8xqcl": "",
          "--sx-1h56kua": "#f0bf00",
          "--sx-1rsaf4u": "#2a2d48",
          "--xkwfvdu": "--x1o1lnwn",
          "--sx-35jz1e": "#3c3f5c",
          "--100svh": "calc(100 * 1svh)",
          "--xy7jo44": "inherit",
          "--sx-10lzhmx": "0px 4px 4px -1px #0000000a, 0px 1px 1px 0px #00000014",
          "--xot17o6": "",
          "--x1umwnkk": "\"Berkeley Mono\",\"SFMono Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace",
          "--x1ps2i54": "",
          "--sx-k68kma": "#2d2f34",
          "--x1rnpv0l": "",
          "--xciqj87": "",
          "--cursor-none": "none",
          "--sx-ykavoc": "8px",
          "--sx-v3o8qy": "#636467",
          "--scrollbar-width": "12px",
          "--x1edn6di": "",
          "--mask-visible": "black",
          "--sx-d29rh7": "#28292e",
          "--xx8afrf": "6px",
          "--x2icmlu": "",
          "--x1ltkoa": "",
          "--xumgfby": "",
          "--sx-13m9wh7": "#007def",
          "--x105wzx7": "",
          "--sx-13kjjc4": "#38393d",
          "--sx-1q6smeb": "#ff6565",
          "--svh": "1svh",
          "--xnihqbq": "",
          "--ease-in-quint": "cubic-bezier(0.755,0.05,0.855,0.06)",
          "--sx-c3gk8m": "0 0 0 1px #5e69d1",
          "--sx-16hn3q3": "#242629",
          "--x129bhjt": "",
          "--speed-highlightFadeIn": "0s",
          "--sx-1xaoi8i": "#7a88ff",
          "--x1crf4sx": "",
          "--sx-d1bcc1": "#08080826",
          "--homepage-max-width": "calc(1344px + 10px * 2)",
          "--mask-off": "transparent",
          "--x1gxylln": "",
          "--sx-3zwjav": "#e4e5e9",
          "--mask-on": "black",
          "--x91u3ar": "",
          "--xgauayi": "",
          "--header-blur": "20px",
          "--sx-8gevfv": "#43bc58",
          "--xpuww38": "",
          "--xvatjr0": "",
          "--x1h56kua": "",
          "--prose-max-width": "624px",
          "--sx-6od1kq": "#dbffff",
          "--x10o0rs5": "",
          "--x1glqxor": "",
          "--x1gcjx5j": "",
          "--x74qs5": "",
          "--sx-ws85c5": "#fcfaff",
          "--sx-15wwovl": "#28292e",
          "--sx-1qdowq0": "#00000066",
          "--sx-6ayg1n": "#2e3036",
          "--sx-ikq9iy": "#322122",
          "--xas9fd0": "",
          "--layer-max": "10000",
          "--xk68kma": "",
          "--xnnhj77": "",
          "--ease-out-expo": "cubic-bezier(0.19,1,0.22,1)",
          "--sx-g52i5g": "#1c1f24",
          "--sx-9o00jb": "#00c6d9",
          "--x19k7np8": "1",
          "--xwsz0k3": "",
          "--mask-invisible": "transparent",
          "--xi20l48": "",
          "--layer-dialog": "700",
          "--xg52i5g": "",
          "--x10845vo": "",
          "--xhfmm6c": "",
          "--sx-1k7nh0l": "#fffaa6",
          "--x1k7v50d": "",
          "--editor-block-menu-offset": "28px",
          "--speed-regularTransition": "0.25s",
          "--x1stx5uy": "",
          "--x133wec9": "",
          "--x6zt3z6": "",
          "--sx-142jeir": "#28292e",
          "--cursor-pointer": "pointer",
          "--editor-safe-area": "16px",
          "--ease-in-out-quad": "cubic-bezier(0.455,0.03,0.515,0.955)",
          "--x1q6smeb": "",
          "--icon-grayscale-image-filter": "grayscale(100%) brightness(0%)",
          "--x1a798ef": "6px",
          "--sx-1yxqotz": "#5e6ad2",
          "--xb9djef": "transparent",
          "--xfeitbp": "",
          "--x1vqca58": "",
          "--ease-in-expo": "cubic-bezier(0.95,0.05,0.795,0.035)",
          "--ease-in-cubic": "cubic-bezier(0.55,0.055,0.675,0.19)",
          "--x1ijrdvx": "",
          "--x1em7oyp": "",
          "--title-4": "590 2rem /1.125 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-17ckey5": "#ff5d5e",
          "--sx-74qs5": "#00000001",
          "--xc3gk8m": "",
          "--x1ospiv4": "",
          "--mask-ease": "rgba(0,0,0,0.2)",
          "--sx-14ggo8w": "#1e2823",
          "--title-3": "590 1.5rem /1.33 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x1ddj3ws": "",
          "--sx-7jk47a": "#2b2c2f",
          "--sx-1m4y240": "#19191b",
          "--sx-ljw4h1": "#303236",
          "--x629164": "",
          "--header-height": "72px",
          "--x14ggo8w": "",
          "--sx-18pfyxa": "6px 12px",
          "--editor-todolist-checkbox-width": "14px",
          "--x1g0wh59": "transparent",
          "--sx-1urpf9d": "#ffffff0d",
          "--xor1tl7": "",
          "--sx-1stx5uy": "#74e3ff",
          "--sx-7ide1": "#747ee9",
          "--x142jeir": "",
          "--x1uoekal": "",
          "--ease-out-quad": "cubic-bezier(0.25,0.46,0.45,0.94)",
          "--sx-138rywl": "13vh",
          "--x10lzhmx": "",
          "--sx-sfnrch": "#f0bf00",
          "--sx-1ltkoa": "#626467",
          "--xpi45vo": "transparent",
          "--sx-1dcvabv": "#332024",
          "--x193njt9": "",
          "--sx-91u3ar": "#ffcc00",
          "--sx-18uyzu6": "#008a2a",
          "--sx-ot17o6": "#00cee2",
          "--sx-1gm0lru": "#282a30",
          "--sx-34xdpc": "#d9343f",
          "--sx-1gxylln": "#232528",
          "--ease-out-quart": "cubic-bezier(0.165,0.84,0.44,1)",
          "--sx-1ccqs4f": "#3f4145",
          "--x3zwjav": "",
          "--xugsh4": "",
          "--sx-feitbp": "#ffffff",
          "--layer-debug": "5100",
          "--sx-fwc8so": "#cf4608",
          "--ease-in-circ": "cubic-bezier(0.6,0.04,0.98,0.335)",
          "--sx-13sdql6": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--x1eapsa9": "",
          "--x1uv3w6h": "",
          "--sx-1vqca58": "#69daff",
          "--xd29rh7": "",
          "--sx-1fphd1n": "#232427",
          "--ease-in-quart": "cubic-bezier(0.895,0.03,0.685,0.22)",
          "--ease-in-out-cubic": "cubic-bezier(0.645,0.045,0.355,1)",
          "--sx-5igtf4": "#ffffff0d",
          "--page-inset": "32px",
          "--x34xdpc": "",
          "--sx-as9fd0": "#282a30",
          "--sx-ugsh4": "#ffd500",
          "--ease-in-out-quint": "cubic-bezier(0.86,0,0.07,1)",
          "--editor-bullet-disc-width": "0.5em",
          "--x17ckey5": "",
          "--x19hxmp1": "",
          "--sx-n8xqcl": "#5e69d1",
          "--sx-1glqxor": "#232535",
          "--sx-w1p5jj": "#37393e",
          "--layer-command-menu": "650",
          "--ease-in-out-expo": "cubic-bezier(1,0,0,1)",
          "--sx-1k7v50d": "0 4px 40px #00000019, 0 3px 20px #0000001f,0 3px 12px #0000001f, 0 2px 8px #0000001f, 0 1px 1px #0000001f",
          "--x138rywl": "13vh",
          "--sx-1ospiv4": "#ffffff14",
          "--x13m9wh7": "",
          "--layer-dialog-overlay": "699",
          "--xjupg42": "",
          "--xpqiwo2": "",
          "--x1jpq86z": "transparent",
          "--sx-1jffjrl": "#6a76e3",
          "--layer-footer": "50",
          "--sx-cb0zzs": "#35373d",
          "--sx-ch85qk": "#5e69d1",
          "--sx-1ubxoo9": "#1e2022",
          "--x1ccqs4f": "",
          "--x18uyzu6": "",
          "--sx-wsz0k3": "#26a544",
          "--sx-1qlh175": "#00889c",
          "--xch85qk": "",
          "--sx-193njt9": "#ffffff22",
          "--x1dd5bcf": "",
          "--layer-scrollbar": "75",
          "--sx-1dhg814": "0 3px 8px #0000001f, 0 2px 5px #0000001f, 0 1px 1px #0000001f",
          "--sx-629164": "#2b2c2f",
          "--sx-1dd5bcf": "#9c9da1",
          "--sx-1uoekal": "#00b8cb",
          "--cursor-tooltip": "help",
          "--sx-1uztw8p": "#ffffff30",
          "--x1rsaf4u": "",
          "--x1k7nh0l": "",
          "--xv3o8qy": "",
          "--xys2i3t": "",
          "--pointer": "default",
          "--x1rwcria": "",
          "--title-2": "590 1.25rem /1.33 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-1ikf7kw": "#ffffff22",
          "--x6ayg1n": "",
          "--x1o1lnwn": "",
          "--sx-1gakdvt": "#25283f",
          "--underline-offset": "clamp(2px,0.225em,6px)",
          "--x1fh23cp": "",
          "--x15wwovl": "",
          "--xmsgncm": "",
          "--page-max-width": "1024px",
          "--sx-129bhjt": "#967000",
          "--sx-1ipkkxf": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",\"Linear Thai\",sans-serif",
          "--x1uztw8p": "",
          "--ease-in-quad": "cubic-bezier(0.55,0.085,0.68,0.53)",
          "--x1jmjcvw": "",
          "--title-9": "590 4.5rem /1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--layer-overlay": "500",
          "--sx-180qi0f": "#d5ffd6",
          "--xj1ai0m": "",
          "--sx-irmyh9": "#ffffff13",
          "--sx-11lpf43": "0.8125rem",
          "--sx-1bu05id": "#ff8583",
          "--grid-columns": "12",
          "--x138kmyo": "",
          "--x13sdql6": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--x1dcvabv": "",
          "--x180qi0f": "",
          "--sx-19hxmp1": "#adbaff",
          "--layer-header": "100",
          "--sx-1o1lnwn": "#28292e",
          "--layer-toasts": "800",
          "--sx-1gcjx5j": "#2d2f37",
          "--x183dfpr": "",
          "--sx-1em7oyp": "#1b263a",
          "--sx-11vg3qk": "#ff7235",
          "--xcb0zzs": "",
          "--x1uu732i": "12px",
          "--x9o00jb": "",
          "--sx-i20l48": "#f34e52",
          "--sx-1edn6di": "#2f3034",
          "--xkig6sr": "",
          "--sx-j1ai0m": "#e4e5e9",
          "--x1qlh175": "",
          "--xhsrmg4": "",
          "--x1rzu7x2": "",
          "--xfwc8so": "",
          "--ximi5ey": "",
          "--xljw4h1": "",
          "--sx-ickszr": "#fefeff",
          "--sx-1hz3utq": "#ff8042",
          "--layer-3": "3",
          "--ease-out-cubic": "cubic-bezier(0.215,0.61,0.355,1)",
          "--title-8": "590 4rem /1.06 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x18pfyxa": "6px 12px",
          "--x1ipkkxf": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",\"Linear Thai\",sans-serif",
          "--sx-axo4ug": "0 0 0 0.5px #28292e",
          "--xay0skx": "",
          "--sx-10o0rs5": "#e4e5e9",
          "--sx-10845vo": "#c9ffff",
          "--sx-1ps2i54": "#1b282d",
          "--layer-skip-nav": "5000",
          "--x1ubxoo9": "",
          "--sx-1umwnkk": "\"Berkeley Mono\",\"SFMono Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace",
          "--xikq9iy": "",
          "--x1n1r1h9": "",
          "--sx-1jmjcvw": "#ffffff0d",
          "--x1xaoi8i": "",
          "--x1bu05id": "",
          "--sx-105wzx7": "#edbf0a",
          "--x1dhg814": "",
          "--sx-1uu732i": "12px",
          "--sx-msgncm": "#292521",
          "--layer-1": "1",
          "--sx-hfmm6c": "#2d2e31",
          "--underline-thickness": "from-font",
          "--radix-select-content-available-height": "none",
          "--x1vyp3gc": "",
          "--sx-1eapsa9": "#626366",
          "--xjrz3l0": "transparent",
          "--editor-list-inset": "1.5rem",
          "--xsfnrch": "",
          "--sx-1ele6il": "1px",
          "--x6od1kq": "",
          "--xws85c5": "",
          "--100dvh": "calc(100 * 1dvh)",
          "--sx-x8afrf": "6px",
          "--x5t1vcl": "",
          "--x11vg3qk": "",
          "--radix-select-trigger-width": "0px",
          "--sx-ciqj87": "#3de261",
          "--sx-bpgheo": "#636fd7"
        },
        "meta": {
          "extractedAt": "2026-05-08T20:51:00.782Z"
        }
      },
      "dark": {
        "colors": {
          "background": "hsl(210, 11%, 4%)",
          "foreground": "hsl(180, 7%, 97%)",
          "primary": "hsl(64, 89%, 54%)",
          "primary-foreground": "hsl(0, 0%, 0%)",
          "secondary": "hsl(234, 56%, 60%)",
          "secondary-foreground": "hsl(0, 0%, 100%)",
          "accent": "hsl(121, 100%, 50%)",
          "accent-foreground": "hsl(0, 0%, 0%)",
          "muted": "hsl(180, 5%, 7%)",
          "muted-foreground": "hsl(180, 7%, 97%)",
          "border": "hsla(0, 0%, 100%, 0.08)"
        },
        "allVars": {
          "--color-primary": "#e4f222",
          "--color-secondary": "#5e6ad2",
          "--color-accent": "#7170ff",
          "--color-neutral-50": "#f7f8f8",
          "--color-neutral-100": "#62666d",
          "--color-neutral-200": "#d0d6e0",
          "--color-neutral-300": "#e5e5e6",
          "--color-neutral-400": "#8a8f98",
          "--color-neutral-500": "#08090a",
          "--color-neutral-600": "#23252a",
          "--color-neutral-700": "#323334",
          "--color-neutral-800": "#000000",
          "--color-neutral-900": "#121414",
          "--color-bg": "#08090a",
          "--color-bg-1": "#090a0b",
          "--color-bg-2": "#101112",
          "--color-bg-3": "#121314",
          "--color-bg-4": "#ffffff",
          "--color-bg-5": "#161718",
          "--color-bg-6": "#0f1011",
          "--color-bg-7": "#e4f222",
          "--color-text": "#f7f8f8",
          "--color-text-1": "#ffffff",
          "--color-text-2": "#8a8f98",
          "--color-text-3": "#08090a",
          "--color-text-4": "#d0d6e0",
          "--font-sans": "'Inter Variable', sans-serif",
          "--font-body": "'Berkeley Mono', sans-serif",
          "--font-size-64": "64px",
          "--font-size-40": "40px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-17": "17px",
          "--font-size-16": "16px",
          "--font-size-15": "15px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--spacing-1": "1px",
          "--spacing-39": "39px",
          "--spacing-47": "47px",
          "--spacing-51": "51px",
          "--spacing-56": "56px",
          "--spacing-69": "69px",
          "--spacing-79": "79px",
          "--spacing-91": "91px",
          "--spacing-95": "95px",
          "--spacing-99": "99px",
          "--spacing-111": "111px",
          "--spacing-123": "123px",
          "--spacing-127": "127px",
          "--spacing-131": "131px",
          "--spacing-135": "135px",
          "--spacing-152": "152px",
          "--spacing-155": "155px",
          "--spacing-159": "159px",
          "--spacing-166": "166px",
          "--spacing-199": "199px",
          "--radius-xs": "1px",
          "--radius-sm": "4px",
          "--radius-md": "7px",
          "--radius-lg": "16px",
          "--radius-xl": "20px",
          "--radius-full": "9999px",
          "--shadow-sm": "rgba(0, 0, 0, 0.4) 0px 2px 4px 0px",
          "--shadow-xs": "rgba(0, 0, 0, 0.03) 0px 1.2px 0px 0px",
          "--shadow-md": "rgba(0, 0, 0, 0.2) 0px 0px 12px 0px inset",
          "--shadow-xl": "rgba(8, 9, 10, 0.6) 0px 4px 32px 0px",
          "--color-text-tertiary": "#8a8f98",
          "--color-white": "#fff",
          "--color-border-translucent": "rgba(255,255,255,0.05)",
          "--color-bg-level-3": "#191a1b",
          "--editor-text-color": "#e4e5e9",
          "--color-border-secondary": "#34343a",
          "--btn-highlight-bg": "transparent",
          "--color-accent-hover": "#828fff",
          "--color-border-tertiary": "#3e3e44",
          "--color-button-invert-bg-hover": "#fff",
          "--color-button-invert-bg": "#e5e5e6",
          "--color-fg-quaternary": "#62666d",
          "--color-overlay-primary": "rgba(0,0,0,0.85)",
          "--btn-highlight-color": "inherit",
          "--color-border-primary": "#23252a",
          "--color-link-primary": "#828fff",
          "--color-line-tint": "#141516",
          "--color-green": "#27a644",
          "--color-text-primary": "#f7f8f8",
          "--color-brand-bg": "#5e6ad2",
          "--color-bg-marketing": "#010102",
          "--color-bg-panel": "#0f1011",
          "--color-linear-security": "#7a7fad",
          "--scrollbar-color-active": "rgba(255,255,255,0.4)",
          "--color-bg-tint": "#141516",
          "--header-border": "rgba(255,255,255,0.08)",
          "--focus-ring-width": "1px",
          "--border-hairline": "1px",
          "--color-bg-level-2": "#141516",
          "--focus-ring-color": "#5e69d1",
          "--color-indigo": "#5e6ad2",
          "--color-border-translucent-strong": "rgba(255,255,255,0.08)",
          "--color-overlay-dim-rgb": "255,255,255",
          "--color-text-secondary": "#d0d6e0",
          "--color-line-tertiary": "#18191a",
          "--color-selection-bg": "color-mix(in lch,#5e6ad2,black 10%)",
          "--color-line-secondary": "#202122",
          "--color-line-primary": "#37393a",
          "--color-fg-primary": "#f7f8f8",
          "--color-bg-quinary": "#282828",
          "--color-text-quaternary": "#62666d",
          "--color-alpha": "255",
          "--layer-popover": "600",
          "--color-accent-tint": "#18182f",
          "--header-bg": "rgba(11,11,11,0.8)",
          "--color-line-quaternary": "#141515",
          "--color-black": "#000",
          "--scrollbar-color-hover": "rgba(255,255,255,0.2)",
          "--color-link-hover": "#fff",
          "--color-bg-level-1": "#0f1011",
          "--color-brand-text": "#fff",
          "--color-teal": "#00b8cc",
          "--color-linear-plan": "#68cc58",
          "--color-orange": "#fc7840",
          "--color-selection-text": "#fff",
          "--color-fg-secondary": "#d0d6e0",
          "--color-bg-translucent": "rgba(255,255,255,0.05)",
          "--color-red": "#eb5757",
          "--color-blue": "#4ea7fc",
          "--color-selection-dim": "color-mix(in lch,#5e6ad2,transparent 80%)",
          "--color-bg-tertiary": "#232326",
          "--focus-ring-outline": "1px solid #5e69d1",
          "--color-bg-quaternary": "#28282c",
          "--color-bg-primary": "#08090a",
          "--focus-ring-offset": "2px",
          "--color-yellow": "#f0bf00",
          "--color-fg-tertiary": "#8a8f98",
          "--color-bg-level-0": "#08090a",
          "--scrollbar-color": "rgba(255,255,255,0.1)",
          "--color-linear-build": "#d4b144",
          "--color-bg-secondary": "#1c1c1f",
          "--text-micro-size": "0.75rem",
          "--font-size-title1": "2.25rem",
          "--title-3-letter-spacing": "-0.012em",
          "--editor-block-menu-size": "20px",
          "--scrollbar-size-active": "10px",
          "--text-regular-size": "0.9375rem",
          "--font-size-miniPlus": "0.75rem",
          "--text-regular-letter-spacing": "-0.011em",
          "--editor-block-spacing-small": "calc(0.375 * 1rem)",
          "--font-size-microPlus": "0.6875rem",
          "--title-7-size": "3.5rem",
          "--text-small-size": "0.875rem",
          "--page-padding-block": "64px",
          "--text-micro-letter-spacing": "0",
          "--title-6-letter-spacing": "-0.022em",
          "--title-9-letter-spacing": "-0.022em",
          "--title-8-size": "4rem",
          "--font-size-largePlus": "1.125rem",
          "--font-size-smallPlus": "0.8125rem",
          "--title-7-letter-spacing": "-0.022em",
          "--title-1-size": "1.0625rem",
          "--font-size-title3": "1.25rem",
          "--editor-block-spacing": "1rem",
          "--text-tiny-size": "0.625rem",
          "--font-size-regular": "0.9375rem",
          "--font-size-mini": "0.75rem",
          "--editor-last-invisible-paragraph-spacing": "10px",
          "--text-mini-letter-spacing": "-0.01em",
          "--text-tiny-letter-spacing": "-0.015em",
          "--editor-font-size": "0.9375rem",
          "--title-2-letter-spacing": "-0.012em",
          "--title-2-size": "1.25rem",
          "--title-4-size": "2rem",
          "--editor-letter-spacing": "-0.00666667em",
          "--font-size-micro": "0.6875rem",
          "--font-size-title2": "1.5rem",
          "--homepage-outer-padding": "10px",
          "--title-5-letter-spacing": "-0.022em",
          "--font-size-small": "0.8125rem",
          "--font-size-large": "1.125rem",
          "--font-size-regularPlus": "0.9375rem",
          "--page-padding-right": "max(0px,24px)",
          "--text-mini-size": "0.8125rem",
          "--page-padding-left": "max(0px,24px)",
          "--font-monospace": "\"Berkeley Mono\",ui-monospace,\"SF Mono\",\"Menlo\",monospace",
          "--title-6-size": "3rem",
          "--title-5-size": "2.5rem",
          "--title-1-letter-spacing": "-0.012em",
          "--scrollbar-size": "6px",
          "--min-tap-size": "44px",
          "--text-large-size": "1.0625rem",
          "--page-padding-inline": "24px",
          "--title-8-letter-spacing": "-0.022em",
          "--text-large-letter-spacing": "0",
          "--text-small-letter-spacing": "-0.013em",
          "--title-9-size": "4.5rem",
          "--title-3-size": "1.5rem",
          "--scrollbar-gap": "4px",
          "--homepage-padding-inset": "32px",
          "--title-4-letter-spacing": "-0.022em",
          "--editor-block-spacing-large": "calc(1.375 * 1rem)",
          "--page-padding-y": "48px",
          "--font-variations": "\"opsz\" auto",
          "--title-1-line-height": "1.4",
          "--font-emoji": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--text-tiny": "0.625rem /1.5 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--text-small-line-height": "calc(21 / 14)",
          "--text-large": "1.0625rem /1.6 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--font-regular": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-3-line-height": "1.33",
          "--text-micro-line-height": "1.4",
          "--text-tiny-line-height": "1.5",
          "--title-8-line-height": "1.06",
          "--text-regular-line-height": "1.6",
          "--text-small": "0.875rem /calc(21 / 14) \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-7-line-height": "1.1",
          "--title-5-line-height": "1.1",
          "--layer-context-menu": "1200",
          "--font-weight-normal": "400",
          "--font-weight-medium": "510",
          "--text-large-line-height": "1.6",
          "--font-settings": "\"cv01\",\"ss03\"",
          "--title-9-line-height": "1",
          "--editor-line-height": "1.6",
          "--font-weight-bold": "680",
          "--text-micro": "0.75rem /1.4 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-2-line-height": "1.33",
          "--text-mini": "0.8125rem /1.5 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-4-line-height": "1.125",
          "--text-regular": "0.9375rem /1.6 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--title-6-line-height": "1",
          "--font-weight-light": "300",
          "--font-serif-display": "\"Tiempos Headline\",ui-serif,Georgia,Cambria,\"Times New Roman\",Times,serif",
          "--font-weight-semibold": "590",
          "--text-mini-line-height": "1.5",
          "--btn-overlay-shadow-hover": "none",
          "--shadow-low": "0px 2px 4px rgba(0,0,0,0.1)",
          "--btn-overlay-shadow": "none",
          "--shadow-medium": "0px 4px 24px rgba(0,0,0,0.2)",
          "--shadow-stack-low": "0px 8px 2px 0px rgba(0,0,0,0),0px 5px 2px 0px rgba(0,0,0,0.01),0px 3px 2px 0px rgba(0,0,0,0.04),0px 1px 1px 0px rgba(0,0,0,0.07),0px 0px 1px 0px rgba(0,0,0,0.08)",
          "--shadow-high": "0px 7px 32px rgba(0,0,0,0.35)",
          "--shadow-tiny": "0px 0px 0px transparent",
          "--shadow-none": "0px 0px 0px transparent",
          "--radius-rounded": "9999px",
          "--radius-circle": "50%",
          "--radius-8": "8px",
          "--radius-12": "12px",
          "--rounded-full": "9999px",
          "--radius-24": "24px",
          "--radius-4": "4px",
          "--radius-6": "6px",
          "--radius-16": "16px",
          "--editor-block-radius": "6px",
          "--radius-32": "32px",
          "--x1cxqmhc": "",
          "--x15hezws": "transparent",
          "--zoom-in": "default",
          "--xd1bcc1": "",
          "--sx-1ijrdvx": "#ff8849",
          "--sx-1uv3w6h": "#2c2d32",
          "--xn768d": "100%",
          "--speed-highlightFadeOut": "0.15s",
          "--xkthb5v": "",
          "--sx-138kmyo": "#424449",
          "--xaxo4ug": "",
          "--sx-1mc3c6y": "#1e2022",
          "--cursor-disabled": "not-allowed",
          "--xq9soxx": "inherit",
          "--x1fphd1n": "",
          "--layer-tooltip": "1100",
          "--ease-in-out-quart": "cubic-bezier(0.77,0,0.175,1)",
          "--x5igtf4": "",
          "--x7ide1": "",
          "--sx-vatjr0": "#34353a",
          "--x1mc3c6y": "",
          "--x1ikf7kw": "",
          "--sx-tw6awd": "#ffe7de",
          "--x1gm0lru": "",
          "--x1jffjrl": "",
          "--sx-kthb5v": "#6c76e0",
          "--sx-183dfpr": "#ff9958",
          "--x35jz1e": "",
          "--ease-in-out-circ": "cubic-bezier(0.785,0.135,0.15,0.86)",
          "--title-7": "590 3.5rem /1.1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x8gevfv": "",
          "--speed-quickTransition": "0.1s",
          "--sx-jw5zf4": "#39b350",
          "--xkbzynh": "transparent",
          "--sx-pqiwo2": "#373a56",
          "--x13kjjc4": "",
          "--title-1": "590 1.0625rem /1.4 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--xds2y8i": "5px",
          "--x1ele6il": "",
          "--xw1p5jj": "",
          "--x1hz3utq": "",
          "--x1urpf9d": "",
          "--transparent": "rgba(255,255,255,0)",
          "--layer-2": "2",
          "--editor-bullet-disc-offset": "0.5em",
          "--sx-6zt3z6": "1px solid #28292e",
          "--xcx2ark": "",
          "--sx-1fh23cp": "#9c9da1",
          "--xohseg1": "",
          "--xtw6awd": "",
          "--xx7veac": "transparent",
          "--sx-1vyp3gc": "#ffeac6",
          "--xickszr": "",
          "--x1yxqotz": "",
          "--x1m4y240": "",
          "--x7jk47a": "",
          "--sx-ay0skx": "#fefeff",
          "--x16hn3q3": "",
          "--sx-or1tl7": "#55ccff",
          "--sx-ys2i3t": "#ffffff",
          "--x1gakdvt": "",
          "--sx-umgfby": "0 1px 1px inset #00000011, 0 1px 3px inset #00000011, 0 2px 5px inset #00000019",
          "--xjw5zf4": "",
          "--xbpgheo": "",
          "--sx-1rzu7x2": "#626366",
          "--x1s7kw6p": "transparent",
          "--x11lpf43": "0.8125rem",
          "--ease-out-circ": "cubic-bezier(0.075,0.82,0.165,1)",
          "--ease-out-quint": "cubic-bezier(0.23,1,0.32,1)",
          "--sx-1n1r1h9": "#ffffff0d",
          "--title-5": "590 2.5rem /1.1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-1cxqmhc": "#00e8ff",
          "--1fr": "minmax(0,1fr)",
          "--sx-5t1vcl": "#00ceff",
          "--xirmyh9": "",
          "--sx-2icmlu": "#08080826",
          "--sx-cx2ark": "#37393e",
          "--title-6": "590 3rem /1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x1qdowq0": "",
          "--dvh": "1dvh",
          "--xykavoc": "5px",
          "--xn8xqcl": "",
          "--sx-1h56kua": "#f0bf00",
          "--sx-1rsaf4u": "#2a2d48",
          "--xkwfvdu": "--x1o1lnwn",
          "--sx-35jz1e": "#3c3f5c",
          "--100svh": "calc(100 * 1svh)",
          "--xy7jo44": "inherit",
          "--sx-10lzhmx": "0px 4px 4px -1px #0000000a, 0px 1px 1px 0px #00000014",
          "--xot17o6": "",
          "--x1umwnkk": "\"Berkeley Mono\",\"SFMono Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace",
          "--x1ps2i54": "",
          "--sx-k68kma": "#2d2f34",
          "--x1rnpv0l": "",
          "--xciqj87": "",
          "--cursor-none": "none",
          "--sx-ykavoc": "8px",
          "--sx-v3o8qy": "#636467",
          "--x1edn6di": "",
          "--scrollbar-width": "12px",
          "--mask-visible": "black",
          "--sx-d29rh7": "#28292e",
          "--xx8afrf": "6px",
          "--x2icmlu": "",
          "--x1ltkoa": "",
          "--sx-13m9wh7": "#007def",
          "--xumgfby": "",
          "--x105wzx7": "",
          "--sx-13kjjc4": "#38393d",
          "--svh": "1svh",
          "--sx-1q6smeb": "#ff6565",
          "--xnihqbq": "",
          "--ease-in-quint": "cubic-bezier(0.755,0.05,0.855,0.06)",
          "--sx-c3gk8m": "0 0 0 1px #5e69d1",
          "--sx-16hn3q3": "#242629",
          "--x129bhjt": "",
          "--speed-highlightFadeIn": "0s",
          "--x1crf4sx": "",
          "--sx-1xaoi8i": "#7a88ff",
          "--sx-d1bcc1": "#08080826",
          "--homepage-max-width": "calc(1344px + 10px * 2)",
          "--mask-off": "transparent",
          "--x1gxylln": "",
          "--sx-3zwjav": "#e4e5e9",
          "--mask-on": "black",
          "--x91u3ar": "",
          "--xgauayi": "",
          "--header-blur": "20px",
          "--sx-8gevfv": "#43bc58",
          "--xpuww38": "",
          "--xvatjr0": "",
          "--x1h56kua": "",
          "--prose-max-width": "624px",
          "--sx-6od1kq": "#dbffff",
          "--x10o0rs5": "",
          "--x1glqxor": "",
          "--x1gcjx5j": "",
          "--x74qs5": "",
          "--sx-ws85c5": "#fcfaff",
          "--sx-1qdowq0": "#00000066",
          "--sx-15wwovl": "#28292e",
          "--sx-6ayg1n": "#2e3036",
          "--sx-ikq9iy": "#322122",
          "--xas9fd0": "",
          "--layer-max": "10000",
          "--xnnhj77": "",
          "--xk68kma": "",
          "--ease-out-expo": "cubic-bezier(0.19,1,0.22,1)",
          "--xwsz0k3": "",
          "--sx-g52i5g": "#1c1f24",
          "--sx-9o00jb": "#00c6d9",
          "--x19k7np8": "1",
          "--mask-invisible": "transparent",
          "--xi20l48": "",
          "--layer-dialog": "700",
          "--xg52i5g": "",
          "--x10845vo": "",
          "--xhfmm6c": "",
          "--sx-1k7nh0l": "#fffaa6",
          "--x1k7v50d": "",
          "--editor-block-menu-offset": "28px",
          "--speed-regularTransition": "0.25s",
          "--x1stx5uy": "",
          "--x133wec9": "",
          "--x6zt3z6": "",
          "--sx-142jeir": "#28292e",
          "--cursor-pointer": "pointer",
          "--editor-safe-area": "16px",
          "--x1q6smeb": "",
          "--ease-in-out-quad": "cubic-bezier(0.455,0.03,0.515,0.955)",
          "--icon-grayscale-image-filter": "grayscale(100%) brightness(400%)",
          "--x1a798ef": "6px",
          "--sx-1yxqotz": "#5e6ad2",
          "--xb9djef": "transparent",
          "--xfeitbp": "",
          "--x1vqca58": "",
          "--ease-in-expo": "cubic-bezier(0.95,0.05,0.795,0.035)",
          "--ease-in-cubic": "cubic-bezier(0.55,0.055,0.675,0.19)",
          "--x1ijrdvx": "",
          "--x1em7oyp": "",
          "--title-4": "590 2rem /1.125 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-17ckey5": "#ff5d5e",
          "--x1ospiv4": "",
          "--sx-74qs5": "#00000001",
          "--xc3gk8m": "",
          "--mask-ease": "rgba(0,0,0,0.2)",
          "--sx-14ggo8w": "#1e2823",
          "--title-3": "590 1.5rem /1.33 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x1ddj3ws": "",
          "--sx-7jk47a": "#2b2c2f",
          "--sx-1m4y240": "#19191b",
          "--sx-ljw4h1": "#303236",
          "--x629164": "",
          "--header-height": "72px",
          "--x14ggo8w": "",
          "--sx-18pfyxa": "6px 12px",
          "--editor-todolist-checkbox-width": "14px",
          "--x1g0wh59": "transparent",
          "--sx-1urpf9d": "#ffffff0d",
          "--xor1tl7": "",
          "--sx-1stx5uy": "#74e3ff",
          "--sx-7ide1": "#747ee9",
          "--x142jeir": "",
          "--x1uoekal": "",
          "--ease-out-quad": "cubic-bezier(0.25,0.46,0.45,0.94)",
          "--sx-138rywl": "13vh",
          "--x10lzhmx": "",
          "--sx-sfnrch": "#f0bf00",
          "--sx-1ltkoa": "#626467",
          "--xpi45vo": "transparent",
          "--sx-1dcvabv": "#332024",
          "--x193njt9": "",
          "--sx-91u3ar": "#ffcc00",
          "--sx-18uyzu6": "#008a2a",
          "--sx-ot17o6": "#00cee2",
          "--sx-1gm0lru": "#282a30",
          "--sx-34xdpc": "#d9343f",
          "--sx-1gxylln": "#232528",
          "--ease-out-quart": "cubic-bezier(0.165,0.84,0.44,1)",
          "--sx-1ccqs4f": "#3f4145",
          "--xugsh4": "",
          "--x3zwjav": "",
          "--sx-feitbp": "#ffffff",
          "--layer-debug": "5100",
          "--sx-fwc8so": "#cf4608",
          "--ease-in-circ": "cubic-bezier(0.6,0.04,0.98,0.335)",
          "--sx-13sdql6": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--x1eapsa9": "",
          "--x1uv3w6h": "",
          "--sx-1vqca58": "#69daff",
          "--xd29rh7": "",
          "--sx-1fphd1n": "#232427",
          "--ease-in-out-cubic": "cubic-bezier(0.645,0.045,0.355,1)",
          "--ease-in-quart": "cubic-bezier(0.895,0.03,0.685,0.22)",
          "--sx-5igtf4": "#ffffff0d",
          "--page-inset": "32px",
          "--x34xdpc": "",
          "--sx-as9fd0": "#282a30",
          "--sx-ugsh4": "#ffd500",
          "--ease-in-out-quint": "cubic-bezier(0.86,0,0.07,1)",
          "--editor-bullet-disc-width": "0.5em",
          "--x17ckey5": "",
          "--x19hxmp1": "",
          "--sx-1glqxor": "#232535",
          "--sx-n8xqcl": "#5e69d1",
          "--sx-w1p5jj": "#37393e",
          "--layer-command-menu": "650",
          "--ease-in-out-expo": "cubic-bezier(1,0,0,1)",
          "--sx-1k7v50d": "0 4px 40px #00000019, 0 3px 20px #0000001f,0 3px 12px #0000001f, 0 2px 8px #0000001f, 0 1px 1px #0000001f",
          "--x138rywl": "13vh",
          "--sx-1ospiv4": "#ffffff14",
          "--x13m9wh7": "",
          "--layer-dialog-overlay": "699",
          "--xjupg42": "",
          "--xpqiwo2": "",
          "--x1jpq86z": "transparent",
          "--sx-1jffjrl": "#6a76e3",
          "--layer-footer": "50",
          "--sx-cb0zzs": "#35373d",
          "--sx-ch85qk": "#5e69d1",
          "--sx-1ubxoo9": "#1e2022",
          "--x1ccqs4f": "",
          "--x18uyzu6": "",
          "--sx-wsz0k3": "#26a544",
          "--sx-1qlh175": "#00889c",
          "--xch85qk": "",
          "--sx-193njt9": "#ffffff22",
          "--x1dd5bcf": "",
          "--layer-scrollbar": "75",
          "--sx-1dhg814": "0 3px 8px #0000001f, 0 2px 5px #0000001f, 0 1px 1px #0000001f",
          "--sx-629164": "#2b2c2f",
          "--sx-1dd5bcf": "#9c9da1",
          "--sx-1uoekal": "#00b8cb",
          "--cursor-tooltip": "help",
          "--x1rsaf4u": "",
          "--sx-1uztw8p": "#ffffff30",
          "--x1k7nh0l": "",
          "--xv3o8qy": "",
          "--xys2i3t": "",
          "--pointer": "default",
          "--x1rwcria": "",
          "--title-2": "590 1.25rem /1.33 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--sx-1ikf7kw": "#ffffff22",
          "--x6ayg1n": "",
          "--x1o1lnwn": "",
          "--sx-1gakdvt": "#25283f",
          "--underline-offset": "clamp(2px,0.225em,6px)",
          "--x1fh23cp": "",
          "--x15wwovl": "",
          "--xmsgncm": "",
          "--page-max-width": "1024px",
          "--sx-129bhjt": "#967000",
          "--sx-1ipkkxf": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",\"Linear Thai\",sans-serif",
          "--x1uztw8p": "",
          "--ease-in-quad": "cubic-bezier(0.55,0.085,0.68,0.53)",
          "--x1jmjcvw": "",
          "--title-9": "590 4.5rem /1 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--layer-overlay": "500",
          "--sx-180qi0f": "#d5ffd6",
          "--xj1ai0m": "",
          "--sx-irmyh9": "#ffffff13",
          "--sx-11lpf43": "0.8125rem",
          "--layer-header": "100",
          "--grid-columns": "12",
          "--x138kmyo": "",
          "--x13sdql6": "\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Segoe UI\",\"Twemoji Mozilla\",\"Noto Color Emoji\",\"Android Emoji\"",
          "--x1dcvabv": "",
          "--x180qi0f": "",
          "--sx-19hxmp1": "#adbaff",
          "--sx-1bu05id": "#ff8583",
          "--sx-1o1lnwn": "#28292e",
          "--layer-toasts": "800",
          "--sx-1gcjx5j": "#2d2f37",
          "--x183dfpr": "",
          "--sx-1em7oyp": "#1b263a",
          "--xcb0zzs": "",
          "--sx-11vg3qk": "#ff7235",
          "--x1uu732i": "12px",
          "--x9o00jb": "",
          "--sx-i20l48": "#f34e52",
          "--sx-1edn6di": "#2f3034",
          "--xkig6sr": "",
          "--sx-j1ai0m": "#e4e5e9",
          "--x1qlh175": "",
          "--xhsrmg4": "",
          "--x1rzu7x2": "",
          "--xfwc8so": "",
          "--ximi5ey": "",
          "--xljw4h1": "",
          "--sx-ickszr": "#fefeff",
          "--sx-1hz3utq": "#ff8042",
          "--layer-3": "3",
          "--ease-out-cubic": "cubic-bezier(0.215,0.61,0.355,1)",
          "--title-8": "590 4rem /1.06 \"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",sans-serif",
          "--x18pfyxa": "6px 12px",
          "--sx-10845vo": "#c9ffff",
          "--sx-axo4ug": "0 0 0 0.5px #28292e",
          "--xay0skx": "",
          "--x1ipkkxf": "\"Inter Variable\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",\"Linear Thai\",sans-serif",
          "--sx-10o0rs5": "#e4e5e9",
          "--sx-1ps2i54": "#1b282d",
          "--layer-skip-nav": "5000",
          "--x1ubxoo9": "",
          "--xikq9iy": "",
          "--sx-1umwnkk": "\"Berkeley Mono\",\"SFMono Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace",
          "--x1n1r1h9": "",
          "--sx-1jmjcvw": "#ffffff0d",
          "--x1xaoi8i": "",
          "--x1bu05id": "",
          "--sx-105wzx7": "#edbf0a",
          "--x1dhg814": "",
          "--sx-1uu732i": "12px",
          "--sx-msgncm": "#292521",
          "--sx-hfmm6c": "#2d2e31",
          "--layer-1": "1",
          "--underline-thickness": "from-font",
          "--radix-select-content-available-height": "none",
          "--x1vyp3gc": "",
          "--sx-1eapsa9": "#626366",
          "--xjrz3l0": "transparent",
          "--editor-list-inset": "1.5rem",
          "--xsfnrch": "",
          "--sx-1ele6il": "1px",
          "--x6od1kq": "",
          "--xws85c5": "",
          "--100dvh": "calc(100 * 1dvh)",
          "--sx-x8afrf": "6px",
          "--x5t1vcl": "",
          "--x11vg3qk": "",
          "--radix-select-trigger-width": "0px",
          "--sx-ciqj87": "#3de261",
          "--sx-bpgheo": "#636fd7"
        },
        "meta": {
          "extractedAt": "2026-05-08T20:53:50.545Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "body font \"Inter Variable\" not on Google Fonts — fallback to sans-serif",
      "mono font \"Berkeley Mono\" not on Google Fonts — fallback to monospace"
    ]
  },
  {
    "slug": "payloadcms",
    "name": "Payload",
    "source": "https://payloadcms.com",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "Untitled Sans",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Geist Mono",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Geist+Mono:wght@100..900&display=swap",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 100%)",
          "foreground": "hsl(0, 0%, 0%)",
          "primary": "hsl(197, 100%, 7%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(197, 53%, 93%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "border": "hsla(0, 0%, 100%, 0.13)"
        },
        "allVars": {
          "--color-primary": "#001923",
          "--color-secondary": "#e5f2f7",
          "--color-neutral-50": "#ffffff",
          "--color-neutral-100": "#000000",
          "--color-neutral-200": "#ebebeb",
          "--color-neutral-300": "#808080",
          "--color-neutral-400": "#d0d0d0",
          "--color-neutral-500": "#141414",
          "--color-bg": "#ffffff",
          "--color-bg-1": "#001923",
          "--color-bg-2": "#000000",
          "--color-bg-3": "#141414",
          "--color-text": "#000000",
          "--color-text-1": "#ffffff",
          "--color-text-2": "#e5f2f7",
          "--color-text-3": "#ebebeb",
          "--color-text-4": "#d0d0d0",
          "--font-sans": "'untitledSans', sans-serif",
          "--font-body": "'monospace', sans-serif",
          "--font-size-64": "64px",
          "--font-size-48": "48px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-22": "22px",
          "--font-size-16": "16px",
          "--font-size-15": "15px",
          "--font-size-14": "14px",
          "--font-size-12": "12px",
          "--spacing-1": "1px",
          "--spacing-29": "29px",
          "--spacing-39": "39px",
          "--spacing-48": "48px",
          "--spacing-56": "56px",
          "--spacing-64": "64px",
          "--spacing-72": "72px",
          "--spacing-97": "97px",
          "--spacing-120": "120px",
          "--radius-sm": "3px",
          "--radius-md": "8px",
          "--radius-full": "100px",
          "--shadow-xs": "rgb(205, 205, 230) 0px -2px 0px 0px inset, rgb(255, 255, 255) 0px 0px 1px 1px inset, rgba(30, 35, 90, 0.4) 0px 1px 2px 1px",
          "--shadow-sm": "rgba(0, 0, 0, 0.5) 0px 0px 4px 0px",
          "--shadow-xl": "rgba(0, 0, 0, 0.5) 0px 48px 64px 16px",
          "--color-purple-200": "rgb(252,214,252)",
          "--color-base-500": "rgb(128,128,128)",
          "--color-success-650": "rgb(0,89,122)",
          "--theme-blue-bg": "rgba(209,229,239,1)",
          "--color-blue-700": "rgb(0,76,104)",
          "--color-purple-800": "rgb(99,61,99)",
          "--color-warning-550": "rgb(220,155,71)",
          "--color-blue-150": "rgb(178,217,231)",
          "--color-blue-300": "rgb(102,178,206)",
          "--color-error-550": "rgb(229,122,100)",
          "--color-purple-850": "rgb(74,46,74)",
          "--color-success-950": "rgb(0,13,17)",
          "--theme-bg": "rgb(255,255,255)",
          "--color-orange-border-light": "rgba(244,172,79,1)",
          "--color-blue-bg-light": "rgba(209,229,239,1)",
          "--color-base-200": "rgb(208,208,208)",
          "--color-blue-400": "rgb(51,153,190)",
          "--highlight-danger-text-color": "",
          "--color-base-900": "rgb(20,20,20)",
          "--docsearch-hit-active-color": "#fff",
          "--color-success-250": "rgb(128,191,215)",
          "--color-orange-bg-light": "rgba(255,235,194,1)",
          "--color-purple-600": "rgb(198,122,198)",
          "--color-base-700": "rgb(74,74,74)",
          "--color-red-text-light": "rgba(102,17,0,1)",
          "--color-purple-550": "rgb(222,138,222)",
          "--color-purple-350": "rgb(249,184,249)",
          "--color-purple-650": "rgb(173,107,173)",
          "--color-warning-850": "rgb(73,52,24)",
          "--color-base-0": "rgb(255,255,255)",
          "--color-error-150": "rgb(255,219,212)",
          "--color-success-850": "rgb(0,38,52)",
          "--color-red-bg-light": "rgba(255,195,183,1)",
          "--color-success-350": "rgb(77,165,198)",
          "--color-blue-bg-dark": "rgba(17,28,34,1)",
          "--color-error-250": "rgb(255,195,183)",
          "--color-blue-800": "rgb(0,51,70)",
          "--color-warning-50": "rgb(254,247,237)",
          "--color-error-50": "rgb(255,243,241)",
          "--color-error-600": "rgb(204,108,89)",
          "--color-error-750": "rgb(128,68,56)",
          "--highlight-info-bg-color": "rgb(235,235,235)",
          "--color-blue-100": "rgb(229,242,247)",
          "--color-blue-border-dark": "rgba(0,127,174,1)",
          "--color-warning-900": "rgb(49,34,16)",
          "--color-purple-750": "rgb(124,77,124)",
          "--color-success-300": "rgb(102,178,206)",
          "--color-orange-text-dark": "rgba(255,225,164,1)",
          "--color-warning-950": "rgb(24,17,8)",
          "--docsearch-primary-color": "#5468ff",
          "--color-error-850": "rgb(77,41,33)",
          "--color-base-600": "rgb(101,101,101)",
          "--color-purple-250": "rgb(251,204,251)",
          "--color-blue-border-light": "rgba(0,127,174,1)",
          "--color-success-500": "rgb(0,127,174)",
          "--theme-orange-bg": "rgba(255,235,194,1)",
          "--color-error-900": "rgb(51,27,22)",
          "--highlight-info-text-color": "rgb(34,34,34)",
          "--color-red-bg-dark": "rgba(51,27,22,1)",
          "--color-success-750": "rgb(0,64,87)",
          "--color-base-550": "rgb(114,114,114)",
          "--color-base-450": "rgb(141,141,141)",
          "--color-purple-400": "rgb(249,173,249)",
          "--color-blue-600": "rgb(0,102,139)",
          "--color-success-700": "rgb(0,76,104)",
          "--color-blue-350": "rgb(77,165,198)",
          "--color-base-800": "rgb(47,47,47)",
          "--color-warning-150": "rgb(252,230,202)",
          "--color-blue-50": "rgb(229,242,247)",
          "--color-base-950": "rgb(7,7,7)",
          "--color-success-450": "rgb(26,140,182)",
          "--theme-red-border": "rgba(255,135,111,1)",
          "--color-base-850": "rgb(34,34,34)",
          "--color-blue-650": "rgb(0,89,122)",
          "--color-error-800": "rgb(102,54,44)",
          "--color-warning-500": "rgb(244,172,79)",
          "--color-warning-400": "rgb(246,189,114)",
          "--color-blue-text-light": "rgba(26,57,85,1)",
          "--docsearch-highlight-color": "#5468ff",
          "--color-purple-500": "rgb(247,153,247)",
          "--color-purple-450": "rgb(248,163,248)",
          "--color-orange-border-dark": "rgba(244,172,79,1)",
          "--color-error-400": "rgb(255,159,140)",
          "--color-purple-150": "rgb(253,224,253)",
          "--color-base-350": "rgb(168,168,168)",
          "--color-error-200": "rgb(255,207,197)",
          "--default-border-width": "2px",
          "--color-success-150": "rgb(178,217,231)",
          "--color-warning-450": "rgb(245,181,96)",
          "--color-base-50": "rgb(245,245,245)",
          "--color-base-300": "rgb(181,181,181)",
          "--color-purple-900": "rgb(49,31,49)",
          "--color-orange-bg-dark": "rgba(51,45,33,1)",
          "--color-purple-100": "rgb(253,235,253)",
          "--color-warning-250": "rgb(249,214,167)",
          "--color-error-300": "rgb(255,183,169)",
          "--color-success-800": "rgb(0,51,70)",
          "--color-purple-950": "rgb(25,15,25)",
          "--theme-blue-border": "rgba(0,127,174,1)",
          "--color-orange-text-light": "rgba(51,45,33,1)",
          "--color-base-250": "rgb(195,195,195)",
          "--color-red-border-light": "rgba(255,135,111,1)",
          "--color-red-text-dark": "rgba(255,213,204,1)",
          "--theme-input-bg": "#efefef",
          "--color-base-150": "rgb(221,221,221)",
          "--color-blue-750": "rgb(0,64,87)",
          "--color-error-700": "rgb(153,81,67)",
          "--highlight-warning-bg-color": "rgb(246,189,114)",
          "--docsearch-hit-color": "#444950",
          "--color-success-50": "rgb(229,242,247)",
          "--color-success-200": "rgb(153,204,223)",
          "--color-blue-450": "rgb(26,140,182)",
          "--color-success-400": "rgb(51,153,190)",
          "--color-blue-text-dark": "rgba(217,234,242,1)",
          "--color-blue-250": "rgb(128,191,215)",
          "--color-warning-800": "rgb(98,69,32)",
          "--color-error-100": "rgb(255,231,226)",
          "--highlight-success-bg-color": "rgb(51,153,190)",
          "--color-error-350": "rgb(255,171,154)",
          "--color-error-650": "rgb(178,95,78)",
          "--color-blue-850": "rgb(0,38,52)",
          "--color-success-100": "rgb(229,242,247)",
          "--color-red-border-dark": "rgba(255,135,111,1)",
          "--color-success-550": "rgb(0,114,157)",
          "--color-base-400": "rgb(154,154,154)",
          "--color-warning-750": "rgb(122,86,39)",
          "--color-warning-200": "rgb(251,222,185)",
          "--theme-red-bg": "rgba(255,195,183,1)",
          "--highlight-warning-text-color": "rgb(73,52,24)",
          "--theme-orange-border": "rgba(244,172,79,1)",
          "--color-warning-600": "rgb(195,138,63)",
          "--highlight-danger-bg-color": "rgb(255,219,212)",
          "--color-base-750": "rgb(60,60,60)",
          "--color-blue-500": "rgb(0,127,174)",
          "--color-error-500": "rgb(255,135,111)",
          "--color-blue-900": "rgb(0,25,35)",
          "--docsearch-logo-color": "#5468ff",
          "--color-error-950": "rgb(26,14,11)",
          "--color-warning-300": "rgb(248,205,149)",
          "--color-purple-50": "rgb(254,245,254)",
          "--color-blue-550": "rgb(0,114,157)",
          "--color-warning-650": "rgb(171,121,55)",
          "--color-warning-100": "rgb(253,238,220)",
          "--color-base-650": "rgb(87,87,87)",
          "--docsearch-text-color": "#1c1e21",
          "--color-blue-200": "rgb(153,204,223)",
          "--color-warning-700": "rgb(146,103,47)",
          "--color-error-450": "rgb(255,147,125)",
          "--theme-border-color": "rgba(0,0,0,0.125)",
          "--highlight-success-text-color": "rgb(0,38,52)",
          "--color-purple-700": "rgb(148,92,148)",
          "--color-success-900": "rgb(0,25,35)",
          "--color-success-600": "rgb(0,102,139)",
          "--docsearch-muted-color": "#969faf",
          "--color-warning-350": "rgb(247,197,132)",
          "--color-blue-950": "rgb(0,13,17)",
          "--color-base-1000": "rgb(0,0,0)",
          "--color-base-100": "rgb(235,235,235)",
          "--color-purple-300": "rgb(250,194,250)",
          "--docsearch-spacing": "12px",
          "--font-body-size": "16px",
          "--block-spacing": "5rem",
          "--page-padding-top": "calc(76px + 3rem)",
          "--new-block-spacing": "6rem",
          "--theme-blue-text": "rgba(26,57,85,1)",
          "--theme-red-text": "rgba(102,17,0,1)",
          "--theme-text-success": "rgb(0,89,122)",
          "--text-light": "rgba(0,0,0,0.5)",
          "--text-dark": "rgba(255,255,255,0.5)",
          "--theme-text": "rgb(0,0,0)",
          "--theme-orange-text": "rgba(51,45,33,1)",
          "--docsearch-modal-shadow": "inset 1px 1px 0 0 hsla(0,0%,100%,.5),0 3px 8px 0 #555a64",
          "--docsearch-key-pressed-shadow": "inset 0 -2px 0 0 #cdcde6,inset 0 0 1px 1px #fff,0 1px 1px 0 rgba(30,35,90,.4)",
          "--docsearch-hit-shadow": "0 1px 3px 0 #d4d9e1",
          "--docsearch-footer-shadow": "0 -1px 0 0 #e0e3e8,0 -3px 6px 0 rgba(69,98,155,.12)",
          "--docsearch-searchbox-shadow": "inset 0 0 0 2px #5468ff",
          "--docsearch-key-shadow": "inset 0 -2px 0 0 #cdcde6,inset 0 0 1px 1px #fff,0 1px 2px 1px rgba(30,35,90,.4)",
          "--theme-success-400": "rgb(51,153,190)",
          "--header-height": "76px",
          "--theme-purple-200": "rgb(252,214,252)",
          "--theme-elevation-1000": "rgb(0,0,0)",
          "--theme-elevation-800": "rgb(47,47,47)",
          "--z-popup": "10",
          "--theme-warning-900": "rgb(49,34,16)",
          "--theme-elevation-600": "rgb(101,101,101)",
          "--docsearch-icon-stroke-width": "1.4",
          "--theme-purple-50": "rgb(254,245,254)",
          "--docsearch-footer-background": "#fff",
          "--theme-blue-700": "rgb(0,76,104)",
          "--docsearch-hit-height": "56px",
          "--theme-blue-800": "rgb(0,51,70)",
          "--docsearch-modal-height": "600px",
          "--theme-elevation-650": "rgb(87,87,87)",
          "--theme-blue-500": "rgb(0,127,174)",
          "--theme-warning-700": "rgb(146,103,47)",
          "--breakpoint-mp-width": "$breakpoint-mp-width",
          "--theme-purple-800": "rgb(99,61,99)",
          "--theme-warning-150": "rgb(252,230,202)",
          "--theme-success-650": "rgb(0,89,122)",
          "--theme-purple-450": "rgb(248,163,248)",
          "--theme-purple-850": "rgb(74,46,74)",
          "--theme-error-950": "rgb(26,14,11)",
          "--theme-blue-950": "rgb(0,13,17)",
          "--theme-purple-750": "rgb(124,77,124)",
          "--theme-purple-500": "rgb(247,153,247)",
          "--z-modal": "50",
          "--theme-blue-600": "rgb(0,102,139)",
          "--theme-error-600": "rgb(204,108,89)",
          "--theme-elevation-300": "rgb(181,181,181)",
          "--theme-error-500": "rgb(255,135,111)",
          "--grid-line-light": "rgba(0,0,0,0.125)",
          "--breakpoint-m-width": "$breakpoint-m-width",
          "--docsearch-searchbox-focus-background": "#fff",
          "--theme-purple-600": "rgb(198,122,198)",
          "--docsearch-hit-background": "#fff",
          "--theme-blue-650": "rgb(0,89,122)",
          "--theme-elevation-0": "rgb(255,255,255)",
          "--theme-success-350": "rgb(77,165,198)",
          "--vw": "14.4px",
          "--theme-elevation-350": "rgb(168,168,168)",
          "--theme-elevation-400": "rgb(154,154,154)",
          "--column": "calc((100vw - (4rem * 2)) / 16)",
          "--theme-purple-250": "rgb(251,204,251)",
          "--theme-elevation-950": "rgb(7,7,7)",
          "--theme-elevation-150": "rgb(221,221,221)",
          "--breakpoint-l-width": "$breakpoint-l-width",
          "--theme-blue-450": "rgb(26,140,182)",
          "--theme-purple-300": "rgb(250,194,250)",
          "--theme-error-50": "rgb(255,243,241)",
          "--theme-error-200": "rgb(255,207,197)",
          "--theme-blue-300": "rgb(102,178,206)",
          "--theme-warning-100": "rgb(253,238,220)",
          "--theme-error-750": "rgb(128,68,56)",
          "--theme-elevation-50": "rgb(245,245,245)",
          "--breakpoint-xl-width": "$breakpoint-xl-width",
          "--theme-success-300": "rgb(102,178,206)",
          "--theme-error-550": "rgb(229,122,100)",
          "--theme-warning-800": "rgb(98,69,32)",
          "--theme-success-150": "rgb(178,217,231)",
          "--theme-blue-350": "rgb(77,165,198)",
          "--theme-purple-150": "rgb(253,224,253)",
          "--breakpoint-xs-width": "$breakpoint-xs-width",
          "--docsearch-footer-height": "44px",
          "--theme-purple-350": "rgb(249,184,249)",
          "--z-status": "30",
          "--trans-default": "150ms",
          "--theme-warning-250": "rgb(249,214,167)",
          "--theme-warning-850": "rgb(73,52,24)",
          "--theme-success-50": "rgb(229,242,247)",
          "--theme-error-700": "rgb(153,81,67)",
          "--theme-success-800": "rgb(0,51,70)",
          "--theme-blue-750": "rgb(0,64,87)",
          "--theme-purple-400": "rgb(249,173,249)",
          "--theme-blue-150": "rgb(178,217,231)",
          "--theme-success-500": "rgb(0,127,174)",
          "--theme-warning-950": "rgb(24,17,8)",
          "--docsearch-container-background": "rgba(101,108,133,.8)",
          "--theme-elevation-850": "rgb(34,34,34)",
          "--breakpoint-mh-width": "$breakpoint-mh-width",
          "--theme-success-600": "rgb(0,102,139)",
          "--gutter-h": "4rem",
          "--scrollbar-width": "17px",
          "--breakpoint-l-height": "$breakpoint-l-height",
          "--theme-elevation-250": "rgb(195,195,195)",
          "--theme-purple-950": "rgb(25,15,25)",
          "--theme-error-300": "rgb(255,183,169)",
          "--theme-success-550": "rgb(0,114,157)",
          "--theme-error-250": "rgb(255,195,183)",
          "--breakpoint-2xl-width": "$breakpoint-2xl-width",
          "--theme-warning-450": "rgb(245,181,96)",
          "--theme-blue-900": "rgb(0,25,35)",
          "--theme-elevation-700": "rgb(74,74,74)",
          "--vh": "9px",
          "--top-bar-height": "3rem",
          "--theme-blue-850": "rgb(0,38,52)",
          "--theme-purple-100": "rgb(253,235,253)",
          "--theme-warning-200": "rgb(251,222,185)",
          "--theme-success-700": "rgb(0,76,104)",
          "--theme-elevation-750": "rgb(60,60,60)",
          "--theme-elevation-500": "rgb(128,128,128)",
          "--theme-warning-550": "rgb(220,155,71)",
          "--theme-blue-200": "rgb(153,204,223)",
          "--theme-warning-600": "rgb(195,138,63)",
          "--theme-error-400": "rgb(255,159,140)",
          "--theme-success-850": "rgb(0,38,52)",
          "--z-nav": "40",
          "--docsearch-modal-width": "560px",
          "--theme-purple-900": "rgb(49,31,49)",
          "--theme-elevation-450": "rgb(141,141,141)",
          "--theme-success-750": "rgb(0,64,87)",
          "--docsearch-searchbox-background": "#ebedf0",
          "--docsearch-modal-background": "#f5f6f7",
          "--theme-warning-400": "rgb(246,189,114)",
          "--theme-success-100": "rgb(229,242,247)",
          "--theme-warning-750": "rgb(122,86,39)",
          "--base": "16px",
          "--theme-success-250": "rgb(128,191,215)",
          "--theme-error-100": "rgb(255,231,226)",
          "--theme-purple-650": "rgb(173,107,173)",
          "--theme-blue-100": "rgb(229,242,247)",
          "--theme-warning-350": "rgb(247,197,132)",
          "--theme-error-850": "rgb(77,41,33)",
          "--theme-purple-700": "rgb(148,92,148)",
          "--theme-error-800": "rgb(102,54,44)",
          "--theme-success-900": "rgb(0,25,35)",
          "--theme-success-200": "rgb(153,204,223)",
          "--breakpoint-s-width": "$breakpoint-s-width",
          "--theme-success-950": "rgb(0,13,17)",
          "--theme-warning-500": "rgb(244,172,79)",
          "--theme-warning-50": "rgb(254,247,237)",
          "--theme-elevation-200": "rgb(208,208,208)",
          "--theme-error-900": "rgb(51,27,22)",
          "--theme-warning-650": "rgb(171,121,55)",
          "--theme-blue-250": "rgb(128,191,215)",
          "--theme-elevation-900": "rgb(20,20,20)",
          "--theme-error-150": "rgb(255,219,212)",
          "--theme-warning-300": "rgb(248,205,149)",
          "--docsearch-key-gradient": "linear-gradient(-225deg,#d5dbe4,#f8f8f8)",
          "--theme-purple-550": "rgb(222,138,222)",
          "--theme-elevation-100": "rgb(235,235,235)",
          "--docsearch-searchbox-height": "56px",
          "--theme-blue-400": "rgb(51,153,190)",
          "--theme-error-450": "rgb(255,147,125)",
          "--theme-success-450": "rgb(26,140,182)",
          "--theme-error-650": "rgb(178,95,78)",
          "--theme-elevation-550": "rgb(114,114,114)",
          "--theme-blue-550": "rgb(0,114,157)",
          "--theme-blue-50": "rgb(229,242,247)",
          "--sticky-sidebar-top": "calc(76px + 1.25rem)",
          "--breakpoint-lm-width": "$breakpoint-lm-width",
          "--grid-line-dark": "rgba(255,255,255,0.125)",
          "--theme-error-350": "rgb(255,171,154)",
          "--rhythm-section": "8rem",
          "--rhythm-subsection": "4rem",
          "--rhythm-heading-to-body": "2rem",
          "--stack-heading-size": "64px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "64px",
          "--stack-heading-tracking": "-3.2px",
          "--stack-body-size": "16px",
          "--stack-body-weight": "400",
          "--stack-body-line-height": "22.4px",
          "--eyebrow-size": "12px",
          "--eyebrow-weight": "400",
          "--eyebrow-tracking": "3px",
          "--eyebrow-transform": "uppercase"
        },
        "meta": {
          "extractedAt": "2026-05-08T22:33:41.992Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "body font \"Untitled Sans\" not on Google Fonts — fallback to sans-serif"
    ]
  },
  {
    "slug": "raycast",
    "name": "Raycast",
    "source": "https://raycast.com",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "Inter",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Geist Mono",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Geist+Mono:wght@100..900&display=swap",
        "fallback": "monospace"
      }
    },
    "modes": {
      "dark": {
        "colors": {
          "background": "hsl(220, 18%, 3%)",
          "foreground": "hsl(0, 0%, 100%)",
          "primary": "hsl(0, 100%, 69%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(201, 100%, 77%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "accent": "hsl(202, 100%, 67%)",
          "accent-foreground": "hsl(0, 0%, 0%)",
          "muted": "hsl(220, 8%, 7%)",
          "muted-foreground": "hsl(0, 0%, 100%)",
          "border": "hsla(0, 0%, 100%, 0.08)"
        },
        "allVars": {
          "--color-primary": "#ff6363",
          "--color-secondary": "#8cd6ff",
          "--color-accent": "#56c2ff",
          "--color-neutral-50": "#ffffff",
          "--color-neutral-100": "#6a6b6c",
          "--color-neutral-200": "#9c9c9d",
          "--color-neutral-300": "#434345",
          "--color-neutral-400": "#e6e6e6",
          "--color-neutral-500": "#2f3031",
          "--color-neutral-600": "#222222",
          "--color-neutral-700": "#8e8c90",
          "--color-neutral-800": "#111214",
          "--color-bg": "#07080a",
          "--color-bg-1": "#000000",
          "--color-bg-2": "#ffffff",
          "--color-bg-3": "#9ebed7",
          "--color-bg-4": "#111214",
          "--color-bg-5": "#d72a2a",
          "--color-text": "#ffffff",
          "--color-text-1": "#9c9c9d",
          "--color-text-2": "#2f3031",
          "--color-text-3": "#6a6b6c",
          "--color-text-4": "#e6e6e6",
          "--font-sans": "'Inter', sans-serif",
          "--font-body": "'GeistMono', sans-serif",
          "--font-size-64": "64px",
          "--font-size-56": "56px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-22": "22px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--spacing-1": "8px",
          "--spacing-45": "45px",
          "--spacing-56": "56px",
          "--spacing-64": "64px",
          "--spacing-72": "72px",
          "--spacing-80": "80px",
          "--spacing-96": "96px",
          "--spacing-102": "102px",
          "--spacing-120": "120px",
          "--spacing-128": "128px",
          "--spacing-137": "137px",
          "--spacing-148": "148px",
          "--spacing-169": "169px",
          "--spacing-200": "200px",
          "--spacing-212": "212px",
          "--spacing-217": "217px",
          "--spacing-224": "224px",
          "--spacing-325": "325px",
          "--spacing-370": "370px",
          "--spacing-400": "400px",
          "--radius-xs": "2px",
          "--radius-sm": "5px",
          "--radius-md": "6px",
          "--radius-lg": "16px",
          "--radius-xl": "22px",
          "--radius-full": "99999px",
          "--shadow-sm": "rgba(0, 0, 0, 0.25) 0px 4px 4px 0px",
          "--shadow-xs": "rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(154, 170, 255, 0.05) 0px 2px 40px 10px, rgba(154, 170, 255, 0.05) 0px 0px 16px -7px",
          "--shadow-md": "rgba(0, 0, 0, 0.11) 0px -4px 10px 0px",
          "--shadow-lg": "rgba(215, 201, 175, 0.05) 0px 0px 20px 5px, rgba(215, 201, 175, 0.05) 0px 0px 16px -7px",
          "--shadow-xl": "rgba(215, 42, 42, 0.05) -72px -50px 40px -60px",
          "--color-blue-transparent": "hsla(202,100%,67%,0.15)",
          "--key-bg-end-color": "rgb(13, 13, 13)",
          "--key-bg-start-color": "rgb(18, 18, 18)",
          "--color-bg-100": "rgb(16,17,17)",
          "--color-button-fg": "rgb(24,25,26)",
          "--color-yellow": "hsl(43,100%,60%)",
          "--font-color-rgb": "255,255,255",
          "--reverse-font-color-rgb": "0,0,0",
          "--spring-1": "linear(0.000000 0%,0.005927 1%,0.022466 2%,0.047872 3%,0.080554 4%,0.119068 5%,0.162116 6%,0.208536 7.000000000000001%,0.2573 8%,0.3075 9%,0.358346 10%,0.409157 11%,0.45935 12%,0.508438 13%,0.556014 14.000000000000002%,0.601751 15%,0.645389 16%,0.686733 17%,0.72564 18%,0.762019 19%,0.795818 20%,0.827026 21%,0.855662 22%,0.881772 23%,0.905423 24%,0.926704 25%,0.945714 26%,0.962568 27%,0.977386 28.000000000000004%,0.990295 28.999999999999996%,1.001426 30%,1.010911 31%,1.018881 32%,1.025465 33%,1.030792 34%,1.034982 35%,1.038155 36%,1.040423 37%,1.041892 38%,1.042662 39%,1.042827 40%,1.042473 41%,1.04168 42%,1.040522 43%,1.039065 44%,1.037371 45%,1.035493 46%,1.03348 47%,1.031376 48%,1.029217 49%,1.027037 50%,1.024864 51%,1.022722 52%,1.020631 53%,1.018608 54%,1.016667 55.00000000000001%,1.014817 56.00000000000001%,1.013067 56.99999999999999%,1.011422 57.99999999999999%,1.009887 59%,1.008462 60%,1.007148 61%,1.005944 62%,1.004847 63%,1.003855 64%,1.002964 65%,1.002169 66%,1.001466 67%,1.000848 68%,1.000311 69%,0.999849 70%,0.999457 71%,0.999128 72%,0.998858 73%,0.99864 74%,0.99847 75%,0.998342 76%,0.998253 77%,0.998196 78%,0.998169 79%,0.998167 80%,0.998186 81%,0.998224 82%,0.998276 83%,0.998341 84%,0.998415 85%,0.998497 86%,0.998584 87%,0.998675 88%,0.998768 89%,0.998861 90%,0.998954 91%,0.999045 92%,0.999134 93%,0.99922 94%,0.999303 95%,0.999381 96%,0.999455 97%,0.999525 98%,0.999589 99%,0.99965 100%)",
          "--lines-color-rgb": "255,255,255",
          "--color-fg-300": "#78787c",
          "--color-button-bg-hover": "hsl(0,0%,100%)",
          "--color-button-bg": "hsla(0,0%,100%,0.815)",
          "--color-border": "hsl(195,5%,15%)",
          "--color-red": "hsl(0,100%,69%)",
          "--color-bg-400": "rgb(73,75,77)",
          "--color-green": "hsl(151,59%,59%)",
          "--color-blue": "hsl(202,100%,67%)",
          "--color-fg": "hsl(240,11%,96%)",
          "--color-red-transparent": "hsla(0,100%,69%,0.15)",
          "--color-green-transparent": "hsla(151,59%,59%,0.15)",
          "--color-yellow-transparent": "hsla(43,100%,60%,0.15)",
          "--color-fg-400": "rgb(94,99,102)",
          "--color-bg-200": "rgb(24,25,26)",
          "--color-fg-200": "rgb(194,199,202)",
          "--color-bg-300": "rgb(49,49,51)",
          "--spacing-4": "32px",
          "--spacing-9": "80px",
          "--spacing-13": "224px",
          "--spacing-6": "48px",
          "--spacing-1-5": "12px",
          "--spacing-12": "168px",
          "--removed-body-scroll-bar-size": "0px",
          "--grid-gap": "32px",
          "--spacing-8": "64px",
          "--spacing-none": "0px",
          "--spacing-2": "16px",
          "--navbar-total-spacing": "calc(76px + (2 * 16px))",
          "--monospace-font": "\"JetBrains Mono\",\"JetBrains Mono Fallback\",Menlo,Monaco,Courier,monospace",
          "--spacing-3": "24px",
          "--spacing-11": "112px",
          "--navbar-container-padding-top": "16px",
          "--spacing-5": "40px",
          "--spacing-7": "56px",
          "--spacing-10": "96px",
          "--spacing-0-5": "4px",
          "--spacing-2-5": "20px",
          "--main-font": "\"Inter\",\"Inter Fallback\",sans-serif",
          "--font-jetbrains-mono": "\"JetBrains Mono\",\"JetBrains Mono Fallback\"",
          "--font-geist-mono": "\"GeistMono\",ui-monospace,SFMono-Regular,Roboto Mono,Menlo,Monaco,Liberation Mono,DejaVu Sans Mono,Courier New,monospace",
          "--font-inter": "\"Inter\",\"Inter Fallback\"",
          "--rounding-lg": "16px",
          "--container-xs-width": "746px",
          "--rounding-xl": "20px",
          "--rounding-normal": "8px",
          "--grey-900": "#07080a",
          "--grey-400": "#434345",
          "--grey-200": "#9c9c9d",
          "--background": "#07080a",
          "--reverse-background": "#ffffff",
          "--rounding-xs": "4px",
          "--grey-50": "#e6e6e6",
          "--r2": "0deg",
          "--navbar-height": "76px",
          "--Base-Black": "#000000",
          "--container-sm-width": "1064px",
          "--rounding-sm": "6px",
          "--grey-500": "#2f3031",
          "--rounding-none": "0px",
          "--grey-300": "#6a6b6c",
          "--rounding-md": "12px",
          "--rounding-full": "100%",
          "--red-dark": "rgba(255,99,99,1)",
          "--blue-dark": "#56c2ff",
          "--Base-White": "#ffffff",
          "--rounding-xxl": "24px",
          "--navbar-width": "1204px",
          "--grey-800": "#0c0d0f",
          "--grey-700": "#111214",
          "--x": "0px",
          "--container-lg-width": "1280px",
          "--container-width": "1204px",
          "--grey-100": "#cdcece",
          "--grey-600": "#1b1c1e",
          "--rhythm-section": "12rem",
          "--rhythm-subsection": "0.75rem",
          "--rhythm-body-to-cta": "3rem",
          "--stack-heading-size": "20px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "normal",
          "--stack-heading-tracking": "0.2px",
          "--stack-body-size": "20px",
          "--stack-body-weight": "500",
          "--stack-body-line-height": "normal",
          "--eyebrow-size": "16px",
          "--eyebrow-weight": "400",
          "--eyebrow-color": "rgb(255, 255, 255)"
        },
        "meta": {
          "extractedAt": "2026-05-08T22:37:46.595Z"
        }
      }
    },
    "defaultMode": "dark"
  },
  {
    "slug": "stripe",
    "name": "Stripe",
    "source": "https://stripe.com",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "Söhne",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Source Code Pro",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@200..900&display=swap",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 100%)",
          "foreground": "hsl(0, 0%, 0%)",
          "primary": "hsl(248, 98%, 61%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(237, 100%, 95%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "accent": "hsl(20, 100%, 91%)",
          "accent-foreground": "hsl(0, 0%, 0%)",
          "muted": "hsl(0, 0%, 83%)",
          "muted-foreground": "hsl(215, 27%, 32%)",
          "border": "hsl(210, 44%, 93%)"
        },
        "allVars": {
          "--color-primary": "#533afd",
          "--color-secondary": "#e8e9ff",
          "--color-accent": "#ffe0d1",
          "--color-neutral-50": "#000000",
          "--color-neutral-100": "#50617a",
          "--color-neutral-200": "#ffffff",
          "--color-neutral-300": "#64748d",
          "--color-neutral-400": "#f5f5f5",
          "--color-neutral-500": "#7d8ba4",
          "--color-neutral-600": "#171717",
          "--color-neutral-700": "#d8dee4",
          "--color-neutral-800": "#ffe6f5",
          "--color-neutral-900": "#707070",
          "--color-bg": "#ffffff",
          "--color-bg-1": "#e5edf5",
          "--color-bg-2": "#f8fafd",
          "--color-bg-3": "#302554",
          "--color-bg-4": "#5d0252",
          "--color-bg-5": "#fffafd",
          "--color-bg-6": "#0d1738",
          "--color-bg-7": "#122054",
          "--color-bg-8": "#004364",
          "--color-text": "#000000",
          "--color-text-1": "#533afd",
          "--color-text-2": "#061b31",
          "--color-text-3": "#ffffff",
          "--color-text-4": "#64748d",
          "--font-sans": "'sohne-var', sans-serif",
          "--font-body": "'monospace', sans-serif",
          "--font-size-56": "56px",
          "--font-size-48": "48px",
          "--font-size-32": "32px",
          "--font-size-26": "26px",
          "--font-size-24": "24px",
          "--font-size-22": "22px",
          "--font-size-21": "21px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-16": "16px",
          "--font-size-15": "15px",
          "--font-size-14": "14px",
          "--spacing-1": "1px",
          "--spacing-48": "48px",
          "--spacing-52": "52px",
          "--spacing-56": "56px",
          "--spacing-60": "60px",
          "--spacing-64": "64px",
          "--spacing-72": "72px",
          "--spacing-80": "80px",
          "--spacing-96": "96px",
          "--spacing-175": "175px",
          "--spacing-191": "191px",
          "--spacing-222": "222px",
          "--spacing-340": "340px",
          "--spacing-368": "368px",
          "--radius-xs": "1px",
          "--radius-sm": "4px",
          "--radius-md": "8px",
          "--radius-lg": "16px",
          "--radius-full": "100px",
          "--shadow-sm": "rgba(0, 0, 0, 0.1) 0px 2px 5px 0px",
          "--shadow-md": "rgba(0, 0, 0, 0.1) 0px 4px 8px 0px",
          "--shadow-lg": "rgba(0, 0, 0, 0.2) 0px 0px 32px 8px",
          "--shadow-xl": "rgba(0, 0, 0, 0.1) 0px 30px 60px -50px, rgba(50, 50, 93, 0.25) 0px 30px 60px -10px",
          "--hds-color-core-neutral-975": "#0d253d",
          "--hds-color-accent-border-solid": "#533afd",
          "--hds-color-accentColorMode-ruby-icon-solid": "#ea2261",
          "--hds-color-util-brand-900": "#1c1e54",
          "--hds-color-action-bg-subduedHover": "#b9b9f9",
          "--hds-color-input-text-label": "#273951",
          "--hds-color-accentColorMode-magenta-surface-subduedAlt": "#ffe6f5",
          "--hds-color-input-text-selected": "#273951",
          "--hds-color-input-text-popover": "#273951",
          "--hds-color-shadow-sm-top": "#00377014",
          "--hds-color-button-ui-iconHover": "#2e2b8c",
          "--hds-color-input-text-placeholder": "#7d8ba4",
          "--hds-color-core-brandDark-800A": "#4b31d080",
          "--hds-color-core-lemon-500": "#9b6829",
          "--hds-color-shadow-lg-top": "#0037701a",
          "--hds-color-util-bg-min": "#fff",
          "--hds-color-core-neutral-50A": "#a8c3de4d",
          "--hds-color-util-neutral-50": "#e5edf5",
          "--hds-color-input-selector-text-range": "#665efd",
          "--hds-color-accentColorMode-lemon-surface-subdued": "#fff2d8",
          "--hds-color-accentColorMode-magenta-icon-gradientMiddle": "#f96bee",
          "--hds-color-core-neutralDark-25": "#f2f7fe",
          "--hds-color-action-bg-translucent": "#ffffffa6",
          "--hds-color-util-accent-magenta-100": "#ffd7ef",
          "--hds-color-util-accent-orange-50": "#ffe5da",
          "--hds-color-input-icon-solidAlternate": "#533afd",
          "--hds-color-heading-subdued": "#64748d",
          "--hds-color-heading-solid": "#061b31",
          "--hds-color-accent-charm-bg": "#533afd",
          "--hds-color-util-bg-quiet": "#f8fafd",
          "--hds-color-button-secondary-textDisabled": "#95a4ba",
          "--hds-color-core-neutralDark-700": "#273f73",
          "--hds-color-action-text-onSolid": "#fff",
          "--hds-color-core-neutralDark-990": "#0d1738",
          "--hds-color-util-accent-lemon-200": "#f9b900",
          "--hds-color-input-tile-text-selected": "#533afd",
          "--hds-color-util-brand-200": "#b9b9f9",
          "--hds-color-action-border-solidHover": "#4032c8",
          "--hds-color-util-action-icon-soft": "#665efd",
          "--hds-color-accentColorMode-ruby-icon-gradientEnd": "#b51145",
          "--hds-color-util-brand-25": "#f5f5ff",
          "--hds-color-input-bg-default": "#ffffff40",
          "--hds-color-button-primary-bg": "#533afd",
          "--hds-color-accentColorMode-magenta-icon-gradientStart": "#f98bf9",
          "--hds-color-util-text-soft": "#50617a",
          "--hds-color-util-brand-800": "#2e2b8c",
          "--hds-color-input-selector-icon-disabledOnSolid": "#95a4ba",
          "--hds-color-action-bg-subdued": "#e2e4ff",
          "--hds-color-input-text-disabled": "#95a4ba",
          "--hds-color-util-neutral-950": "#11273e",
          "--hds-color-core-neutral-0": "#fff",
          "--hds-color-accent-surface-solid": "#533afd",
          "--hds-color-accentColorMode-magenta-surface-subdued": "#ffe6f5",
          "--hds-color-icon-error": "#d8351e",
          "--hds-color-util-action-bg-max": "#2e2b8c",
          "--hds-color-util-neutral-800": "#273951",
          "--hds-color-util-accent-orange-350": "#ff6118",
          "--hds-color-util-action-bg-emphasized": "#4032c8",
          "--hds-color-accentColorMode-default-icon-solidAlt": "#533afd",
          "--hds-color-util-neutral-700": "#3c4f69",
          "--hds-color-util-brand-300": "#9a9afe",
          "--hds-color-icon-success": "#00b261",
          "--hds-color-core-neutralDark-50": "#e3ecf7",
          "--hds-color-core-brand-400": "#7f7dfc",
          "--hds-space-input-border-default": "1.25px",
          "--hds-color-action-icon-onSubdued": "#533afd",
          "--hds-color-core-lemon-200": "#f9b900",
          "--hds-color-core-brandDark-200": "#a8bfff",
          "--hds-color-accentColorMode-orange-icon-solid": "#ff6118",
          "--hds-color-util-brand-600": "#533afd",
          "--hds-color-accentColorMode-orange-icon-gradientMiddle": "#fd6252",
          "--hds-color-core-ruby-500": "#e2225f",
          "--hds-color-core-neutralDark-400": "#839bc8",
          "--hds-color-button-primary-iconDisabled": "#95a4ba",
          "--hds-space-button-border": "1px",
          "--hds-color-util-neutral-990": "#061b31",
          "--hds-color-util-action-border-max": "#2e2b8c",
          "--hds-color-util-accent-ruby-400": "#ea2261",
          "--hds-color-input-popover-border": "#ffffff00",
          "--hds-color-util-action-icon-solid": "#533afd",
          "--hds-color-util-action-icon-subdued": "#b9b9f9",
          "--hds-color-icon-surface": "#bac8da",
          "--hds-color-shadow-xl-bottom": "#003b890f",
          "--hds-color-accent-icon-solidAlt": "#533afd",
          "--hds-color-action-text-onTransparent": "#533afd",
          "--hds-color-accentColorMode-lemon-icon-gradientStart": "#ffd552",
          "--hds-color-util-action-bg-soft": "#665efd",
          "--hds-color-core-brandDark-925": "#1c1b5a",
          "--hds-color-input-bg-accent": "#533afd",
          "--hds-color-util-brand-975": "#0f1137",
          "--hds-color-core-orange-100": "#ffd8c6",
          "--hds-color-util-accent-orange-100": "#ffd8c6",
          "--hds-color-input-text-error": "#d8351e",
          "--hds-space-core-border-lg": "2px",
          "--hds-color-input-tile-border-pressed": "#2e2b8c",
          "--hds-color-button-secondary-bg": "#ffffff00",
          "--hds-color-input-border-error": "#d8351e",
          "--hds-color-input-selector-bg-selected": "#533afd",
          "--hds-color-core-brandDark-700": "#362baa",
          "--hds-color-core-neutralDark-200": "#c0cee6",
          "--hds-color-button-secondary-bgHover": "#ffffff00",
          "--hds-color-core-neutral-700": "#3c4f69",
          "--hds-color-core-neutralDark-900A": "#23357a80",
          "--hds-color-accentColorMode-ruby-icon-solidAlt": "#ea2261",
          "--hds-color-accentColorMode-ruby-surface-subduedAlt": "#fed9de",
          "--hds-color-button-ui-bgOnSubdued": "#e2e4ff",
          "--hds-color-action-bg-transparent": "#ffffff00",
          "--hds-color-action-border-disabled": "#d4dee9",
          "--hds-color-action-icon-navigation-soft": "#50617a",
          "--hds-color-util-accent-lemon-500": "#9b6829",
          "--hds-color-util-action-border-solid": "#533afd",
          "--hds-color-accent-charm-gradientMiddle": "#533afd",
          "--hds-color-action-text-solidHover": "#2e2b8c",
          "--hds-color-util-text-solid": "#061b31",
          "--hds-color-shadow-md-top": "#0037701a",
          "--hds-color-util-neutral-300": "#95a4ba",
          "--hds-color-action-bg-disabled": "#e5edf5",
          "--hds-color-util-aura-h241Shadow": "#1c1b5a",
          "--hds-color-util-action-border-quiet": "#b9b9f9",
          "--hds-color-surface-border-quiet": "#e5edf5",
          "--hds-color-util-brand-925": "#1c1e54",
          "--hds-color-accentColorMode-magenta-icon-gradientEnd": "#b262f9",
          "--hds-color-button-secondary-icon": "#533afd",
          "--hds-color-core-brandDark-600": "#533afd",
          "--hds-color-surface-bg-subduedAdaptive": "#1658bc08",
          "--hds-color-util-text-quiet": "#7d8ba4",
          "--hds-color-core-error-600": "#a01400",
          "--hds-color-core-brand-950": "#161741",
          "--hds-color-input-icon-onSolid": "#fff",
          "--hds-color-core-brand-100A": "#7680f54d",
          "--hds-color-action-icon-onTransparent": "#533afd",
          "--hds-color-core-ruby-800": "#5d1c3c",
          "--hds-color-core-neutral-400": "#7d8ba4",
          "--hds-color-accentColorMode-lemon-icon-solidAlt": "#e8a30b",
          "--hds-color-input-border-selected": "#d4dee9bf",
          "--hds-color-core-brand-25A": "#acacff1f",
          "--hds-color-util-neutral-0": "#fff",
          "--hds-color-util-action-fg-solidAlternate": "#533afd",
          "--hds-color-input-border-default": "#d4dee9bf",
          "--hds-color-util-neutral-200": "#bac8da",
          "--hds-color-core-brand-925": "#1c1e54",
          "--hds-color-core-brandDark-100": "#c3d3ff",
          "--hds-color-input-bg-quiet": "#d4dee9",
          "--hds-color-button-primary-text": "#fff",
          "--hds-color-util-text-inactive": "#95a4ba",
          "--hds-color-action-text-solid": "#533afd",
          "--hds-color-text-quiet": "#7d8ba4",
          "--hds-color-core-success-600": "#006f3a",
          "--hds-color-shadow-popoverBottom": "#061b311f",
          "--hds-color-util-border-subdued": "#d4dee9",
          "--hds-color-util-action-text-max": "#2e2b8c",
          "--hds-color-util-action-fg-solidAlternateHover": "#2e2b8c",
          "--hds-color-core-brand-25": "#f5f5ff",
          "--hds-color-core-success-400": "#00b261",
          "--hds-color-core-neutral-50": "#e5edf5",
          "--hds-color-core-lemon-100": "#ffe1a3",
          "--hds-color-util-accent-lemon-800": "#483414",
          "--hds-color-action-border-quiet": "#d6d9fc",
          "--hds-color-core-brandDark-50": "#e4eaff",
          "--hds-color-shadow-sm-bottom": "#003b890d",
          "--hds-color-util-success-100": "#b6f2c7",
          "--hds-color-util-brand-500": "#665efd",
          "--hds-color-core-neutral-300": "#95a4ba",
          "--hds-color-core-brand-500": "#665efd",
          "--hds-color-action-icon-onTranslucent": "#533afd",
          "--hds-color-action-icon-solid": "#533afd",
          "--hds-color-core-global-transparent": "#ffffff00",
          "--hds-color-util-neutral-25": "#f8fafd",
          "--hds-space-core-border-none": "0px",
          "--hds-color-surface-bg-subdued": "#f8fafd",
          "--hds-color-accentColorMode-orange-icon-solidAlt": "#ff6118",
          "--hds-color-util-accent-magenta-600": "#a51d85",
          "--hds-color-action-bg-quietHover": "#d6d9fc",
          "--hds-color-action-icon-onQuiet": "#533afd",
          "--hds-space-core-border-md": "1.25px",
          "--hds-color-input-popover-divider": "#d4dee9bf",
          "--hds-color-core-magenta-50": "#ffe6f5",
          "--hds-color-core-magenta-800": "#4f2055",
          "--hds-color-core-neutralDark-500": "#6480b2",
          "--hds-color-accent-text-solid": "#533afd",
          "--hds-color-core-brandDark-900": "#222069",
          "--hds-color-action-icon-solidHover": "#2e2b8c",
          "--hds-color-action-focus-outer": "#533afd",
          "--hds-color-core-brand-600": "#533afd",
          "--hds-color-input-selector-bg-range": "#e8e9ff",
          "--hds-color-util-accent-magenta-800": "#4f2055",
          "--hds-color-util-brand-100": "#d6d9fc",
          "--hds-color-button-primary-textDisabled": "#95a4ba",
          "--hds-color-button-secondary-borderDisabled": "#d4dee9",
          "--hds-color-core-lemon-300": "#e8a30b",
          "--hds-color-core-ruby-600": "#b51145",
          "--hds-color-input-selector-text-disabled": "#95a4ba",
          "--hds-color-accentColorMode-orange-surface-subdued": "#ffe5da",
          "--hds-color-button-primary-icon": "#fff",
          "--hds-color-action-focus-surface": "#ffffff00",
          "--hds-color-util-action-fg-solidHover": "#2e2b8c",
          "--hds-color-core-neutral-600": "#50617a",
          "--hds-color-util-accent-magenta-500": "#cf2cab",
          "--hds-color-util-accent-ruby-50": "#fee8eb",
          "--hds-color-util-action-bg-subdued": "#b9b9f999",
          "--hds-color-input-bg-focus": "#ffffff80",
          "--hds-color-button-ui-bgOnSubduedHover": "#b9b9f9",
          "--hds-color-util-action-icon-max": "#2e2b8c",
          "--hds-color-util-action-fg-solid": "#533afd",
          "--hds-color-input-icon-solid": "#533afd",
          "--hds-color-core-brand-50A": "#a3a7ff40",
          "--hds-color-util-accent-magenta-50": "#ffe6f5",
          "--hds-color-action-text-onTranslucent": "#533afd",
          "--hds-color-core-brand-300": "#9a9afe",
          "--hds-color-core-magenta-350": "#f44bcc",
          "--hds-color-core-neutralDark-800A": "#2f458ba6",
          "--hds-color-util-action-bg-solid": "#533afd",
          "--hds-color-accentColorMode-default-surface-subduedAlt": "#e2e4ff",
          "--hds-color-core-orange-600": "#ab3500",
          "--hds-color-core-brandDark-300": "#92adff",
          "--hds-color-input-selector-bg-availableHover": "#d6d9fc",
          "--hds-color-button-ui-borderDisabled": "#d4dee9",
          "--hds-color-accentColorMode-orange-icon-gradientEnd": "#fd5d7c",
          "--hds-color-core-ruby-400": "#ea2261",
          "--hds-color-input-selector-text-available": "#273951",
          "--hds-color-input-selector-text-selected": "#fff",
          "--hds-color-util-error-100": "#feb9ac",
          "--hds-color-core-brandDark-400": "#7389ff",
          "--hds-color-util-brand-400": "#7f7dfc",
          "--hds-color-core-orange-50": "#ffe5da",
          "--hds-color-accentColorMode-default-icon-gradientEnd": "#4032c8",
          "--hds-color-action-bg-solidHover": "#4032c8",
          "--hds-color-core-neutral-100": "#d4dee9",
          "--hds-color-accentColorMode-ruby-surface-subdued": "#fed9de",
          "--hds-color-util-brand-700": "#4032c8",
          "--hds-color-core-error-100": "#feb9ac",
          "--hds-color-core-neutralDark-900": "#182659",
          "--hds-color-input-bg-solid": "#fff",
          "--hds-color-util-accent-lemon-300": "#e8a30b",
          "--hds-color-util-border-solid": "#273951",
          "--hds-color-util-action-fg-onSolid": "#fff",
          "--hds-color-action-text-solidAlternate": "#533afd",
          "--hds-color-input-bg-popoverTransparent": "#ffffff00",
          "--hds-color-util-neutral-400": "#7d8ba4",
          "--hds-color-action-text-onQuiet": "#533afd",
          "--hds-color-accentColorMode-lemon-icon-solid": "#e8a30b",
          "--hds-color-util-action-fg-onAlpha": "#533afd",
          "--hds-color-core-brandDark-975": "#171055",
          "--hds-color-button-primary-iconHover": "#fff",
          "--hds-color-input-tile-bg-selected": "#acacff1f",
          "--hds-color-core-ruby-100": "#fed9de",
          "--hds-color-core-brand-50": "#e8e9ff",
          "--hds-color-action-text-secondary": "#061b31",
          "--hds-color-input-bg-popover": "#fff",
          "--hds-color-util-black": "#061b31",
          "--hds-color-input-selector-bg-available": "#ffffff00",
          "--hds-size-input-popover-border-width": "0px",
          "--hds-color-accentColorMode-magenta-icon-solidAlt": "#f44bcc",
          "--hds-color-util-accent-ruby-100": "#fed9de",
          "--hds-color-input-bg-listboxIcon": "#e5edf5",
          "--hds-color-input-border-accent": "#533afd",
          "--hds-color-accent-surface-subduedAlt": "#e2e4ff",
          "--hds-color-core-magenta-100": "#ffd7ef",
          "--hds-color-util-action-text-min": "#fff",
          "--hds-color-accentColorMode-orange-border-quiet": "#ffd8c6",
          "--hds-color-accentColorMode-orange-surface-subduedAlt": "#ffe5da",
          "--hds-color-util-brand-950": "#161741",
          "--hds-color-shadow-md-bottom": "#003b8905",
          "--hds-canary-dashed-border": "1px dashed #e5edf5",
          "--hds-color-input-bg-selectorActive": "#7f7dfc",
          "--hds-color-input-border-focus": "#d4dee9bf",
          "--hds-space-customerCard-logo-height": "60px",
          "--hds-color-input-tile-border-hover": "#533afd",
          "--hds-color-core-brand-800": "#2e2b8c",
          "--hds-color-shadow-lg-bottom": "#003b890a",
          "--hds-color-shadow-xs-bottom": "#003b890a",
          "--hds-color-action-border-solid": "#533afd",
          "--hds-color-core-neutral-800": "#273951",
          "--hds-color-core-ruby-50": "#fee8eb",
          "--hds-color-util-action-border-emphasized": "#4032c8",
          "--hds-color-util-accent-ruby-800": "#5d1c3c",
          "--hds-color-core-neutralDark-600": "#45639d",
          "--hds-color-action-bg-quiet": "#e8e9ff",
          "--hds-color-util-brand-75": "#e2e4ff",
          "--hds-color-util-success-400": "#00b261",
          "--hds-color-button-primary-bgDisabled": "#e5edf5",
          "--hds-color-core-brand-700": "#4032c8",
          "--hds-color-accentColorMode-lemon-icon-gradientEnd": "#ff9014",
          "--hds-color-util-neutral-975": "#0d253d",
          "--hds-color-accentColorMode-lemon-border-quiet": "#ffe1a3",
          "--hds-color-core-magenta-500": "#cf2cab",
          "--hds-color-util-neutral-100": "#d4dee9",
          "--hds-color-core-brand-75": "#e2e4ff",
          "--hds-color-core-lemon-25": "#fff2d8",
          "--hds-color-action-text-disabled": "#95a4ba",
          "--hds-color-shadow-popoverTop": "#27395114",
          "--hds-color-core-neutral-950": "#11273e",
          "--hds-space-input-popover-width": "240px",
          "--hds-color-accentColorMode-ruby-icon-gradientStart": "#fd7184",
          "--hds-color-util-accent-lemon-100": "#ffe1a3",
          "--hds-color-core-brand-200": "#b9b9f9",
          "--hds-color-core-brandDark-700A": "#4834dbb2",
          "--hds-color-button-ui-icon": "#533afd",
          "--hds-color-core-orange-800": "#56281b",
          "--hds-color-core-neutralDark-950": "#122054",
          "--hds-color-button-ui-bg": "#e8e9ff",
          "--hds-color-util-action-bg-quiet": "#b9b9f94d",
          "--hds-color-util-accent-orange-500": "#d04900",
          "--accent-gradient-color-stop-1": "#bdb4ff",
          "--hds-color-util-action-icon-quiet": "#d6d9fc",
          "--hds-color-input-bg-inactive": "#d4dee9bf",
          "--hds-color-input-selector-text-rangeDisabled": "#b9b9f9",
          "--hds-color-action-text-solidAlternateHover": "#2e2b8c",
          "--hds-color-icon-solid": "#273951",
          "--hds-color-action-focus-inner-subdued": "#f8fafd",
          "--hds-color-button-secondary-borderOnSubdued": "#b9b9f9",
          "--hds-color-accent-charm-gradientStart": "#7f7dfc",
          "--hds-color-accent-border-quiet": "#d6d9fc",
          "--hds-color-util-border-emphasized": "#061b31",
          "--hds-color-util-error-500": "#d8351e",
          "--hds-color-core-neutral-200": "#bac8da",
          "--hds-color-input-bg-hover": "#f5f5ff",
          "--hds-color-surface-bg-quiet": "#fff",
          "--hds-color-util-error-400": "#f3432a",
          "--hds-color-action-text-onSubdued": "#533afd",
          "--hds-space-core-border-sm": "1px",
          "--hds-color-util-neutral-600": "#50617a",
          "--hds-color-input-icon-disabled": "#d4dee9",
          "--hds-color-action-icon-solidAlternate": "#533afd",
          "--hds-color-util-action-bg-min": "#9a9afe1f",
          "--hds-color-util-bg-subdued": "#e5edf5",
          "--hds-color-input-selector-bg-selectedHover": "#4032c8",
          "--hds-color-button-secondary-text": "#533afd",
          "--hds-color-core-neutral-900": "#1a2c44",
          "--hds-color-core-neutral-990": "#061b31",
          "--hds-color-text-soft": "#50617a",
          "--hds-color-icon-subdued": "#64748d",
          "--hds-color-util-bg-soft": "#d4dee9",
          "--hds-canary-layout-content-maxWidth-borders": "calc(1264px + 2px)",
          "--hds-color-core-magenta-600": "#a51d85",
          "--hds-color-core-neutral-200A": "#7591b580",
          "--hds-color-util-action-icon-emphasized": "#4032c8",
          "--hds-color-accentColorMode-lemon-icon-gradientMiddle": "#ffaf2d",
          "--hds-color-core-neutral-25A": "#1658bc08",
          "--hds-color-core-brandDark-25": "#f6f7ff",
          "--hds-color-util-action-text-emphasized": "#4032c8",
          "--hds-color-action-icon-onSolid": "#fff",
          "--hds-color-util-text-subdued": "#64748d",
          "--hds-color-accentColorMode-orange-icon-gradientStart": "#fe8c2d",
          "--hds-color-util-action-text-soft": "#665efd",
          "--hds-color-button-ui-iconDisabled": "#95a4ba",
          "--hds-color-core-error-500": "#d8351e",
          "--hds-color-core-orange-500": "#d04900",
          "--hds-color-core-brandDark-925A": "#582be233",
          "--hds-color-core-error-400": "#f3432a",
          "--hds-color-accent-charm-gradientEnd": "#4032c8",
          "--hds-color-input-selector-bg-disabled": "#e5edf5",
          "--hds-color-accent-surface-subdued": "#e2e4ff",
          "--hds-color-util-action-icon-min": "#fff",
          "--hds-color-accentColorMode-default-icon-gradientMiddle": "#533afd",
          "--hds-canary-color-border-focus": "#635bff",
          "--hds-color-input-selector-text-rangeHover": "#4032c8",
          "--hds-color-util-border-quiet": "#e5edf5",
          "--hds-color-input-tile-border-selected": "#7f7dfc",
          "--hds-color-util-neutral-900": "#1a2c44",
          "--hds-color-core-brandDark-500": "#5d64fe",
          "--hds-color-core-brand-100": "#d6d9fc",
          "--hds-color-input-tile-text-hover": "#533afd",
          "--hds-color-util-neutral-500": "#64748d",
          "--hds-color-input-tile-text-pressed": "#2e2b8c",
          "--hds-color-util-action-border-subdued": "#7f7dfc",
          "--hds-color-action-border-subdued": "#b9b9f9",
          "--hds-color-input-selector-text-availableHover": "#4032c8",
          "--hds-color-input-border-disabled": "#d4dee9",
          "--accent-gradient-color-stop-2": "#643afd",
          "--hds-color-button-secondary-textHover": "#2e2b8c",
          "--hds-color-core-neutralDark-800": "#23356e",
          "--hds-color-button-secondary-border": "#d6d9fc",
          "--accent-gradient-color-stop-3": "#533afd",
          "--hds-color-util-white": "#fff",
          "--hds-color-util-error-600": "#a01400",
          "--hds-color-text-solid": "#061b31",
          "--hds-color-core-brandDark-800": "#2c2484",
          "--hds-color-core-brandDark-75": "#ccdaff",
          "--hds-color-core-neutralDark-300": "#a3b5d6",
          "--hds-color-button-primary-bgHover": "#4032c8",
          "--hds-color-button-secondary-iconHover": "#2e2b8c",
          "--hds-color-core-neutralDark-975": "#101d4e",
          "--hds-color-core-neutralDark-100": "#d4deef",
          "--hds-color-util-success-600": "#006f3a",
          "--hds-color-core-neutralDark-950A": "#17297080",
          "--hds-color-accentColorMode-ruby-border-quiet": "#fed9de",
          "--hds-color-core-brand-900": "#1c1e54",
          "--hds-color-input-text-solid": "#273951",
          "--hds-color-accentColorMode-magenta-icon-solid": "#f44bcc",
          "--hds-color-util-accent-orange-800": "#56281b",
          "--hds-color-text-subdued": "#64748d",
          "--hds-color-core-lemon-800": "#483414",
          "--hds-color-core-brandDark-950": "#191a51",
          "--hds-color-shadow-xl-top": "#00377024",
          "--hds-color-core-success-100": "#b6f2c7",
          "--hds-color-input-selector-text-current": "#061b31",
          "--hds-color-accentColorMode-ruby-icon-gradientMiddle": "#ea2261",
          "--hds-color-util-action-text-solid": "#533afd",
          "--hds-color-core-neutral-500": "#64748d",
          "--hds-color-action-icon-disabled": "#95a4ba",
          "--hds-color-icon-emphasized": "#061b31",
          "--hds-color-util-accent-magenta-350": "#f44bcc",
          "--hds-color-button-ui-bgHover": "#d6d9fc",
          "--hds-color-button-secondary-borderHover": "#4032c8",
          "--hds-color-input-selector-text-selectedDisabled": "#273951",
          "--hds-color-util-brand-50": "#e8e9ff",
          "--hds-color-action-focus-inner-quiet": "#fff",
          "--navigation-border-radius": "6px",
          "--hds-color-core-neutral-25": "#f8fafd",
          "--hds-color-action-icon-solidAlternateHover": "#2e2b8c",
          "--hds-color-util-accent-ruby-500": "#e2225f",
          "--hds-color-util-accent-orange-600": "#ab3500",
          "--hds-color-accentColorMode-magenta-border-quiet": "#ffd7ef",
          "--hds-color-shadow-xs-top": "#0037700f",
          "--hds-color-action-bg-solid": "#533afd",
          "--hds-color-core-orange-350": "#ff6118",
          "--hds-color-core-brand-975": "#0f1137",
          "--hds-color-action-icon-navigation-solid": "#061b31",
          "--hds-color-accentColorMode-default-icon-gradientStart": "#7f7dfc",
          "--hds-color-util-accent-ruby-600": "#b51145",
          "--hds-color-action-icon-navigation-subdued": "#64748d",
          "--hds-color-accentColorMode-lemon-surface-subduedAlt": "#fff2d8",
          "--hds-color-input-bg-disabled": "#e5edf5",
          "--hds-color-util-border-soft": "#50617a",
          "--hds-color-util-accent-lemon-50": "#fff2d8",
          "--hds-color-accent-icon-solid": "#533afd",
          "--hds-color-button-primary-textHover": "#fff",
          "--navigation-padding-outer": "8px",
          "--hds-space-core-1900": "152px",
          "--hds-space-core-300": "24px",
          "--hds-space-core-250": "20px",
          "--hds-space-core-2000": "160px",
          "--hds-font-heading-md-letterSpacing": "-0.01em",
          "--hds-font-text-lg-letterSpacing": "0em",
          "--hds-space-input-text-paddingX-lg": "16px",
          "--hds-space-input-text-paddingY-sm": "8px",
          "--hds-space-core-radius-none": "0px",
          "--hds-space-core-550": "44px",
          "--hds-font-text-xxl-letterSpacing": "-0.02em",
          "--hds-space-block-column-gap": "16px",
          "--hds-font-heading-xl-size": "3rem",
          "--hds-font-input-text-sm-size": "0.75rem",
          "--hds-space-core-2200": "176px",
          "--hds-space-input-text-paddingY-md": "10px",
          "--hds-font-text-sm-size": "0.875rem",
          "--hds-font-input-text-lg-letterSpacing": "0px",
          "--hds-space-layout-gap": "16px",
          "--hds-space-core-1000": "80px",
          "--hds-font-heading-hero-md-size": "2.25rem",
          "--hds-font-heading-lg-letterSpacing": "-0.02em",
          "--hds-font-input-description-letterSpacing": "0px",
          "--hds-font-input-label-lg-size": "1rem",
          "--hds-space-input-layered-label-maxWidth": "196px",
          "--hds-space-core-radius-round": "99999px",
          "--hds-font-heading-xxs-letterSpacing": "0em",
          "--hds-font-heading-hero-md-letterSpacing": "-0.02em",
          "--hds-space-core-1400": "112px",
          "--hds-space-core-400": "32px",
          "--hds-font-heading-lg-size": "2rem",
          "--hds-space-input-focus-shadowOuter": "4px",
          "--hds-space-block-stack-gap-lg": "48px",
          "--hds-space-input-gap-errorMessage": "4px",
          "--hds-space-layout-columns": "12",
          "--hds-space-core-1500": "120px",
          "--hds-space-input-layered-label-minWidth": "120px",
          "--hds-font-input-description-size": "0.875rem",
          "--hds-font-heading-hero-sm-letterSpacing": "-0.02em",
          "--hds-font-heading-xs-size": "1rem",
          "--hds-space-core-radius-lg": "16px",
          "--hds-font-quote-md-letterSpacing": "-0.01em",
          "--hds-space-block-stack-gap-md": "16px",
          "--hds-space-core-350": "28px",
          "--hds-font-heading-xxl-size": "3.5rem",
          "--hds-font-heading-xxs-size": "0.875rem",
          "--hds-space-core-1300": "104px",
          "--hds-font-heading-xxl-letterSpacing": "-0.025em",
          "--hds-space-core-1800": "144px",
          "--hds-space-input-text-paddingY-listbox": "6px",
          "--hds-font-input-text-md-size": "0.875rem",
          "--hds-space-core-150": "12px",
          "--hds-font-input-label-sm-size": "0.75rem",
          "--hds-font-heading-md-size": "1.625rem",
          "--hds-space-layout-page-margin": "16px",
          "--hds-space-core-25": "2px",
          "--hds-space-core-700": "56px",
          "--hds-font-text-md-size": "1rem",
          "--hds-font-input-text-md-letterSpacing": "0px",
          "--hds-space-core-1100": "88px",
          "--hds-font-input-label-md-letterSpacing": "0px",
          "--hds-space-block-stack-gap-xl": "64px",
          "--hds-space-button-radius-sm": "2px",
          "--hds-space-core-1200": "96px",
          "--hds-space-input-layered-input-minWidth": "300px",
          "--hds-font-heading-hero-lg-size": "2.5rem",
          "--hds-space-core-radius-xs": "2px",
          "--hds-space-core-600": "48px",
          "--hds-font-text-xs-letterSpacing": "0em",
          "--hds-space-input-text-paddingX-md": "13px",
          "--hds-font-quoteAttribution-md-size": "1.125rem",
          "--hds-font-heading-xs-letterSpacing": "0em",
          "--hds-space-core-450": "36px",
          "--hds-font-text-xs-size": "0.875rem",
          "--hds-font-text-xxs-size": "0.75rem",
          "--hds-space-core-500": "40px",
          "--hds-space-core-50": "4px",
          "--hds-space-input-text-paddingX-sm": "10px",
          "--hds-font-text-md-letterSpacing": "0em",
          "--hds-font-input-text-lgTextarea-size": "1rem",
          "--hds-font-heading-hero-sm-size": "2rem",
          "--hds-font-input-groupHeading-size": "0.75rem",
          "--hds-space-core-2500": "200px",
          "--hds-space-core-radius-xl": "32px",
          "--hds-font-text-xl-letterSpacing": "-0.01em",
          "--hds-space-stat-content-padding-y": "36px",
          "--hds-space-core-75": "6px",
          "--hds-space-input-text-paddingX-listbox": "10px",
          "--hds-font-heading-hero-lg-letterSpacing": "-0.02em",
          "--hds-font-heading-xl-letterSpacing": "-0.02em",
          "--hds-font-input-label-sm-letterSpacing": "0px",
          "--hds-font-heading-sm-size": "1.375rem",
          "--hds-space-core-2100": "168px",
          "--hds-font-input-label-md-size": "0.875rem",
          "--hds-space-core-1700": "136px",
          "--hds-font-text-sm-letterSpacing": "0em",
          "--hds-space-input-minHeight": "48px",
          "--hds-space-input-gap-labelVertical": "8px",
          "--hds-space-input-focus-shadowSingle": "2px",
          "--hds-space-core-1": "1px",
          "--hds-font-quoteAttribution-md-letterSpacing": "0em",
          "--hds-font-input-text-lgTextarea-letterSpacing": "0px",
          "--hds-font-input-label-lg-letterSpacing": "0px",
          "--hds-space-core-200": "16px",
          "--hds-space-core-900": "72px",
          "--hds-space-input-layered-input-maxWidth": "360px",
          "--hds-space-button-height": "48px",
          "--hds-space-core-100": "8px",
          "--hds-space-section-gap-top": "96px",
          "--hds-font-heading-sm-letterSpacing": "-0.01em",
          "--hds-font-text-xxl-size": "3rem",
          "--hds-space-input-focus-outline-offset": "1px",
          "--hds-space-layout-content-margin": "16px",
          "--hds-font-input-text-lg-size": "1rem",
          "--hds-font-quote-md-size": "1.625rem",
          "--hds-font-text-lg-size": "1.125rem",
          "--hds-font-input-text-sm-letterSpacing": "0px",
          "--hds-space-core-radius-md": "6px",
          "--hds-space-core-0": "0px",
          "--hds-space-core-800": "64px",
          "--hds-space-layout-content-maxWidth": "1264px",
          "--hds-space-core-radius-sm": "4px",
          "--hds-space-core-2300": "184px",
          "--hds-space-core-1600": "128px",
          "--hds-space-button-radius-lg": "4px",
          "--hds-font-text-xl-size": "1.25rem",
          "--hds-space-section-gap-bottom": "96px",
          "--hds-space-core-2400": "192px",
          "--hds-space-input-text-paddingY-lg": "12px",
          "--hds-space-input-layered-gap": "24px",
          "--hds-font-text-xxs-letterSpacing": "0em",
          "--hds-font-input-groupHeading-letterSpacing": "0px",
          "--hds-font-input-text-md-lineHeight": "1.3",
          "--hds-font-heading-xs-lineHeight": "1.2",
          "--hds-font-quoteAttribution-md-weight": "300",
          "--hds-font-heading-md-weight": "300",
          "--hds-font-heading-xl-lineHeight": "1.03",
          "--hds-font-input-groupHeading-weight": "300",
          "--hds-font-text-lg-lineHeight": "1.4",
          "--hds-font-input-description-lineHeight": "1.3",
          "--hds-font-family": "\"sohne-var\",\"SF Pro Display\",sans-serif",
          "--hds-font-heading-sm-weight": "300",
          "--hds-font-heading-hero-lg-lineHeight": "1.2",
          "--hds-font-input-label-lg-weight": "400",
          "--hds-font-text-xxs-lineHeight": "1.45",
          "--hero-font-lang-large": "3rem",
          "--hds-font-text-xxl-weight": "300",
          "--hds-font-text-xs-weight": "300",
          "--hds-font-input-text-lgTextarea-lineHeight": "1.4",
          "--hds-font-heading-xxs-lineHeight": "1.2",
          "--hds-font-text-xxs-weight": "300",
          "--hds-font-heading-hero-md-weight": "300",
          "--hds-font-text-md-weight": "300",
          "--hds-font-text-lg-weight": "300",
          "--hero-font-lang-medium": "2.75rem",
          "--hds-font-heading-hero-lg-weight": "300",
          "--hds-font-input-text-sm-weight": "300",
          "--hds-font-input-text-lgTextarea-weight": "300",
          "--hds-font-text-xl-lineHeight": "1.4",
          "--hds-font-heading-xxl-lineHeight": "1.03",
          "--hds-font-input-label-md-lineHeight": "1.3",
          "--hds-font-heading-sm-lineHeight": "1.1",
          "--hds-font-heading-xxl-weight": "300",
          "--hds-font-heading-xxs-weight": "400",
          "--hds-font-text-sm-lineHeight": "1.4",
          "--hds-font-heading-lg-weight": "300",
          "--hds-font-input-label-sm-lineHeight": "1.35",
          "--hds-font-family-code": "\"SourceCodePro\",\"SFMono-Regular\",monospace",
          "--hds-font-text-xxl-lineHeight": "1",
          "--hds-font-quoteAttribution-md-lineHeight": "1.4",
          "--hds-font-input-text-md-weight": "300",
          "--hds-font-heading-hero-md-lineHeight": "1.05",
          "--hds-font-heading-hero-sm-weight": "300",
          "--hds-font-heading-xs-weight": "400",
          "--hds-font-weight-bold": "400",
          "--hero-font-lang-small": "2.5rem",
          "--hds-font-heading-hero-sm-lineHeight": "1.1",
          "--hds-font-input-groupHeading-lineHeight": "1.35",
          "--hero-font-lang-min": "2.125rem",
          "--hds-font-heading-lg-lineHeight": "1.1",
          "--hds-font-input-label-md-weight": "400",
          "--hds-font-input-text-lg-weight": "300",
          "--hds-font-text-xs-lineHeight": "1.4",
          "--hds-font-text-md-lineHeight": "1.4",
          "--hds-font-input-text-lg-lineHeight": "1",
          "--hds-font-input-text-sm-lineHeight": "1.35",
          "--hds-font-text-sm-weight": "300",
          "--hds-font-input-label-lg-lineHeight": "1.2",
          "--hds-font-text-xl-weight": "300",
          "--hds-font-weight-normal": "300",
          "--hds-font-quote-md-weight": "300",
          "--hds-font-quote-md-lineHeight": "1.12",
          "--hds-font-input-label-sm-weight": "400",
          "--hds-font-heading-xl-weight": "300",
          "--hds-font-heading-md-lineHeight": "1.12",
          "--hds-font-input-description-weight": "300",
          "--hds-shadow-sm-top-offset-y": "5px",
          "--hds-shadow-sm-bottom-offset-y": "2px",
          "--hds-shadow-xs-top-blur": "10px",
          "--hds-shadow-xs-bottom-blur": "4px",
          "--hds-shadow-xs-top-offset-y": "2px",
          "--hds-shadow-sm-bottom-offset-x": "0px",
          "--hds-shadow-xl-bottom-offset-x": "0px",
          "--hds-shadow-xl-bottom-offset-y": "10px",
          "--hds-shadow-lg-bottom-blur": "20px",
          "--hds-shadow-xl-bottom-spread": "-16px",
          "--hds-shadow-sm-bottom-spread": "0px",
          "--hds-shadow-md-top-blur": "22px",
          "--hds-shadow-md-bottom-blur": "8px",
          "--hds-shadow-lg-bottom-offset-x": "0px",
          "--hds-shadow-xl": "0px 20px 80px -16px #00377024,0px 10px 60px -16px #003b890f",
          "--hds-shadow-sm-top-offset-x": "0px",
          "--hds-shadow-md": "0px 6px 22px 0px #0037701a,0px 4px 8px 0px #003b8905",
          "--hds-shadow-lg-bottom-offset-y": "5px",
          "--hds-shadow-sm-top-spread": "0px",
          "--hds-shadow-md-bottom-spread": "0px",
          "--hds-shadow-xl-top-spread": "-16px",
          "--hds-shadow-lg-bottom-spread": "-2px",
          "--hds-shadow-xl-top-offset-x": "0px",
          "--hds-shadow-md-top-spread": "0px",
          "--hds-shadow-xl-top-offset-y": "20px",
          "--hds-shadow-xs-bottom-offset-x": "0px",
          "--hds-shadow-xl-bottom-blur": "60px",
          "--hds-shadow-xs-top-offset-x": "0px",
          "--hds-shadow-md-bottom-offset-y": "4px",
          "--hds-shadow-xl-top-blur": "80px",
          "--hds-shadow-md-top-offset-x": "0px",
          "--hds-shadow-sm-bottom-blur": "8px",
          "--hds-shadow-sm-top-blur": "14px",
          "--hds-shadow-lg-top-offset-y": "15px",
          "--hds-canary-ui-shadow": "0px 16px 32px rgba(50,50,93,.12)",
          "--hds-shadow-xs-top-spread": "0px",
          "--hds-shadow-lg-top-spread": "-2px",
          "--hds-shadow-md-top-offset-y": "6px",
          "--hds-shadow-lg": "0px 15px 40px -2px #0037701a,0px 5px 20px -2px #003b890a",
          "--hds-shadow-lg-top-offset-x": "0px",
          "--hds-shadow-xs": "0px 2px 10px 0px #0037700f,0px 1px 4px 0px #003b890a",
          "--hds-shadow-sm": "0px 5px 14px 0px #00377014,0px 2px 8px 0px #003b890d",
          "--hds-shadow-xs-bottom-spread": "0px",
          "--hds-shadow-md-bottom-offset-x": "0px",
          "--hds-shadow-xs-bottom-offset-y": "1px",
          "--hds-shadow-lg-top-blur": "40px",
          "--navigation-inline-end": "16px",
          "--navigation-duration-slow": "300ms",
          "--navigation-duration": "240ms",
          "--hds-canary-ui-mini-stroke": "#e5edf5",
          "--hds-canary-grid-span-quarter": "span 3",
          "--navigation-easing": "cubic-bezier(0.45,0.05,0.55,0.95)",
          "--navigation-hamburger-duration": "0.25s",
          "--navigation-height": "76px",
          "--hover-progress": "0",
          "--hds-canary-grid-span-full": "span 12",
          "--hds-canary-grid-span-half": "span 6",
          "--hds-canary-ui-stroke": "color-mix(in srgb,#e5edf5 50%,transparent)",
          "--navigation-inline-start": "16px"
        },
        "meta": {
          "extractedAt": "2026-05-08T20:48:18.811Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "body font \"Söhne\" not on Google Fonts — fallback to sans-serif"
    ]
  },
  {
    "slug": "tailwindcss",
    "name": "Tailwind",
    "source": "https://tailwindcss.com",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "Inter",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "plexMono",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 100%)",
          "foreground": "hsl(0, 0%, 0%)",
          "primary": "hsl(340, 93%, 48%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(210, 100%, 50%)",
          "secondary-foreground": "hsl(0, 0%, 100%)",
          "accent": "hsl(205, 100%, 59%)",
          "accent-foreground": "hsl(0, 0%, 100%)",
          "muted": "hsl(0, 0%, 100%)",
          "muted-foreground": "hsl(0, 0%, 0%)",
          "border": "hsl(0, 0%, 100%)"
        },
        "allVars": {
          "--color-primary": "#ec0853",
          "--color-secondary": "#0080ff",
          "--color-accent": "#2ca8ff",
          "--color-neutral-50": "lab(98.26% 0 0)",
          "--color-neutral-100": "lab(96.52% -.0000298023 .0000119209)",
          "--color-bg": "#ffffff",
          "--color-bg-1": "#000102",
          "--color-bg-2": "#000000",
          "--color-bg-3": "#ec0853",
          "--color-text": "#000000",
          "--color-text-1": "#ffffff",
          "--color-text-2": "#000102",
          "--font-sans": "\"inter\", \"inter Fallback\", system-ui",
          "--font-body": "'plexMono', sans-serif",
          "--font-size-96": "96px",
          "--font-size-40": "40px",
          "--font-size-36": "36px",
          "--font-size-30": "30px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-17": "17px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--spacing-1": "1px",
          "--spacing-57": "57px",
          "--spacing-64": "64px",
          "--spacing-72": "72px",
          "--spacing-96": "96px",
          "--spacing-160": "160px",
          "--spacing-336": "336px",
          "--spacing-400": "400px",
          "--radius-sm": ".25rem",
          "--radius-md": ".375rem",
          "--radius-lg": ".5rem",
          "--radius-xl": ".75rem",
          "--radius-full": "32px",
          "--shadow-sm": "0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a",
          "--color-purple-300": "lab(78.3298% 26.2195 -34.9499)",
          "--color-mauve-800": "lab(14.1786% 6.35938 -5.68258)",
          "--color-zinc-100": "lab(96.1634% .0993311 -.364041)",
          "--color-purple-200": "lab(87.8405% 13.4282 -18.7159)",
          "--color-zinc-200": "lab(90.6853% .399232 -1.45452)",
          "--color-rose-200": "lab(86.806% 19.1909 4.07754)",
          "--color-slate-200": "lab(91.7353% -.998765 -4.76968)",
          "--tw-mask-bottom-to-color": "transparent",
          "--color-sky-500": "lab(63.3038% -18.433 -51.0407)",
          "--color-pink-500": "lab(56.9303% 76.8162 -8.07021)",
          "--color-orange-600": "lab(57.1026% 64.2584 89.8886)",
          "--color-violet-600": "lab(41.088% 68.9966 -91.995)",
          "--color-red-900": "lab(28.5139% 44.5539 29.0463)",
          "--color-orange-800": "lab(37.1566% 46.6433 50.5562)",
          "--color-mauve-600": "lab(34.0653% 7.82093 -6.65653)",
          "--color-neutral-600": "lab(34.924% 0 0)",
          "--tw-mask-bottom-from-color": "black",
          "--color-teal-400": "lab(76.0109% -53.3483 -2.27906)",
          "--color-pink-950": "lab(15.6116% 35.2166 3.53979)",
          "--color-blue-700": "lab(36.9089% 35.0961 -85.6872)",
          "--color-olive-50": "lab(98.6338% -.297457 1.09334)",
          "--color-neutral-300": "lab(84.92% 0 -.0000119209)",
          "--color-taupe-600": "lab(34.6954% 4.49754 4.2051)",
          "--color-slate-500": "lab(48.0876% -2.03595 -16.5814)",
          "--color-purple-800": "lab(30.6017% 56.7637 -64.4751)",
          "--color-orange-900": "lab(30.2951% 36.0434 37.671)",
          "--color-mauve-50": "lab(98.26% 0 0)",
          "--tw-inset-ring-shadow": "0 0 #0000",
          "--color-orange-50": "lab(97.7008% 1.53735 5.90649)",
          "--color-neutral-200": "lab(90.952% 0 -.0000119209)",
          "--color-cyan-700": "lab(44.7267% -21.5987 -26.118)",
          "--color-blue-300": "lab(77.5052% -6.4629 -36.42)",
          "--color-gray-300": "lab(85.1236% -.612259 -3.7138)",
          "--color-yellow-400": "lab(83.2664% 8.65132 106.895)",
          "--color-slate-300": "lab(84.7652% -1.94535 -7.93337)",
          "--color-mist-600": "lab(36.3261% -4.71437 -3.54635)",
          "--color-amber-300": "lab(86.4156% 6.13147 78.3961)",
          "--color-gray-500": "lab(47.7841% -.393182 -10.0268)",
          "--color-taupe-400": "lab(66.7386% 3.56972 3.57119)",
          "--color-olive-100": "lab(96.0988% -.493258 1.82395)",
          "--color-zinc-50": "lab(98.26% 0 0)",
          "--color-cyan-200": "lab(91.0821% -24.0435 -12.8306)",
          "--color-green-500": "lab(70.5521% -66.5147 45.8073)",
          "--color-white": "#fff",
          "--color-sky-600": "lab(51.7754% -11.4712 -49.8349)",
          "--color-gray-400": "lab(65.9269% -.832707 -8.17473)",
          "--color-blue-400": "lab(65.0361% -1.42065 -56.9802)",
          "--color-slate-400": "lab(65.5349% -2.25151 -14.5072)",
          "--color-pink-50": "lab(96.4459% 4.53997 -1.49434)",
          "--color-stone-900": "lab(9.03835% 1.15298 1.92955)",
          "--color-taupe-700": "lab(26.4543% 4.4374 3.65548)",
          "--color-yellow-300": "lab(89.7033% -.480294 84.4917)",
          "--color-zinc-950": "lab(2.51107% .242703 -.886115)",
          "--color-taupe-300": "lab(84.6434% 1.81875 1.71728)",
          "--color-gray-100": "lab(96.1596% -.0823438 -1.13575)",
          "--color-teal-950": "lab(16.6371% -15.3183 -3.81732)",
          "--color-emerald-200": "lab(90.2247% -31.039 9.47084)",
          "--color-purple-600": "lab(43.0295% 75.21 -86.5669)",
          "--color-mist-300": "lab(85.1957% -1.8006 -1.71063)",
          "--tw-mask-left-from-color": "black",
          "--color-violet-800": "lab(29.3188% 57.7986 -76.1493)",
          "--color-teal-900": "lab(29.506% -21.4706 -3.59886)",
          "--color-zinc-700": "lab(26.8019% 1.35387 -4.68303)",
          "--color-neutral-700": "lab(27.036% 0 0)",
          "--color-violet-500": "lab(49.9355% 55.1776 -81.8963)",
          "--color-fuchsia-600": "lab(47.5131% 83.4271 -63.0363)",
          "--color-sky-50": "lab(97.3623% -2.33802 -4.13098)",
          "--color-lime-200": "lab(94.0718% -22.5338 42.5238)",
          "--color-fuchsia-200": "lab(87.7108% 19.9958 -18.2054)",
          "--color-green-900": "lab(30.797% -29.6927 17.382)",
          "--color-taupe-950": "lab(2.86039% .454858 .569314)",
          "--color-rose-950": "lab(14.2323% 34.0086 9.80922)",
          "--color-blue-800": "lab(30.2514% 27.7853 -70.2699)",
          "--color-pink-100": "lab(93.5864% 9.01193 -3.15079)",
          "--color-neutral-900": "lab(7.78201% -.0000149012 0)",
          "--color-cyan-50": "lab(98.3304% -5.97432 -2.62108)",
          "--color-blue-100": "lab(92.0301% -2.24757 -11.6453)",
          "--color-green-600": "lab(59.0978% -58.6621 41.2579)",
          "--color-green-950": "lab(15.6845% -20.4225 11.7249)",
          "--color-taupe-500": "lab(47.3292% 5.2588 5.60027)",
          "--color-yellow-950": "lab(16.8146% 15.7422 23.1133)",
          "--color-violet-950": "lab(14.0706% 33.3353 -46.7553)",
          "--color-violet-300": "lab(76.7419% 18.3911 -37.0706)",
          "--color-zinc-900": "lab(8.30603% .618205 -2.16572)",
          "--color-red-300": "lab(76.5514% 36.422 15.5335)",
          "--color-sky-300": "lab(80.3307% -20.2945 -31.385)",
          "--color-cyan-500": "lab(67.805% -35.3952 -30.2018)",
          "--color-orange-500": "lab(64.272% 57.1788 90.3583)",
          "--color-slate-800": "lab(16.132% -.318035 -14.6672)",
          "--color-olive-300": "lab(86.1731% -1.073 4.02397)",
          "--color-lime-800": "lab(37.7655% -25.1694 43.0683)",
          "--color-emerald-900": "lab(28.8637% -26.9249 5.45986)",
          "--color-sky-400": "lab(70.687% -23.6078 -45.9483)",
          "--color-mist-800": "lab(15.9728% -2.89693 -2.50866)",
          "--tw-mask-right-from-color": "black",
          "--color-slate-600": "lab(35.5623% -1.74978 -15.4316)",
          "--color-taupe-50": "lab(98.3763% .249773 .707853)",
          "--color-pink-600": "lab(49.5493% 79.8381 2.31768)",
          "--color-pink-200": "lab(87.4504% 19.6 -6.46662)",
          "--color-stone-600": "lab(35.5168% 1.08604 4.07829)",
          "--color-olive-950": "lab(3.26204% -.309289 1.13377)",
          "--color-mauve-500": "lab(46.4092% 9.24578 -7.68465)",
          "--color-rose-900": "lab(29.7104% 51.514 12.6253)",
          "--color-green-400": "lab(78.503% -64.9265 39.7492)",
          "--color-emerald-500": "lab(66.9756% -58.27 19.5419)",
          "--color-yellow-50": "lab(98.6846% -1.79055 9.7766)",
          "--color-mauve-300": "lab(84.1787% 3.38054 -2.53499)",
          "--color-gray-950": "lab(1.90334% .278696 -5.48866)",
          "--color-rose-700": "lab(41.1651% 71.6251 30.3087)",
          "--color-amber-700": "lab(47.2709% 42.9082 69.2966)",
          "--color-amber-900": "lab(31.2288% 30.2627 40.0378)",
          "--color-mauve-100": "lab(95.3199% .844389 -.636518)",
          "--color-emerald-50": "lab(97.8462% -6.94966 1.85487)",
          "--color-zinc-600": "lab(35.1166% 1.78212 -6.1173)",
          "--color-gray-600": "lab(35.6337% -1.58697 -10.8425)",
          "--color-indigo-500": "lab(48.295% 38.3129 -81.9673)",
          "--color-violet-200": "lab(87.0888% 8.53688 -19.4189)",
          "--color-purple-400": "lab(63.6946% 47.6127 -59.2066)",
          "--color-yellow-200": "lab(94.3433% -5.00429 52.9663)",
          "--color-orange-100": "lab(94.7127% 3.58394 14.3151)",
          "--tw-mask-top-to-color": "transparent",
          "--color-blue-600": "lab(44.0605% 29.0279 -86.0352)",
          "--color-green-200": "lab(92.4222% -26.4702 12.9427)",
          "--tw-border-style": "solid",
          "--color-cyan-900": "lab(30.372% -13.1853 -18.7887)",
          "--color-red-600": "lab(48.4493% 77.4328 61.5452)",
          "--color-blue-50": "lab(96.492% -1.14644 -5.11479)",
          "--color-stone-700": "lab(27.3812% 1.32917 3.57789)",
          "--color-indigo-700": "lab(32.4486% 49.2217 -84.6695)",
          "--color-neutral-950": "lab(2.75381% 0 0)",
          "--color-black": "#000",
          "--color-neutral-400": "lab(66.128% -.0000298023 .0000119209)",
          "--tw-mask-right-to-color": "transparent",
          "--tw-border-spacing-y": "0px",
          "--color-fuchsia-300": "lab(78.5378% 39.3533 -32.9615)",
          "--color-amber-100": "lab(95.916% -1.21653 23.111)",
          "--color-mist-400": "lab(67.9697% -3.85058 -3.02824)",
          "--color-stone-800": "lab(15.0353% 1.96067 1.53427)",
          "--color-mist-100": "lab(95.7289% -.644743 -.229919)",
          "--color-indigo-100": "lab(91.6577% 1.04591 -12.7199)",
          "--color-mauve-900": "lab(8.33002% 5.15411 -4.30998)",
          "--color-emerald-800": "lab(35.3675% -33.1188 8.04002)",
          "--color-taupe-800": "lab(15.0089% 3.01889 2.55873)",
          "--color-teal-100": "lab(95.1845% -17.4212 -.425422)",
          "--color-violet-50": "lab(96.2416% 2.28849 -5.51657)",
          "--color-cyan-400": "lab(76.6045% -40.9406 -29.6231)",
          "--color-cyan-300": "lab(85.3886% -36.7636 -21.5716)",
          "--color-amber-400": "lab(80.1641% 16.6016 99.2089)",
          "--tw-ring-shadow": "0 0 #0000",
          "--color-indigo-400": "lab(59.866% 22.4834 -64.4485)",
          "--color-purple-500": "lab(52.0183% 66.11 -78.2316)",
          "--color-orange-200": "lab(88.4871% 9.94918 28.8378)",
          "--tw-mask-radial-from-color": "black",
          "--color-emerald-300": "lab(83.9203% -48.7124 13.8849)",
          "--color-yellow-600": "lab(62.7799% 22.4197 86.1544)",
          "--color-lime-950": "lab(16.5113% -15.1841 22.0145)",
          "--color-slate-700": "lab(26.9569% -1.47016 -15.6993)",
          "--color-pink-300": "lab(77.8308% 38.525 -10.5394)",
          "--color-indigo-300": "lab(74.0235% 8.54138 -41.6075)",
          "--color-neutral-500": "lab(48.496% 0 0)",
          "--color-amber-600": "lab(60.3514% 40.5624 87.1228)",
          "--color-yellow-800": "lab(38.7484% 23.5833 51.4916)",
          "--color-pink-400": "lab(64.5597% 64.3615 -12.7988)",
          "--tw-mask-linear-to-color": "transparent",
          "--color-slate-900": "lab(7.78673% 1.82345 -15.0537)",
          "--tw-mask-linear-from-color": "black",
          "--color-stone-400": "lab(66.2166% 1.88044 3.20326)",
          "--color-green-100": "lab(96.1861% -13.8464 6.52365)",
          "--color-emerald-700": "lab(44.4871% -41.0396 11.0361)",
          "--tw-border-spacing-x": "0px",
          "--color-teal-50": "lab(98.3189% -4.74921 -.111711)",
          "--color-red-200": "lab(86.017% 19.8815 7.75869)",
          "--color-indigo-800": "lab(26.6645% 37.9804 -68.6402)",
          "--color-purple-900": "lab(24.9401% 45.2703 -51.2728)",
          "--color-violet-900": "lab(24.3783% 45.7525 -61.4902)",
          "--color-sky-800": "lab(35.164% -9.57692 -34.4068)",
          "--color-pink-800": "lab(34.9559% 60.2885 5.99639)",
          "--color-teal-800": "lab(35.5975% -26.6648 -4.34487)",
          "--color-stone-950": "lab(2.86037% .455312 .568903)",
          "--color-emerald-600": "lab(55.0481% -49.9246 15.93)",
          "--color-taupe-100": "lab(95.3391% .644386 .231409)",
          "--color-gray-50": "lab(98.2596% -.247031 -.706708)",
          "--color-violet-400": "lab(62.8239% 34.9159 -60.0512)",
          "--color-purple-100": "lab(93.3333% 6.97437 -9.83434)",
          "--color-pink-900": "lab(29.4367% 49.3962 3.35757)",
          "--color-lime-600": "lab(61.1055% -41.0235 73.1483)",
          "--tw-ring-offset-color": "#fff",
          "--color-red-400": "lab(63.7053% 60.745 31.3109)",
          "--color-fuchsia-50": "lab(97.1083% 4.46233 -4.09334)",
          "--color-indigo-50": "lab(95.4818% .411302 -6.78529)",
          "--color-lime-300": "lab(89.9218% -35.6546 68.5254)",
          "--color-mist-200": "lab(91.3368% -1.38441 -1.08377)",
          "--color-rose-100": "lab(92.8221% 9.86832 2.60075)",
          "--color-fuchsia-800": "lab(32.904% 60.2883 -43.6569)",
          "--color-teal-600": "lab(55.0223% -41.0774 -3.90277)",
          "--color-olive-400": "lab(69.6658% -2.009 7.72947)",
          "--color-emerald-100": "lab(94.9004% -17.0769 5.63836)",
          "--color-red-800": "lab(33.7174% 55.8993 41.0293)",
          "--color-red-500": "lab(55.4814% 75.0732 48.8528)",
          "--color-rose-400": "lab(64.4125% 63.0291 19.2068)",
          "--tw-ring-offset-width": "0px",
          "--color-olive-200": "lab(91.9397% -.686854 2.55626)",
          "--color-zinc-300": "lab(84.9837% .601262 -2.17986)",
          "--color-purple-950": "lab(14.8253% 38.9005 -44.5861)",
          "--color-mauve-200": "lab(90.8851% 1.40759 -1.05978)",
          "--color-rose-800": "lab(34.6481% 60.802 20.1957)",
          "--color-indigo-600": "lab(38.4009% 52.6132 -92.3857)",
          "--color-amber-800": "lab(37.8822% 37.1699 52.2718)",
          "--color-fuchsia-500": "lab(56.4256% 83.132 -64.639)",
          "--color-lime-500": "lab(75.3197% -46.6547 86.1778)",
          "--color-sky-700": "lab(41.6013% -9.10804 -42.5647)",
          "--tw-mask-top-from-color": "black",
          "--color-cyan-800": "lab(36.5114% -17.1989 -21.6292)",
          "--color-slate-50": "lab(98.1434% -.369519 -1.05966)",
          "--color-orange-300": "lab(80.8059% 21.7313 50.4455)",
          "--color-yellow-100": "lab(97.3564% -4.51407 27.344)",
          "--color-violet-700": "lab(35.2783% 67.9912 -88.793)",
          "--tw-ring-offset-shadow": "0 0 #0000",
          "--color-olive-700": "lab(29.8862% -2.11598 8.58277)",
          "--color-mist-900": "lab(9.32863% -1.87989 -2.1017)",
          "--color-taupe-200": "lab(90.9149% 1.38998 1.08777)",
          "--color-gray-800": "lab(16.1051% -1.18239 -11.7533)",
          "--color-zinc-500": "lab(47.8878% 1.65477 -5.77283)",
          "--color-stone-100": "lab(96.5286% -.0991821 .364268)",
          "--tw-mask-radial-to-color": "transparent",
          "--color-orange-700": "lab(46.4615% 57.7275 70.8507)",
          "--color-teal-700": "lab(44.4134% -33.1436 -4.22149)",
          "--color-green-50": "lab(98.1563% -5.60117 2.75915)",
          "--color-lime-700": "lab(47.246% -32.2589 55.8249)",
          "--color-indigo-950": "lab(12.4853% 14.9672 -31.3418)",
          "--color-zinc-800": "lab(15.7305% .613764 -2.16959)",
          "--color-mist-700": "lab(27.9503% -4.0026 -3.35106)",
          "--color-lime-900": "lab(31.9931% -20.7654 33.7379)",
          "--color-stone-500": "lab(48.1164% 2.35701 4.26852)",
          "--color-orange-950": "lab(14.1747% 23.4515 19.4461)",
          "--color-lime-50": "lab(98.7039% -5.32573 10.2149)",
          "--color-rose-50": "lab(96.2369% 4.94155 1.28011)",
          "--color-sky-100": "lab(94.3709% -4.56053 -8.23453)",
          "--color-emerald-950": "lab(15.0582% -17.9507 2.38369)",
          "--color-amber-500": "lab(72.7183% 31.8672 97.9407)",
          "--color-sky-900": "lab(29.1959% -8.34689 -28.2453)",
          "--color-orange-400": "lab(70.0429% 42.5156 75.8207)",
          "--color-mauve-400": "lab(66.2215% 5.18823 -4.27421)",
          "--color-cyan-100": "lab(95.3146% -13.8285 -6.84732)",
          "--color-yellow-700": "lab(47.8202% 25.2426 66.5015)",
          "--color-violet-100": "lab(93.0838% 4.35197 -9.88284)",
          "--color-rose-300": "lab(76.6339% 38.3549 9.68835)",
          "--color-slate-950": "lab(1.76974% 1.32743 -9.28855)",
          "--color-mist-50": "lab(98.5129% -.644743 -.229931)",
          "--color-olive-500": "lab(51.5272% -2.86695 11.5408)",
          "--color-green-800": "lab(37.4616% -36.7971 22.9692)",
          "--color-rose-500": "lab(56.101% 79.4328 31.4532)",
          "--color-mauve-950": "lab(2.70037% 1.13126 -.853461)",
          "--color-red-700": "lab(40.4273% 67.2623 53.7441)",
          "--color-slate-100": "lab(96.286% -.852436 -2.46847)",
          "--color-fuchsia-950": "lab(15.7348% 39.0235 -27.4073)",
          "--color-indigo-200": "lab(84.4329% 3.18977 -23.9688)",
          "--color-rose-600": "lab(49.1882% 81.577 36.0311)",
          "--color-blue-500": "lab(54.1736% 13.3369 -74.6839)",
          "--color-gray-900": "lab(8.11897% .811279 -12.254)",
          "--color-pink-700": "lab(42.1737% 71.8009 7.42233)",
          "--color-sky-950": "lab(17.8299% -5.31271 -21.1584)",
          "--color-blue-900": "lab(26.1542% 15.7545 -51.5504)",
          "--color-zinc-400": "lab(65.6464% 1.53497 -5.42429)",
          "--color-olive-600": "lab(38.2553% -2.31101 9.30823)",
          "--tw-mask-left-to-color": "transparent",
          "--color-lime-100": "lab(96.8662% -11.7133 22.0854)",
          "--color-yellow-900": "lab(32.3865% 21.1273 38.5959)",
          "--color-gray-700": "lab(27.1134% -.956401 -12.3224)",
          "--color-cyan-600": "lab(55.1767% -26.7496 -30.5139)",
          "--color-teal-300": "lab(84.8977% -48.1516 -1.3321)",
          "--color-red-100": "lab(92.243% 10.2865 3.83865)",
          "--color-amber-950": "lab(15.8111% 20.9107 23.3752)",
          "--color-purple-50": "lab(97.1627% 2.99937 -4.13398)",
          "--color-stone-200": "lab(91.055% .663072 .865579)",
          "--color-olive-800": "lab(17.3033% -1.48043 5.96187)",
          "--color-red-50": "lab(96.5005% 4.18508 1.52328)",
          "--color-green-300": "lab(86.9953% -47.2691 25.0054)",
          "--color-blue-200": "lab(86.15% -4.04379 -21.0797)",
          "--color-lime-400": "lab(83.7876% -45.0447 88.4738)",
          "--color-olive-900": "lab(10.5512% -1.19986 4.84231)",
          "--color-taupe-900": "lab(8.7711% 2.25864 2.3765)",
          "--tw-mask-conic-from-color": "black",
          "--color-red-950": "lab(13.003% 29.04 16.7519)",
          "--color-teal-200": "lab(90.7612% -33.1343 -.542295)",
          "--color-emerald-400": "lab(75.0771% -60.7313 19.4147)",
          "--color-gray-200": "lab(91.6229% -.159115 -2.26791)",
          "--color-fuchsia-900": "lab(27.755% 48.6174 -34.3553)",
          "--color-green-700": "lab(47.0329% -47.0239 31.4788)",
          "--color-fuchsia-100": "lab(93.9419% 9.57647 -9.08735)",
          "--color-fuchsia-400": "lab(66.1178% 66.0652 -52.4733)",
          "--color-purple-700": "lab(36.1758% 69.8525 -80.0381)",
          "--color-indigo-900": "lab(23.3911% 24.6978 -50.4718)",
          "--color-neutral-800": "lab(15.204% 0 -.00000596046)",
          "--color-mauve-700": "lab(25.8245% 8.01928 -6.32546)",
          "--color-teal-500": "lab(67.3859% -49.0983 -2.63511)",
          "--color-cyan-950": "lab(19.1528% -9.68757 -15.5267)",
          "--color-yellow-500": "lab(76.3898% 14.5258 98.4589)",
          "--color-sky-200": "lab(88.6983% -11.3978 -16.8488)",
          "--color-mist-950": "lab(2.93655% -.435196 -.608262)",
          "--tw-mask-conic-to-color": "transparent",
          "--color-blue-950": "lab(15.6723% 8.86232 -32.2945)",
          "--color-stone-300": "lab(84.7909% .928015 1.59738)",
          "--color-stone-50": "lab(98.2686% -.0991821 .364304)",
          "--color-amber-50": "lab(98.6252% -.635922 8.42309)",
          "--color-mist-500": "lab(49.1145% -5.80183 -4.41525)",
          "--color-amber-200": "lab(91.7203% -.505269 49.9084)",
          "--color-fuchsia-700": "lab(39.787% 72.2653 -53.1244)",
          "--tw-space-x-reverse": "0",
          "--spacing": ".25rem",
          "--tw-space-y-reverse": "0",
          "--tw-mask-radial-size": "farthest-corner",
          "--default-font-feature-settings": "\"cv02\", \"cv03\", \"cv04\", \"cv11\"",
          "--text-base--line-height": "calc(1.5 / 1)",
          "--font-mono": "\"plexMono\", \"plexMono Fallback\", monospace",
          "--tracking-wider": ".05em",
          "--text-9xl--line-height": "1",
          "--font-weight-bold": "700",
          "--font-weight-extralight": "200",
          "--text-xs--line-height": "calc(1 / .75)",
          "--text-xl": "1.25rem",
          "--leading-relaxed": "1.625",
          "--leading-snug": "1.375",
          "--text-9xl": "8rem",
          "--text-2xl--line-height": "calc(2 / 1.5)",
          "--text-shadow-xs": "0px 1px 1px #0003",
          "--text-8xl": "6rem",
          "--text-xl--line-height": "calc(1.75 / 1.25)",
          "--text-sm": ".875rem",
          "--leading-tight": "1.25",
          "--font-weight-thin": "100",
          "--text-4xl--line-height": "calc(2.5 / 2.25)",
          "--tw-text-shadow-alpha": "100%",
          "--tracking-tight": "-.025em",
          "--text-2xl": "1.5rem",
          "--text-7xl": "4.5rem",
          "--text-lg": "1.125rem",
          "--text-shadow-md": "0px 1px 1px #0000001a, 0px 1px 2px #0000001a, 0px 2px 4px #0000001a",
          "--text-8xl--line-height": "1",
          "--text-5xl--line-height": "1",
          "--leading-normal": "1.5",
          "--text-lg--line-height": "calc(1.75 / 1.125)",
          "--text-6xl": "3.75rem",
          "--default-font-family": "\"inter\", \"inter Fallback\", system-ui",
          "--font-weight-light": "300",
          "--font-inter": "\"inter\", \"inter Fallback\"",
          "--font-ubuntu-mono": "\"ubuntuMono\", \"ubuntuMono Fallback\"",
          "--text-shadow-2xs": "0px 1px 0px #00000026",
          "--text-7xl--line-height": "1",
          "--font-plex-mono": "\"plexMono\", \"plexMono Fallback\"",
          "--tracking-tighter": "-.05em",
          "--font-weight-black": "900",
          "--tracking-wide": ".025em",
          "--font-weight-semibold": "600",
          "--font-source-sans-pro": "\"source\", \"source Fallback\"",
          "--font-weight-extrabold": "800",
          "--text-4xl": "2.25rem",
          "--tracking-normal": "0em",
          "--text-sm--line-height": "calc(1.25 / .875)",
          "--text-shadow-lg": "0px 1px 2px #0000001a, 0px 3px 2px #0000001a, 0px 4px 8px #0000001a",
          "--text-5xl": "3rem",
          "--text-shadow-sm": "0px 1px 0px #00000013, 0px 1px 1px #00000013, 0px 2px 2px #00000013",
          "--text-3xl": "1.875rem",
          "--text-xs": ".75rem",
          "--tracking-widest": ".1em",
          "--font-weight-medium": "500",
          "--font-weight-normal": "400",
          "--font-serif": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
          "--text-3xl--line-height": "calc(2.25 / 1.875)",
          "--default-mono-font-feature-settings": "\"ss02\", \"zero\"",
          "--text-6xl--line-height": "1",
          "--leading-loose": "2",
          "--text-base": "1rem",
          "--default-mono-font-family": "\"plexMono\", \"plexMono Fallback\", monospace",
          "--tw-inset-shadow-alpha": "100%",
          "--shadow-xs": "0 1px 2px 0 #0000000d",
          "--tw-inset-shadow": "0 0 #0000",
          "--tw-shadow-alpha": "100%",
          "--drop-shadow-lg": "0 4px 4px #00000026",
          "--shadow-xl": "0 20px 25px -5px #0000001a, 0 8px 10px -6px #0000001a",
          "--drop-shadow-sm": "0 1px 2px #00000026",
          "--drop-shadow-xl": "0 9px 7px #0000001a",
          "--inset-shadow-xs": "inset 0 1px 1px #0000000d",
          "--inset-shadow-2xs": "inset 0 1px #0000000d",
          "--tw-drop-shadow-alpha": "100%",
          "--shadow-md": "0 4px 6px -1px #0000001a, 0 2px 4px -2px #0000001a",
          "--inset-shadow-sm": "inset 0 2px 4px #0000000d",
          "--drop-shadow-2xl": "0 25px 25px #00000026",
          "--shadow-lg": "0 10px 15px -3px #0000001a, 0 4px 6px -4px #0000001a",
          "--shadow-2xl": "0 25px 50px -12px #00000040",
          "--drop-shadow-md": "0 3px 3px #0000001f",
          "--drop-shadow-xs": "0 1px 1px #0000000d",
          "--tw-shadow": "0 0 #0000",
          "--shadow-2xs": "0 1px #0000000d",
          "--radius-4xl": "2rem",
          "--radius-2xl": "1rem",
          "--radius-3xl": "1.5rem",
          "--radius-xs": ".125rem",
          "--container-md": "28rem",
          "--tw-mask-left-to-position": "100%",
          "--aspect-video": "16 / 9",
          "--blur-lg": "16px",
          "--tw-mask-conic": "linear-gradient(#fff, #fff)",
          "--tw-outline-style": "solid",
          "--ease-in": "cubic-bezier(.4, 0, 1, 1)",
          "--tw-mask-conic-from-position": "0%",
          "--tw-mask-top-to-position": "100%",
          "--tw-gradient-from": "rgba(0, 0, 0, 0)",
          "--tw-gradient-to": "rgba(0, 0, 0, 0)",
          "--perspective-normal": "500px",
          "--blur-2xl": "40px",
          "--tw-mask-linear-from-position": "0%",
          "--tw-gradient-via-position": "50%",
          "--tw-mask-right": "linear-gradient(#fff, #fff)",
          "--tw-gradient-to-position": "100%",
          "--default-transition-duration": ".15s",
          "--animate-pulse": "pulse 2s cubic-bezier(.4, 0, .6, 1) infinite",
          "--container-xs": "20rem",
          "--default-transition-timing-function": "cubic-bezier(.4, 0, .2, 1)",
          "--perspective-dramatic": "100px",
          "--tw-translate-z": "0",
          "--tw-gradient-via": "rgba(0, 0, 0, 0)",
          "--tw-scale-y": "1",
          "--tw-mask-radial": "linear-gradient(#fff, #fff)",
          "--container-6xl": "72rem",
          "--breakpoint-lg": "64rem",
          "--container-3xl": "48rem",
          "--blur-xs": "4px",
          "--tw-translate-y": "0",
          "--ease-out": "cubic-bezier(0, 0, .2, 1)",
          "--tw-content": "\"\"",
          "--tw-mask-top": "linear-gradient(#fff, #fff)",
          "--tw-mask-linear-position": "0deg",
          "--tw-translate-x": "0",
          "--animate-flash-code": "flash-code 2s forwards",
          "--container-3xs": "16rem",
          "--tw-mask-right-from-position": "0%",
          "--animate-bounce": "bounce 1s infinite",
          "--tw-mask-radial-shape": "ellipse",
          "--container-xl": "36rem",
          "--tw-mask-linear": "linear-gradient(#fff, #fff)",
          "--breakpoint-xl": "80rem",
          "--lightningcss-dark": "",
          "--animate-ping": "ping 1s cubic-bezier(0, 0, .2, 1) infinite",
          "--tw-mask-left-from-position": "0%",
          "--blur-xl": "24px",
          "--tw-divide-x-reverse": "0",
          "--breakpoint-2xl": "96rem",
          "--tw-mask-bottom-to-position": "100%",
          "--tw-mask-conic-position": "0deg",
          "--blur-3xl": "64px",
          "--tw-scale-z": "1",
          "--container-sm": "24rem",
          "--tw-scroll-snap-strictness": "proximity",
          "--container-lg": "32rem",
          "--perspective-midrange": "800px",
          "--tw-gradient-from-position": "0%",
          "--ease-in-out": "cubic-bezier(.4, 0, .2, 1)",
          "--tw-mask-radial-from-position": "0%",
          "--tw-mask-linear-to-position": "100%",
          "--tw-mask-radial-position": "center",
          "--tw-mask-right-to-position": "100%",
          "--container-5xl": "64rem",
          "--perspective-distant": "1200px",
          "--blur-md": "12px",
          "--tw-mask-radial-to-position": "100%",
          "--container-2xs": "18rem",
          "--container-4xl": "56rem",
          "--animate-spin": "spin 1s linear infinite",
          "--tw-mask-left": "linear-gradient(#fff, #fff)",
          "--lightningcss-light": "initial",
          "--perspective-near": "300px",
          "--tw-mask-bottom-from-position": "0%",
          "--tw-divide-y-reverse": "0",
          "--breakpoint-md": "48rem",
          "--tw-mask-conic-to-position": "100%",
          "--container-2xl": "42rem",
          "--tw-mask-top-from-position": "0%",
          "--tw-scale-x": "1",
          "--tw-mask-bottom": "linear-gradient(#fff, #fff)",
          "--breakpoint-sm": "40rem",
          "--container-7xl": "80rem",
          "--blur-sm": "8px"
        },
        "meta": {
          "extractedAt": "2026-05-08T20:57:21.897Z"
        }
      },
      "dark": {
        "colors": {
          "background": "hsl(224, 71%, 4%)",
          "foreground": "hsl(0, 0%, 100%)",
          "primary": "hsl(340, 93%, 48%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(210, 100%, 50%)",
          "secondary-foreground": "hsl(0, 0%, 100%)",
          "accent": "hsl(205, 100%, 59%)",
          "accent-foreground": "hsl(0, 0%, 100%)",
          "muted": "hsl(210, 100%, 0%)",
          "muted-foreground": "hsl(0, 0%, 100%)",
          "border": "hsl(210, 100%, 0%)"
        },
        "allVars": {
          "--color-primary": "#ec0853",
          "--color-secondary": "#0080ff",
          "--color-accent": "#2ca8ff",
          "--color-neutral-50": "lab(98.26% 0 0)",
          "--color-neutral-100": "lab(96.52% -.0000298023 .0000119209)",
          "--color-bg": "#ffffff",
          "--color-bg-1": "#000102",
          "--color-bg-2": "#ec0853",
          "--color-text": "#ffffff",
          "--font-sans": "\"inter\", \"inter Fallback\", system-ui",
          "--font-body": "'plexMono', sans-serif",
          "--font-size-96": "96px",
          "--font-size-40": "40px",
          "--font-size-36": "36px",
          "--font-size-30": "30px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-17": "17px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--spacing-1": "1px",
          "--spacing-57": "57px",
          "--spacing-64": "64px",
          "--spacing-72": "72px",
          "--spacing-96": "96px",
          "--spacing-160": "160px",
          "--spacing-336": "336px",
          "--spacing-400": "400px",
          "--radius-sm": ".25rem",
          "--radius-md": ".375rem",
          "--radius-lg": ".5rem",
          "--radius-xl": ".75rem",
          "--radius-full": "32px",
          "--shadow-sm": "0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a",
          "--color-purple-200": "lab(87.8405% 13.4282 -18.7159)",
          "--color-purple-300": "lab(78.3298% 26.2195 -34.9499)",
          "--color-mauve-800": "lab(14.1786% 6.35938 -5.68258)",
          "--color-zinc-100": "lab(96.1634% .0993311 -.364041)",
          "--color-zinc-200": "lab(90.6853% .399232 -1.45452)",
          "--color-rose-200": "lab(86.806% 19.1909 4.07754)",
          "--color-slate-200": "lab(91.7353% -.998765 -4.76968)",
          "--tw-mask-bottom-to-color": "transparent",
          "--color-sky-500": "lab(63.3038% -18.433 -51.0407)",
          "--color-pink-500": "lab(56.9303% 76.8162 -8.07021)",
          "--color-orange-600": "lab(57.1026% 64.2584 89.8886)",
          "--color-violet-600": "lab(41.088% 68.9966 -91.995)",
          "--color-red-900": "lab(28.5139% 44.5539 29.0463)",
          "--color-neutral-600": "lab(34.924% 0 0)",
          "--color-orange-800": "lab(37.1566% 46.6433 50.5562)",
          "--color-mauve-600": "lab(34.0653% 7.82093 -6.65653)",
          "--tw-mask-bottom-from-color": "black",
          "--color-olive-50": "lab(98.6338% -.297457 1.09334)",
          "--color-pink-950": "lab(15.6116% 35.2166 3.53979)",
          "--color-blue-700": "lab(36.9089% 35.0961 -85.6872)",
          "--color-teal-400": "lab(76.0109% -53.3483 -2.27906)",
          "--color-neutral-300": "lab(84.92% 0 -.0000119209)",
          "--color-taupe-600": "lab(34.6954% 4.49754 4.2051)",
          "--color-slate-500": "lab(48.0876% -2.03595 -16.5814)",
          "--color-purple-800": "lab(30.6017% 56.7637 -64.4751)",
          "--color-orange-900": "lab(30.2951% 36.0434 37.671)",
          "--color-mauve-50": "lab(98.26% 0 0)",
          "--tw-inset-ring-shadow": "0 0 #0000",
          "--color-orange-50": "lab(97.7008% 1.53735 5.90649)",
          "--color-blue-300": "lab(77.5052% -6.4629 -36.42)",
          "--color-cyan-700": "lab(44.7267% -21.5987 -26.118)",
          "--color-neutral-200": "lab(90.952% 0 -.0000119209)",
          "--color-gray-300": "lab(85.1236% -.612259 -3.7138)",
          "--color-yellow-400": "lab(83.2664% 8.65132 106.895)",
          "--color-slate-300": "lab(84.7652% -1.94535 -7.93337)",
          "--color-mist-600": "lab(36.3261% -4.71437 -3.54635)",
          "--color-amber-300": "lab(86.4156% 6.13147 78.3961)",
          "--color-taupe-400": "lab(66.7386% 3.56972 3.57119)",
          "--color-gray-500": "lab(47.7841% -.393182 -10.0268)",
          "--color-cyan-200": "lab(91.0821% -24.0435 -12.8306)",
          "--color-olive-100": "lab(96.0988% -.493258 1.82395)",
          "--color-zinc-50": "lab(98.26% 0 0)",
          "--color-green-500": "lab(70.5521% -66.5147 45.8073)",
          "--color-white": "#fff",
          "--color-sky-600": "lab(51.7754% -11.4712 -49.8349)",
          "--color-gray-400": "lab(65.9269% -.832707 -8.17473)",
          "--color-blue-400": "lab(65.0361% -1.42065 -56.9802)",
          "--color-slate-400": "lab(65.5349% -2.25151 -14.5072)",
          "--color-pink-50": "lab(96.4459% 4.53997 -1.49434)",
          "--color-stone-900": "lab(9.03835% 1.15298 1.92955)",
          "--color-taupe-700": "lab(26.4543% 4.4374 3.65548)",
          "--color-yellow-300": "lab(89.7033% -.480294 84.4917)",
          "--color-zinc-950": "lab(2.51107% .242703 -.886115)",
          "--color-gray-100": "lab(96.1596% -.0823438 -1.13575)",
          "--color-teal-950": "lab(16.6371% -15.3183 -3.81732)",
          "--color-taupe-300": "lab(84.6434% 1.81875 1.71728)",
          "--color-emerald-200": "lab(90.2247% -31.039 9.47084)",
          "--color-purple-600": "lab(43.0295% 75.21 -86.5669)",
          "--tw-mask-left-from-color": "black",
          "--color-violet-800": "lab(29.3188% 57.7986 -76.1493)",
          "--color-mist-300": "lab(85.1957% -1.8006 -1.71063)",
          "--color-teal-900": "lab(29.506% -21.4706 -3.59886)",
          "--color-zinc-700": "lab(26.8019% 1.35387 -4.68303)",
          "--color-neutral-700": "lab(27.036% 0 0)",
          "--color-violet-500": "lab(49.9355% 55.1776 -81.8963)",
          "--color-fuchsia-600": "lab(47.5131% 83.4271 -63.0363)",
          "--color-sky-50": "lab(97.3623% -2.33802 -4.13098)",
          "--color-lime-200": "lab(94.0718% -22.5338 42.5238)",
          "--color-fuchsia-200": "lab(87.7108% 19.9958 -18.2054)",
          "--color-green-900": "lab(30.797% -29.6927 17.382)",
          "--color-taupe-950": "lab(2.86039% .454858 .569314)",
          "--color-rose-950": "lab(14.2323% 34.0086 9.80922)",
          "--color-blue-800": "lab(30.2514% 27.7853 -70.2699)",
          "--color-pink-100": "lab(93.5864% 9.01193 -3.15079)",
          "--color-neutral-900": "lab(7.78201% -.0000149012 0)",
          "--color-cyan-50": "lab(98.3304% -5.97432 -2.62108)",
          "--color-blue-100": "lab(92.0301% -2.24757 -11.6453)",
          "--color-green-600": "lab(59.0978% -58.6621 41.2579)",
          "--color-green-950": "lab(15.6845% -20.4225 11.7249)",
          "--color-taupe-500": "lab(47.3292% 5.2588 5.60027)",
          "--color-yellow-950": "lab(16.8146% 15.7422 23.1133)",
          "--color-violet-950": "lab(14.0706% 33.3353 -46.7553)",
          "--color-violet-300": "lab(76.7419% 18.3911 -37.0706)",
          "--color-zinc-900": "lab(8.30603% .618205 -2.16572)",
          "--color-red-300": "lab(76.5514% 36.422 15.5335)",
          "--color-sky-300": "lab(80.3307% -20.2945 -31.385)",
          "--color-cyan-500": "lab(67.805% -35.3952 -30.2018)",
          "--color-orange-500": "lab(64.272% 57.1788 90.3583)",
          "--color-slate-800": "lab(16.132% -.318035 -14.6672)",
          "--color-olive-300": "lab(86.1731% -1.073 4.02397)",
          "--color-lime-800": "lab(37.7655% -25.1694 43.0683)",
          "--color-emerald-900": "lab(28.8637% -26.9249 5.45986)",
          "--color-sky-400": "lab(70.687% -23.6078 -45.9483)",
          "--color-mist-800": "lab(15.9728% -2.89693 -2.50866)",
          "--tw-mask-right-from-color": "black",
          "--color-slate-600": "lab(35.5623% -1.74978 -15.4316)",
          "--color-taupe-50": "lab(98.3763% .249773 .707853)",
          "--color-pink-600": "lab(49.5493% 79.8381 2.31768)",
          "--color-pink-200": "lab(87.4504% 19.6 -6.46662)",
          "--color-stone-600": "lab(35.5168% 1.08604 4.07829)",
          "--color-olive-950": "lab(3.26204% -.309289 1.13377)",
          "--color-mauve-500": "lab(46.4092% 9.24578 -7.68465)",
          "--color-rose-900": "lab(29.7104% 51.514 12.6253)",
          "--color-green-400": "lab(78.503% -64.9265 39.7492)",
          "--color-emerald-500": "lab(66.9756% -58.27 19.5419)",
          "--color-yellow-50": "lab(98.6846% -1.79055 9.7766)",
          "--color-mauve-300": "lab(84.1787% 3.38054 -2.53499)",
          "--color-gray-950": "lab(1.90334% .278696 -5.48866)",
          "--color-rose-700": "lab(41.1651% 71.6251 30.3087)",
          "--color-amber-700": "lab(47.2709% 42.9082 69.2966)",
          "--color-amber-900": "lab(31.2288% 30.2627 40.0378)",
          "--color-mauve-100": "lab(95.3199% .844389 -.636518)",
          "--color-emerald-50": "lab(97.8462% -6.94966 1.85487)",
          "--color-zinc-600": "lab(35.1166% 1.78212 -6.1173)",
          "--color-violet-200": "lab(87.0888% 8.53688 -19.4189)",
          "--color-gray-600": "lab(35.6337% -1.58697 -10.8425)",
          "--color-orange-100": "lab(94.7127% 3.58394 14.3151)",
          "--color-purple-400": "lab(63.6946% 47.6127 -59.2066)",
          "--color-yellow-200": "lab(94.3433% -5.00429 52.9663)",
          "--tw-mask-top-to-color": "transparent",
          "--color-blue-600": "lab(44.0605% 29.0279 -86.0352)",
          "--color-indigo-500": "lab(48.295% 38.3129 -81.9673)",
          "--color-green-200": "lab(92.4222% -26.4702 12.9427)",
          "--tw-border-style": "solid",
          "--color-cyan-900": "lab(30.372% -13.1853 -18.7887)",
          "--color-red-600": "lab(48.4493% 77.4328 61.5452)",
          "--color-blue-50": "lab(96.492% -1.14644 -5.11479)",
          "--color-stone-700": "lab(27.3812% 1.32917 3.57789)",
          "--color-indigo-700": "lab(32.4486% 49.2217 -84.6695)",
          "--color-neutral-950": "lab(2.75381% 0 0)",
          "--color-black": "#000",
          "--color-neutral-400": "lab(66.128% -.0000298023 .0000119209)",
          "--tw-mask-right-to-color": "transparent",
          "--tw-border-spacing-y": "0px",
          "--color-fuchsia-300": "lab(78.5378% 39.3533 -32.9615)",
          "--color-amber-100": "lab(95.916% -1.21653 23.111)",
          "--color-mist-400": "lab(67.9697% -3.85058 -3.02824)",
          "--color-stone-800": "lab(15.0353% 1.96067 1.53427)",
          "--color-mist-100": "lab(95.7289% -.644743 -.229919)",
          "--color-indigo-100": "lab(91.6577% 1.04591 -12.7199)",
          "--color-mauve-900": "lab(8.33002% 5.15411 -4.30998)",
          "--color-emerald-800": "lab(35.3675% -33.1188 8.04002)",
          "--color-taupe-800": "lab(15.0089% 3.01889 2.55873)",
          "--color-violet-50": "lab(96.2416% 2.28849 -5.51657)",
          "--color-teal-100": "lab(95.1845% -17.4212 -.425422)",
          "--color-cyan-400": "lab(76.6045% -40.9406 -29.6231)",
          "--color-cyan-300": "lab(85.3886% -36.7636 -21.5716)",
          "--color-amber-400": "lab(80.1641% 16.6016 99.2089)",
          "--tw-ring-shadow": "0 0 #0000",
          "--color-indigo-400": "lab(59.866% 22.4834 -64.4485)",
          "--color-indigo-300": "lab(74.0235% 8.54138 -41.6075)",
          "--color-purple-500": "lab(52.0183% 66.11 -78.2316)",
          "--color-orange-200": "lab(88.4871% 9.94918 28.8378)",
          "--tw-mask-radial-from-color": "black",
          "--color-emerald-300": "lab(83.9203% -48.7124 13.8849)",
          "--color-yellow-600": "lab(62.7799% 22.4197 86.1544)",
          "--color-lime-950": "lab(16.5113% -15.1841 22.0145)",
          "--color-slate-700": "lab(26.9569% -1.47016 -15.6993)",
          "--color-pink-300": "lab(77.8308% 38.525 -10.5394)",
          "--color-neutral-500": "lab(48.496% 0 0)",
          "--color-amber-600": "lab(60.3514% 40.5624 87.1228)",
          "--color-yellow-800": "lab(38.7484% 23.5833 51.4916)",
          "--color-pink-400": "lab(64.5597% 64.3615 -12.7988)",
          "--tw-mask-linear-to-color": "transparent",
          "--color-slate-900": "lab(7.78673% 1.82345 -15.0537)",
          "--tw-mask-linear-from-color": "black",
          "--color-stone-400": "lab(66.2166% 1.88044 3.20326)",
          "--color-green-100": "lab(96.1861% -13.8464 6.52365)",
          "--color-emerald-700": "lab(44.4871% -41.0396 11.0361)",
          "--tw-border-spacing-x": "0px",
          "--color-teal-50": "lab(98.3189% -4.74921 -.111711)",
          "--color-red-200": "lab(86.017% 19.8815 7.75869)",
          "--color-indigo-800": "lab(26.6645% 37.9804 -68.6402)",
          "--color-purple-900": "lab(24.9401% 45.2703 -51.2728)",
          "--color-violet-900": "lab(24.3783% 45.7525 -61.4902)",
          "--color-sky-800": "lab(35.164% -9.57692 -34.4068)",
          "--color-pink-800": "lab(34.9559% 60.2885 5.99639)",
          "--color-teal-800": "lab(35.5975% -26.6648 -4.34487)",
          "--color-stone-950": "lab(2.86037% .455312 .568903)",
          "--color-taupe-100": "lab(95.3391% .644386 .231409)",
          "--color-emerald-600": "lab(55.0481% -49.9246 15.93)",
          "--color-gray-50": "lab(98.2596% -.247031 -.706708)",
          "--color-violet-400": "lab(62.8239% 34.9159 -60.0512)",
          "--color-lime-600": "lab(61.1055% -41.0235 73.1483)",
          "--color-purple-100": "lab(93.3333% 6.97437 -9.83434)",
          "--color-pink-900": "lab(29.4367% 49.3962 3.35757)",
          "--tw-ring-offset-color": "#fff",
          "--color-red-400": "lab(63.7053% 60.745 31.3109)",
          "--color-fuchsia-50": "lab(97.1083% 4.46233 -4.09334)",
          "--color-indigo-50": "lab(95.4818% .411302 -6.78529)",
          "--color-lime-300": "lab(89.9218% -35.6546 68.5254)",
          "--color-teal-600": "lab(55.0223% -41.0774 -3.90277)",
          "--color-mist-200": "lab(91.3368% -1.38441 -1.08377)",
          "--color-rose-100": "lab(92.8221% 9.86832 2.60075)",
          "--color-fuchsia-800": "lab(32.904% 60.2883 -43.6569)",
          "--color-olive-400": "lab(69.6658% -2.009 7.72947)",
          "--color-emerald-100": "lab(94.9004% -17.0769 5.63836)",
          "--color-red-800": "lab(33.7174% 55.8993 41.0293)",
          "--color-red-500": "lab(55.4814% 75.0732 48.8528)",
          "--color-rose-400": "lab(64.4125% 63.0291 19.2068)",
          "--tw-ring-offset-width": "0px",
          "--color-olive-200": "lab(91.9397% -.686854 2.55626)",
          "--color-purple-950": "lab(14.8253% 38.9005 -44.5861)",
          "--color-zinc-300": "lab(84.9837% .601262 -2.17986)",
          "--color-mauve-200": "lab(90.8851% 1.40759 -1.05978)",
          "--color-rose-800": "lab(34.6481% 60.802 20.1957)",
          "--color-amber-800": "lab(37.8822% 37.1699 52.2718)",
          "--color-indigo-600": "lab(38.4009% 52.6132 -92.3857)",
          "--color-fuchsia-500": "lab(56.4256% 83.132 -64.639)",
          "--color-lime-500": "lab(75.3197% -46.6547 86.1778)",
          "--color-sky-700": "lab(41.6013% -9.10804 -42.5647)",
          "--tw-mask-top-from-color": "black",
          "--color-cyan-800": "lab(36.5114% -17.1989 -21.6292)",
          "--color-slate-50": "lab(98.1434% -.369519 -1.05966)",
          "--color-orange-300": "lab(80.8059% 21.7313 50.4455)",
          "--color-yellow-100": "lab(97.3564% -4.51407 27.344)",
          "--color-violet-700": "lab(35.2783% 67.9912 -88.793)",
          "--tw-ring-offset-shadow": "0 0 #0000",
          "--color-olive-700": "lab(29.8862% -2.11598 8.58277)",
          "--color-mist-900": "lab(9.32863% -1.87989 -2.1017)",
          "--color-taupe-200": "lab(90.9149% 1.38998 1.08777)",
          "--color-gray-800": "lab(16.1051% -1.18239 -11.7533)",
          "--color-zinc-500": "lab(47.8878% 1.65477 -5.77283)",
          "--color-stone-100": "lab(96.5286% -.0991821 .364268)",
          "--tw-mask-radial-to-color": "transparent",
          "--color-orange-700": "lab(46.4615% 57.7275 70.8507)",
          "--color-green-50": "lab(98.1563% -5.60117 2.75915)",
          "--color-teal-700": "lab(44.4134% -33.1436 -4.22149)",
          "--color-lime-700": "lab(47.246% -32.2589 55.8249)",
          "--color-mist-700": "lab(27.9503% -4.0026 -3.35106)",
          "--color-zinc-800": "lab(15.7305% .613764 -2.16959)",
          "--color-indigo-950": "lab(12.4853% 14.9672 -31.3418)",
          "--color-lime-900": "lab(31.9931% -20.7654 33.7379)",
          "--color-stone-500": "lab(48.1164% 2.35701 4.26852)",
          "--color-orange-950": "lab(14.1747% 23.4515 19.4461)",
          "--color-lime-50": "lab(98.7039% -5.32573 10.2149)",
          "--color-rose-50": "lab(96.2369% 4.94155 1.28011)",
          "--color-sky-100": "lab(94.3709% -4.56053 -8.23453)",
          "--color-emerald-950": "lab(15.0582% -17.9507 2.38369)",
          "--color-amber-500": "lab(72.7183% 31.8672 97.9407)",
          "--color-orange-400": "lab(70.0429% 42.5156 75.8207)",
          "--color-sky-900": "lab(29.1959% -8.34689 -28.2453)",
          "--color-mauve-400": "lab(66.2215% 5.18823 -4.27421)",
          "--color-cyan-100": "lab(95.3146% -13.8285 -6.84732)",
          "--color-yellow-700": "lab(47.8202% 25.2426 66.5015)",
          "--color-violet-100": "lab(93.0838% 4.35197 -9.88284)",
          "--color-rose-300": "lab(76.6339% 38.3549 9.68835)",
          "--color-slate-950": "lab(1.76974% 1.32743 -9.28855)",
          "--color-mist-50": "lab(98.5129% -.644743 -.229931)",
          "--color-olive-500": "lab(51.5272% -2.86695 11.5408)",
          "--color-green-800": "lab(37.4616% -36.7971 22.9692)",
          "--color-rose-500": "lab(56.101% 79.4328 31.4532)",
          "--color-mauve-950": "lab(2.70037% 1.13126 -.853461)",
          "--color-red-700": "lab(40.4273% 67.2623 53.7441)",
          "--color-slate-100": "lab(96.286% -.852436 -2.46847)",
          "--color-fuchsia-950": "lab(15.7348% 39.0235 -27.4073)",
          "--color-indigo-200": "lab(84.4329% 3.18977 -23.9688)",
          "--color-rose-600": "lab(49.1882% 81.577 36.0311)",
          "--color-blue-500": "lab(54.1736% 13.3369 -74.6839)",
          "--color-gray-900": "lab(8.11897% .811279 -12.254)",
          "--color-pink-700": "lab(42.1737% 71.8009 7.42233)",
          "--color-sky-950": "lab(17.8299% -5.31271 -21.1584)",
          "--color-blue-900": "lab(26.1542% 15.7545 -51.5504)",
          "--color-zinc-400": "lab(65.6464% 1.53497 -5.42429)",
          "--color-olive-600": "lab(38.2553% -2.31101 9.30823)",
          "--tw-mask-left-to-color": "transparent",
          "--color-lime-100": "lab(96.8662% -11.7133 22.0854)",
          "--color-yellow-900": "lab(32.3865% 21.1273 38.5959)",
          "--color-gray-700": "lab(27.1134% -.956401 -12.3224)",
          "--color-cyan-600": "lab(55.1767% -26.7496 -30.5139)",
          "--color-olive-800": "lab(17.3033% -1.48043 5.96187)",
          "--color-red-100": "lab(92.243% 10.2865 3.83865)",
          "--color-teal-300": "lab(84.8977% -48.1516 -1.3321)",
          "--color-amber-950": "lab(15.8111% 20.9107 23.3752)",
          "--color-purple-50": "lab(97.1627% 2.99937 -4.13398)",
          "--color-stone-200": "lab(91.055% .663072 .865579)",
          "--color-red-50": "lab(96.5005% 4.18508 1.52328)",
          "--color-green-300": "lab(86.9953% -47.2691 25.0054)",
          "--color-blue-200": "lab(86.15% -4.04379 -21.0797)",
          "--color-lime-400": "lab(83.7876% -45.0447 88.4738)",
          "--color-olive-900": "lab(10.5512% -1.19986 4.84231)",
          "--color-taupe-900": "lab(8.7711% 2.25864 2.3765)",
          "--tw-mask-conic-from-color": "black",
          "--color-red-950": "lab(13.003% 29.04 16.7519)",
          "--color-teal-200": "lab(90.7612% -33.1343 -.542295)",
          "--color-emerald-400": "lab(75.0771% -60.7313 19.4147)",
          "--color-gray-200": "lab(91.6229% -.159115 -2.26791)",
          "--color-fuchsia-900": "lab(27.755% 48.6174 -34.3553)",
          "--color-indigo-900": "lab(23.3911% 24.6978 -50.4718)",
          "--color-fuchsia-100": "lab(93.9419% 9.57647 -9.08735)",
          "--color-fuchsia-400": "lab(66.1178% 66.0652 -52.4733)",
          "--color-green-700": "lab(47.0329% -47.0239 31.4788)",
          "--color-purple-700": "lab(36.1758% 69.8525 -80.0381)",
          "--color-neutral-800": "lab(15.204% 0 -.00000596046)",
          "--color-mauve-700": "lab(25.8245% 8.01928 -6.32546)",
          "--color-teal-500": "lab(67.3859% -49.0983 -2.63511)",
          "--color-cyan-950": "lab(19.1528% -9.68757 -15.5267)",
          "--color-yellow-500": "lab(76.3898% 14.5258 98.4589)",
          "--color-sky-200": "lab(88.6983% -11.3978 -16.8488)",
          "--color-mist-950": "lab(2.93655% -.435196 -.608262)",
          "--tw-mask-conic-to-color": "transparent",
          "--color-blue-950": "lab(15.6723% 8.86232 -32.2945)",
          "--color-stone-300": "lab(84.7909% .928015 1.59738)",
          "--color-stone-50": "lab(98.2686% -.0991821 .364304)",
          "--color-amber-50": "lab(98.6252% -.635922 8.42309)",
          "--color-mist-500": "lab(49.1145% -5.80183 -4.41525)",
          "--color-amber-200": "lab(91.7203% -.505269 49.9084)",
          "--color-fuchsia-700": "lab(39.787% 72.2653 -53.1244)",
          "--tw-space-x-reverse": "0",
          "--spacing": ".25rem",
          "--tw-space-y-reverse": "0",
          "--tw-mask-radial-size": "farthest-corner",
          "--default-font-feature-settings": "\"cv02\", \"cv03\", \"cv04\", \"cv11\"",
          "--text-base--line-height": "calc(1.5 / 1)",
          "--font-mono": "\"plexMono\", \"plexMono Fallback\", monospace",
          "--tracking-wider": ".05em",
          "--text-9xl--line-height": "1",
          "--font-weight-bold": "700",
          "--font-weight-extralight": "200",
          "--text-xs--line-height": "calc(1 / .75)",
          "--text-xl": "1.25rem",
          "--leading-relaxed": "1.625",
          "--leading-snug": "1.375",
          "--text-9xl": "8rem",
          "--text-2xl--line-height": "calc(2 / 1.5)",
          "--text-shadow-xs": "0px 1px 1px #0003",
          "--text-8xl": "6rem",
          "--text-xl--line-height": "calc(1.75 / 1.25)",
          "--text-sm": ".875rem",
          "--leading-tight": "1.25",
          "--font-weight-thin": "100",
          "--text-4xl--line-height": "calc(2.5 / 2.25)",
          "--tw-text-shadow-alpha": "100%",
          "--tracking-tight": "-.025em",
          "--text-2xl": "1.5rem",
          "--text-7xl": "4.5rem",
          "--text-lg": "1.125rem",
          "--text-shadow-md": "0px 1px 1px #0000001a, 0px 1px 2px #0000001a, 0px 2px 4px #0000001a",
          "--text-8xl--line-height": "1",
          "--text-5xl--line-height": "1",
          "--leading-normal": "1.5",
          "--text-lg--line-height": "calc(1.75 / 1.125)",
          "--text-6xl": "3.75rem",
          "--default-font-family": "\"inter\", \"inter Fallback\", system-ui",
          "--font-weight-light": "300",
          "--font-ubuntu-mono": "\"ubuntuMono\", \"ubuntuMono Fallback\"",
          "--font-inter": "\"inter\", \"inter Fallback\"",
          "--text-shadow-2xs": "0px 1px 0px #00000026",
          "--text-7xl--line-height": "1",
          "--font-plex-mono": "\"plexMono\", \"plexMono Fallback\"",
          "--tracking-tighter": "-.05em",
          "--font-weight-black": "900",
          "--tracking-wide": ".025em",
          "--font-weight-semibold": "600",
          "--font-source-sans-pro": "\"source\", \"source Fallback\"",
          "--font-weight-extrabold": "800",
          "--text-4xl": "2.25rem",
          "--tracking-normal": "0em",
          "--text-sm--line-height": "calc(1.25 / .875)",
          "--text-shadow-lg": "0px 1px 2px #0000001a, 0px 3px 2px #0000001a, 0px 4px 8px #0000001a",
          "--text-5xl": "3rem",
          "--text-shadow-sm": "0px 1px 0px #00000013, 0px 1px 1px #00000013, 0px 2px 2px #00000013",
          "--text-3xl": "1.875rem",
          "--text-xs": ".75rem",
          "--tracking-widest": ".1em",
          "--font-weight-medium": "500",
          "--font-weight-normal": "400",
          "--font-serif": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
          "--text-3xl--line-height": "calc(2.25 / 1.875)",
          "--default-mono-font-feature-settings": "\"ss02\", \"zero\"",
          "--text-6xl--line-height": "1",
          "--leading-loose": "2",
          "--text-base": "1rem",
          "--default-mono-font-family": "\"plexMono\", \"plexMono Fallback\", monospace",
          "--tw-inset-shadow-alpha": "100%",
          "--shadow-xs": "0 1px 2px 0 #0000000d",
          "--tw-inset-shadow": "0 0 #0000",
          "--tw-shadow-alpha": "100%",
          "--drop-shadow-lg": "0 4px 4px #00000026",
          "--shadow-xl": "0 20px 25px -5px #0000001a, 0 8px 10px -6px #0000001a",
          "--drop-shadow-sm": "0 1px 2px #00000026",
          "--drop-shadow-xl": "0 9px 7px #0000001a",
          "--inset-shadow-xs": "inset 0 1px 1px #0000000d",
          "--inset-shadow-2xs": "inset 0 1px #0000000d",
          "--tw-drop-shadow-alpha": "100%",
          "--shadow-md": "0 4px 6px -1px #0000001a, 0 2px 4px -2px #0000001a",
          "--inset-shadow-sm": "inset 0 2px 4px #0000000d",
          "--drop-shadow-2xl": "0 25px 25px #00000026",
          "--shadow-lg": "0 10px 15px -3px #0000001a, 0 4px 6px -4px #0000001a",
          "--shadow-2xl": "0 25px 50px -12px #00000040",
          "--drop-shadow-md": "0 3px 3px #0000001f",
          "--drop-shadow-xs": "0 1px 1px #0000000d",
          "--tw-shadow": "0 0 #0000",
          "--shadow-2xs": "0 1px #0000000d",
          "--radius-4xl": "2rem",
          "--radius-2xl": "1rem",
          "--radius-3xl": "1.5rem",
          "--radius-xs": ".125rem",
          "--container-md": "28rem",
          "--tw-mask-left-to-position": "100%",
          "--aspect-video": "16 / 9",
          "--blur-lg": "16px",
          "--tw-mask-conic": "linear-gradient(#fff, #fff)",
          "--tw-outline-style": "solid",
          "--ease-in": "cubic-bezier(.4, 0, 1, 1)",
          "--tw-mask-conic-from-position": "0%",
          "--tw-mask-top-to-position": "100%",
          "--tw-gradient-from": "rgba(0, 0, 0, 0)",
          "--tw-gradient-to": "rgba(0, 0, 0, 0)",
          "--perspective-normal": "500px",
          "--blur-2xl": "40px",
          "--tw-mask-linear-from-position": "0%",
          "--tw-gradient-via-position": "50%",
          "--tw-mask-right": "linear-gradient(#fff, #fff)",
          "--tw-gradient-to-position": "100%",
          "--default-transition-duration": ".15s",
          "--animate-pulse": "pulse 2s cubic-bezier(.4, 0, .6, 1) infinite",
          "--container-xs": "20rem",
          "--default-transition-timing-function": "cubic-bezier(.4, 0, .2, 1)",
          "--perspective-dramatic": "100px",
          "--tw-translate-z": "0",
          "--tw-gradient-via": "rgba(0, 0, 0, 0)",
          "--tw-scale-y": "1",
          "--tw-mask-radial": "linear-gradient(#fff, #fff)",
          "--container-6xl": "72rem",
          "--breakpoint-lg": "64rem",
          "--container-3xl": "48rem",
          "--blur-xs": "4px",
          "--tw-translate-y": "0",
          "--ease-out": "cubic-bezier(0, 0, .2, 1)",
          "--tw-content": "\"\"",
          "--tw-mask-top": "linear-gradient(#fff, #fff)",
          "--tw-mask-linear-position": "0deg",
          "--tw-translate-x": "0",
          "--animate-flash-code": "flash-code 2s forwards",
          "--container-3xs": "16rem",
          "--tw-mask-right-from-position": "0%",
          "--animate-bounce": "bounce 1s infinite",
          "--tw-mask-radial-shape": "ellipse",
          "--container-xl": "36rem",
          "--tw-mask-linear": "linear-gradient(#fff, #fff)",
          "--breakpoint-xl": "80rem",
          "--lightningcss-dark": "",
          "--animate-ping": "ping 1s cubic-bezier(0, 0, .2, 1) infinite",
          "--tw-mask-left-from-position": "0%",
          "--blur-xl": "24px",
          "--tw-divide-x-reverse": "0",
          "--breakpoint-2xl": "96rem",
          "--tw-mask-bottom-to-position": "100%",
          "--tw-mask-conic-position": "0deg",
          "--blur-3xl": "64px",
          "--tw-scale-z": "1",
          "--container-sm": "24rem",
          "--tw-scroll-snap-strictness": "proximity",
          "--container-lg": "32rem",
          "--perspective-midrange": "800px",
          "--tw-gradient-from-position": "0%",
          "--ease-in-out": "cubic-bezier(.4, 0, .2, 1)",
          "--tw-mask-radial-from-position": "0%",
          "--tw-mask-linear-to-position": "100%",
          "--tw-mask-radial-position": "center",
          "--tw-mask-right-to-position": "100%",
          "--container-5xl": "64rem",
          "--perspective-distant": "1200px",
          "--blur-md": "12px",
          "--tw-mask-radial-to-position": "100%",
          "--container-2xs": "18rem",
          "--animate-spin": "spin 1s linear infinite",
          "--container-4xl": "56rem",
          "--tw-mask-left": "linear-gradient(#fff, #fff)",
          "--perspective-near": "300px",
          "--tw-mask-bottom-from-position": "0%",
          "--lightningcss-light": "initial",
          "--tw-divide-y-reverse": "0",
          "--breakpoint-md": "48rem",
          "--tw-mask-conic-to-position": "100%",
          "--container-2xl": "42rem",
          "--tw-mask-top-from-position": "0%",
          "--tw-scale-x": "1",
          "--tw-mask-bottom": "linear-gradient(#fff, #fff)",
          "--breakpoint-sm": "40rem",
          "--container-7xl": "80rem",
          "--blur-sm": "8px"
        },
        "meta": {
          "extractedAt": "2026-05-08T21:00:36.365Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "mono font \"plexMono\" not on Google Fonts — fallback to monospace",
      "Site has only one rendered mode; --dark capture matched --light"
    ]
  },
  {
    "slug": "vercel",
    "name": "Vercel",
    "source": "https://vercel.com",
    "radius": "8px",
    "fonts": {
      "body": {
        "name": "Geist",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Geist:wght@100..900&display=swap",
        "fallback": "sans-serif"
      },
      "mono": {
        "name": "Geist Mono",
        "googleFontUrl": "https://fonts.googleapis.com/css2?family=Geist+Mono:wght@100..900&display=swap",
        "fallback": "monospace"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 98%)",
          "foreground": "hsl(0, 0%, 9%)",
          "primary": "hsl(211, 100%, 42%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(208, 100%, 66%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "accent": "hsl(212, 100%, 48%)",
          "accent-foreground": "hsl(0, 0%, 100%)",
          "muted": "hsl(210, 100%, 96%)",
          "muted-foreground": "hsl(0, 0%, 9%)",
          "border": "hsl(0, 0%, 92%)"
        },
        "allVars": {
          "--color-primary": "#0068d6",
          "--color-secondary": "#52aeff",
          "--color-accent": "#0072f5",
          "--color-neutral-50": "#171717",
          "--color-neutral-100": "#ebebeb",
          "--color-neutral-200": "#4d4d4d",
          "--color-neutral-300": "#fafafa",
          "--color-neutral-400": "#666666",
          "--color-neutral-500": "#000000",
          "--color-neutral-600": "#a8a8a8",
          "--color-neutral-700": "lab(27.036% 0 0)",
          "--color-neutral-800": "lab(15.204% 0 -.00000596046)",
          "--color-neutral-900": "#ebf5ff",
          "--color-bg": "#fafafa",
          "--color-bg-1": "#ffffff",
          "--color-text": "#171717",
          "--color-text-1": "#0072f5",
          "--color-text-2": "#4d4d4d",
          "--color-text-3": "#ffffff",
          "--color-text-4": "#0068d6",
          "--font-sans": "\"Geist\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
          "--font-mono": "\"Geist Mono\", Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace",
          "--font-size-48": "48px",
          "--font-size-40": "40px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--font-size-8": "8px",
          "--spacing-1": "1px",
          "--spacing-24": "24px",
          "--spacing-32": "32px",
          "--spacing-36": "36px",
          "--spacing-40": "40px",
          "--spacing-44": "44px",
          "--spacing-48": "48px",
          "--spacing-85": "85px",
          "--spacing-90": "90px",
          "--spacing-96": "96px",
          "--spacing-135": "135px",
          "--spacing-144": "144px",
          "--spacing-161": "161px",
          "--radius-xs": "2px",
          "--radius-sm": "5px",
          "--radius-md": "8px",
          "--radius-lg": "16px",
          "--radius-full": "9999px",
          "--shadow-sm": "rgba(0, 0, 0, 0.04) 0px 2px 2px 0px",
          "--shadow-xs": "rgba(0, 0, 0, 0.04) 0px 1px 2px 0px",
          "--ds-shadow-border-large": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0px 8px 16px -4px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-orange-600": "lab(57.1026% 64.2584 89.8886)",
          "--geist-console-text-color-default": "#000",
          "--tw-inset-ring-shadow": "0 0 #0000",
          "--geist-secondary-lighter": "#eaeaea",
          "--header-border-bottom": "0 1px 0 0 #0000001a",
          "--geist-secondary-dark": "#333",
          "--ds-focus-ring": "0 0 0 2px hsla(0, 0%, 100%, 1), 0 0 0 4px hsla(212, 100%, 48%, 1)",
          "--accents-3": "#999",
          "--geist-selection-text-color": "hsla(0, 0%, 95%, 1)",
          "--accents-8": "#111",
          "--color-zinc-900": "lab(8.30603% .618205 -2.16572)",
          "--accents-2": "#eaeaea",
          "--color-gray-950": "lab(1.90334% .278696 -5.48866)",
          "--ds-shadow-border-small": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-blue-50": "lab(96.492% -1.14644 -5.11479)",
          "--color-violet-50": "lab(96.2416% 2.28849 -5.51657)",
          "--tw-ring-shadow": "0 0 #0000",
          "--color-yellow-600": "lab(62.7799% 22.4197 86.1544)",
          "--ds-shadow-background-border": "0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-foreground-rgb": "0, 0, 0",
          "--geist-console-text-color-blue": "#0070f3",
          "--tw-ring-offset-width": "0px",
          "--accents-4": "#888",
          "--color-violet-700": "lab(35.2783% 67.9912 -88.793)",
          "--tw-ring-offset-shadow": "0 0 #0000",
          "--geist-secondary-light": "#999",
          "--ds-motion-popover-timing": "cubic-bezier(.175, .885, .32, 1.1)",
          "--color-violet-100": "lab(93.0838% 4.35197 -9.88284)",
          "--ds-motion-popover-duration": ".2s",
          "--ds-shadow-border-medium": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0px 8px 8px -8px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-zinc-100": "lab(96.1634% .0993311 -.364041)",
          "--color-slate-500": "lab(48.0876% -2.03595 -16.5814)",
          "--accents-6": "#444",
          "--color-slate-300": "lab(84.7652% -1.94535 -7.93337)",
          "--ds-shadow-border": "0 0 0 1px #00000014, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-violet-background-secondary": "#291c3a",
          "--ds-overlay-backdrop-color": "hsla(0, 0%, 98%, 1)",
          "--ds-shadow-border-base": "0 0 0 1px #00000014",
          "--ds-shadow-border-inset": "inset 0 0 0 1px #00000014",
          "--color-zinc-600": "lab(35.1166% 1.78212 -6.1173)",
          "--tw-border-style": "solid",
          "--animate-fadeOutPopover": "fadeOut cubic-bezier(.175, .885, .32, 1.1) .2s",
          "--ds-focus-color": "hsla(212, 100%, 48%, 1)",
          "--accents-7": "#333",
          "--color-gray-50": "lab(98.2596% -.247031 -.706708)",
          "--geist-console-text-color-purple": "#7928ca",
          "--tw-ring-offset-color": "#fff",
          "--geist-console-text-color-pink": "#eb367f",
          "--accents-1": "#fafafa",
          "--color-indigo-600": "lab(38.4009% 52.6132 -92.3857)",
          "--geist-secondary": "#666",
          "--ds-focus-border": "0 0 0 1px #00000057, 0px 0px 0px 4px #00000029",
          "--accents-5": "#666",
          "--geist-foreground": "#000",
          "--color-red-50": "lab(96.5005% 4.18508 1.52328)",
          "--color-gray-200": "hsla(0, 0%, 92%, 1)",
          "--next-icon-border": "#000",
          "--geist-link-color": "hsla(212, 100%, 48%, 1)",
          "--color-amber-50": "lab(98.6252% -.635922 8.42309)",
          "--geist-space-64x": "256px",
          "--geist-space-small-negative": "-32px",
          "--tw-space-x-reverse": "0",
          "--spacing-fluid-24-40": "clamp(1.5rem, -.2143rem + 2.8571vi, 2.5rem)",
          "--geist-space-16x": "64px",
          "--geist-space-large-negative": "-48px",
          "--geist-space-gap-half-negative": "-12px",
          "--geist-gap-half": "12px",
          "--geist-space-24x": "96px",
          "--spacing-fluid-16-24": "clamp(1rem, .1429rem + 1.4286vi, 1.5rem)",
          "--geist-space-2x-negative": "-8px",
          "--geist-space-gap-quarter-negative": "-8px",
          "--geist-space-large": "48px",
          "--geist-gap-half-negative": "-12px",
          "--geist-space-32x-negative": "-128px",
          "--tw-space-y-reverse": "0",
          "--geist-space-8x-negative": "-32px",
          "--geist-gap-quarter": "8px",
          "--geist-space-3x": "12px",
          "--geist-gap-quarter-negative": "-8px",
          "--geist-space-small": "32px",
          "--geist-gap": "24px",
          "--geist-space-48x-negative": "-192px",
          "--font-space-grotesk": "Space Grotesk, \"Geist\", Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--geist-space-negative": "-4px",
          "--ds-page-width-with-margin": "calc(1400px + calc(2 * 24px))",
          "--geist-page-width-with-margin": "calc(1200px + calc(2 * 24px))",
          "--geist-gap-double": "48px",
          "--geist-space-16x-negative": "-64px",
          "--geist-space-gap": "24px",
          "--geist-space-gap-negative": "-24px",
          "--geist-space-4x": "16px",
          "--geist-space-medium": "40px",
          "--geist-space-gap-quarter": "8px",
          "--geist-space-24x-negative": "-96px",
          "--geist-space-48x": "192px",
          "--geist-gap-section": "32px",
          "--spacing": ".25rem",
          "--geist-space-gap-half": "12px",
          "--spacing-fluid-20-24": "clamp(1.25rem, .8214rem + .7143vi, 1.5rem)",
          "--geist-space": "4px",
          "--geist-gap-negative": "-24px",
          "--geist-space-32x": "128px",
          "--geist-gap-double-negative": "-48px",
          "--geist-page-margin": "24px",
          "--geist-space-6x": "24px",
          "--geist-space-8x": "32px",
          "--geist-space-4x-negative": "-16px",
          "--geist-space-64x-negative": "-256px",
          "--spacing-fluid-20-32": "clamp(1.25rem, -.0357rem + 2.1429vi, 2rem)",
          "--geist-space-10x": "40px",
          "--geist-space-medium-negative": "-40px",
          "--geist-space-2x": "8px",
          "--ship-text": "#ff5b4f",
          "--text-base--line-height": "calc(1.5 / 1)",
          "--tracking-wider": ".05em",
          "--text-fluid-24-32": "clamp(1.5rem, .6429rem + 1.4286vi, 2rem)",
          "--text-fluid-24-28": "clamp(1.5rem, 1.0714rem + .7143vi, 1.75rem)",
          "--text-fluid-16-28": "clamp(1rem, -.2857rem + 2.1429vi, 1.75rem)",
          "--text-sm": ".875rem",
          "--geist-form-small-font": ".875rem",
          "--font-weight-thin": "100",
          "--geist-form-large-font": "1rem",
          "--text-fluid-14-24": "clamp(.875rem, -.1964rem + 1.7857vi, 1.5rem)",
          "--text-lg": "1.125rem",
          "--geist-form-small-line-height": ".875rem",
          "--text-fluid-18-24": "clamp(1.125rem, .4821rem + 1.0714vi, 1.5rem)",
          "--default-font-family": "\"Geist\", Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--tracking-tighter": "-.05em",
          "--develop-text": "#0a72ef",
          "--text-fluid-14-20": "clamp(.875rem, .2321rem + 1.0714vi, 1.25rem)",
          "--font-weight-extrabold": "800",
          "--text-sm--line-height": "calc(1.25 / .875)",
          "--text-3xl--line-height": "calc(2.25 / 1.875)",
          "--text-3xl": "1.875rem",
          "--text-xs": ".75rem",
          "--font-weight-medium": "500",
          "--font-weight-normal": "400",
          "--font-sans-fallback": "\"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
          "--text-base": "1rem",
          "--default-mono-font-family": "\"Geist Mono\", ui-monospace, SFMono-Regular, Roboto Mono, Menlo, Monaco, Liberation Mono, DejaVu Sans Mono, Courier New, monospace, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--preview-text": "#de1d8d",
          "--text-fluid-32-64": "clamp(2rem, -1.4286rem + 5.7143vi, 4rem)",
          "--geist-text-gradient": "linear-gradient(180deg, #000c 0%, #000 100%)",
          "--text-fluid-64-128": "clamp(4rem, -2.8571rem + 11.4286vi, 8rem)",
          "--text-fluid-20-28": "clamp(1.25rem, .3929rem + 1.4286vi, 1.75rem)",
          "--font-weight-bold": "700",
          "--text-xs--line-height": "calc(1 / .75)",
          "--text-fluid-20-32": "clamp(1.25rem, -.0357rem + 2.1429vi, 2rem)",
          "--text-xl": "1.25rem",
          "--leading-relaxed": "1.625",
          "--geist-form-line-height": "1.25rem",
          "--text-2xl--line-height": "calc(2 / 1.5)",
          "--text-xl--line-height": "calc(1.75 / 1.25)",
          "--font-mono-fallback": "\"Roboto Mono\", Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace",
          "--geist-form-font": ".875rem",
          "--leading-tight": "1.25",
          "--text-fluid-20-80": "clamp(1.25rem, -5.1786rem + 10.7143vi, 5rem)",
          "--geist-form-large-line-height": "1.5rem",
          "--text-fluid-14-16": "clamp(.875rem, .6607rem + .3571vi, 1rem)",
          "--tracking-tight": "-.025em",
          "--text-2xl": "1.5rem",
          "--text-fluid-16-20": "clamp(1rem, .5714rem + .7143vi, 1.25rem)",
          "--text-fluid-32-80": "clamp(2rem, -3.1429rem + 8.5714vi, 5rem)",
          "--text-5xl--line-height": "1",
          "--leading-normal": "1.5",
          "--text-lg--line-height": "calc(1.75 / 1.125)",
          "--font-weight-light": "300",
          "--font-weight-semibold": "600",
          "--font-pixel-square": "",
          "--tracking-normal": "0em",
          "--text-5xl": "3rem",
          "--tw-inset-shadow": "0 0 #0000",
          "--dropdown-box-shadow": "0 4px 4px 0 #00000005",
          "--tw-shadow-alpha": "100%",
          "--ds-shadow-large": "0px 2px 2px #0000000a, 0px 8px 16px -4px #0000000a",
          "--shadow-sticky": "0 12px 10px -10px #0000001f",
          "--tw-drop-shadow-alpha": "100%",
          "--shadow-large": "0 30px 60px #0000001f",
          "--ds-shadow-small": "0px 2px 2px #0000000a",
          "--shadow-medium": "0 8px 30px #0000001f",
          "--ds-shadow-xl": "0px 1px 1px #00000005, 0px 4px 8px -4px #0000000a, 0px 16px 24px -8px #0000000f",
          "--ds-shadow-modal": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--ds-shadow-medium": "0px 2px 2px #0000000a, 0px 8px 8px -8px #0000000a",
          "--tw-shadow": "0 0 #0000",
          "--shadow-hover": "0 30px 60px #0000001f",
          "--tw-inset-shadow-alpha": "100%",
          "--ds-shadow-2xl": "0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f",
          "--drop-shadow-lg": "0 4px 4px #00000026",
          "--shadow-smallest": "0px 2px 4px #0000001a",
          "--ds-shadow-tooltip": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 4px 8px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--ds-shadow-xs": "0px 1px 2px #0000000a",
          "--ds-shadow-2xs": "0px 1px 1px #0000000a",
          "--shadow-small": "0 5px 10px #0000001f",
          "--ds-shadow-fullscreen": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--shadow-extra-small": "0px 4px 8px #0000001f",
          "--ds-shadow-menu": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 4px 8px -4px #0000000a, 0px 16px 24px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-radius": "6px",
          "--geist-marketing-radius": "8px",
          "--radius-3xl": "1.5rem",
          "--banner-min-height": "64px",
          "--blur-lg": "16px",
          "--geist-cyan-lighter": "#aaffec",
          "--ds-amber-700": "hsla(39, 100%, 57%, 1)",
          "--ds-pink-300-value": "340, 82%, 94%",
          "--ease-in": "cubic-bezier(.4, 0, 1, 1)",
          "--geist-error": "#e00",
          "--ds-amber-900": "hsla(30, 100%, 32%, 1)",
          "--ds-green-200": "hsla(120, 60%, 95%, 1)",
          "--tw-enter-scale": "1",
          "--ds-red-800-value": "358, 70%, 52%",
          "--geist-violet-lighter": "#d8ccf1",
          "--ds-green-1000": "hsla(128, 29%, 15%, 1)",
          "--ds-red-1000": "hsla(355, 49%, 15%, 1)",
          "--wv-orange": "#ffa400",
          "--ds-amber-800-value": "35, 100%, 52%",
          "--ds-gray-alpha-600": "#00000057",
          "--animate-cmdkScaleIn": "cmdkScaleIn .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-300": "hsla(340, 82%, 94%, 1)",
          "--develop-start-gradient": "#007cf0",
          "--geist-violet-background-tertiary": "#eae5f4",
          "--ds-gray-alpha-100": "#0000000d",
          "--ds-teal-700-value": "173, 80%, 36%",
          "--tw-exit-translate-y": "0",
          "--ds-blue-1000": "hsla(211, 100%, 15%, 1)",
          "--tw-gradient-to-position": "100%",
          "--ds-amber-600": "hsla(36, 90%, 62%, 1)",
          "--animate-sandbox-left-reverse": "sandbox-left-reverse .5s ease-in-out forwards",
          "--ds-white": "lab(100% 0 0)",
          "--ds-background-200": "hsla(0, 0%, 98%, 1)",
          "--ds-red-500-value": "0, 82%, 85%",
          "--dropdown-triangle-stroke": "#fff",
          "--ds-blue-400": "hsla(209, 100%, 90%, 1)",
          "--animate-flip-front": "flip-front .5s cubic-bezier(.4, .04, .04, 1) forwards",
          "--ds-teal-700": "hsla(173, 80%, 36%, 1)",
          "--geist-highlight-magenta": "#eb367f",
          "--ds-green-800": "hsla(132, 43%, 39%, 1)",
          "--ds-red-200": "hsla(0, 100%, 96%, 1)",
          "--ds-purple-1000": "hsla(276, 100%, 15%, 1)",
          "--vh100-offset": "calc(64px + 0px)",
          "--ds-green-100-value": "120, 60%, 96%",
          "--ds-gray-500": "hsla(0, 0%, 79%, 1)",
          "--scroller-start": "#fff",
          "--ds-purple-800": "hsla(272, 47%, 45%, 1)",
          "--vaul-overlay-background-end": "#0006",
          "--ds-purple-300": "hsla(274, 78%, 95%, 1)",
          "--ds-amber-500": "hsla(38, 100%, 71%, 1)",
          "--tw-scale-y": "1",
          "--animate-cmdkFadeIn": "cmdkFadeIn .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--scroller-end": "#fff0",
          "--ds-red-700-value": "358, 75%, 59%",
          "--geist-background-rgb": "255, 255, 255",
          "--tw-exit-translate-x": "0",
          "--ds-blue-1000-value": "211, 100%, 15%",
          "--ds-pink-500-value": "340, 75%, 84%",
          "--ds-blue-200-value": "210, 100%, 96%",
          "--header-zindex": "75",
          "--ds-gray-500-value": "0, 0%, 79%",
          "--animate-blue-glow": "blue-glow 3s ease-in-out infinite",
          "--ds-blue-100": "hsla(212, 100%, 97%, 1)",
          "--ds-gray-700": "hsla(0, 0%, 56%, 1)",
          "--ds-teal-800-value": "173, 83%, 30%",
          "--animate-sandbox-left": "sandbox-left .5s ease-in-out forwards",
          "--ds-amber-700-value": "39, 100%, 57%",
          "--animate-dialogFadeIn": "",
          "--ds-teal-200-value": "167, 70%, 94%",
          "--ds-purple-400-value": "276, 71%, 92%",
          "--ds-contrast-fg": "#fff",
          "--tw-enter-blur": "0",
          "--ds-amber-1000-value": "20, 79%, 17%",
          "--animate-cmdkScaleOut": "cmdkScaleOut .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-red-700": "hsla(358, 75%, 59%, 1)",
          "--container-xl": "1200px",
          "--geist-highlight-purple": "#f81ce5",
          "--ds-red-400-value": "0, 90%, 92%",
          "--ds-teal-500": "hsla(170, 70%, 72%, 1)",
          "--geist-code": "#000",
          "--ds-gray-1000-value": "0, 0%, 9%",
          "--ds-teal-1000-value": "171, 80%, 13%",
          "--ds-blue-800-value": "212, 100%, 41%",
          "--geist-warning-lighter": "#ffefcf",
          "--tw-animation-direction": "normal",
          "--ds-blue-400-value": "209, 100%, 90%",
          "--ds-pink-900-value": "336, 65%, 45%",
          "--animate-feedbackFadeIn": "feedbackFadeIn .1s cubic-bezier(.16, 1, .3, 1)",
          "--geist-page-width": "1200px",
          "--ds-purple-100": "hsla(276, 100%, 97%, 1)",
          "--ds-gray-200-value": "0, 0%, 92%",
          "--ds-red-500": "hsla(0, 82%, 85%, 1)",
          "--tw-divide-x-reverse": "0",
          "--ds-blue-600-value": "208, 100%, 66%",
          "--animate-slide-in": "slide-in 1.25s cubic-bezier(.4, .04, .04, 1) forwards",
          "--preview-end-gradient": "#ff0080",
          "--tw-exit-rotate": "0",
          "--develop-end-gradient": "#00dfd8",
          "--ds-purple-600-value": "273, 72%, 73%",
          "--ds-blue-700": "hsla(212, 100%, 48%, 1)",
          "--ds-purple-300-value": "274, 78%, 95%",
          "--ds-amber-600-value": "36, 90%, 62%",
          "--container-sm": "401px",
          "--ds-green-100": "hsla(120, 60%, 96%, 1)",
          "--animate-feedbackAppear": "feedbackAppear .5s .1s ease forwards",
          "--ds-gray-alpha-800": "#00000082",
          "--animate-loading-skeleton": "loading-skeleton 1.5s ease-in-out infinite reverse",
          "--ds-gray-900-value": "0, 0%, 30%",
          "--header-sub-menu-height": "46px",
          "--ds-gray-200": "hsla(0, 0%, 92%, 1)",
          "--ds-overlay-backdrop-opacity": ".8",
          "--ds-blue-500-value": "209, 100%, 80%",
          "--animate-flip-back": "flip-back .5s cubic-bezier(.4, .04, .04, 1) forwards",
          "--ds-green-700": "hsla(131, 41%, 46%, 1)",
          "--ds-amber-100-value": "39, 100%, 95%",
          "--ds-pink-200": "hsla(340, 90%, 96%, 1)",
          "--tw-gradient-from-position": "0%",
          "--ds-pink-700": "hsla(336, 80%, 58%, 1)",
          "--ds-blue-300": "hsla(210, 100%, 94%, 1)",
          "--wv-green": "#0cce6b",
          "--ds-gray-700-value": "0, 0%, 56%",
          "--ds-gray-alpha-700": "#00000070",
          "--ds-gray-300-value": "0, 0%, 90%",
          "--ds-pink-1000": "hsla(333, 74%, 15%, 1)",
          "--ds-red-300-value": "0, 100%, 95%",
          "--ds-gray-alpha-400": "#00000014",
          "--animate-thinking-loader-fast": "thinking-loader .85s linear infinite",
          "--geist-console-purple": "#7928ca",
          "--ds-purple-900-value": "274, 71%, 43%",
          "--ds-gray-400-value": "0, 0%, 92%",
          "--tw-animation-fill-mode": "none",
          "--tw-exit-blur": "0",
          "--animate-feedbackFadeOut": "feedbackFadeOut .2s cubic-bezier(.16, 1, .3, 1) forwards",
          "--ds-red-900-value": "358, 66%, 48%",
          "--ds-pink-500": "hsla(340, 75%, 84%, 1)",
          "--ds-pink-100-value": "330, 100%, 96%",
          "--geist-highlight-pink": "#ff0080",
          "--geist-cyan-light": "#79ffe1",
          "--ds-green-600": "hsla(125, 60%, 64%, 1)",
          "--ds-red-1000-value": "355, 49%, 15%",
          "--vaul-overlay-background-start": "#0000",
          "--geist-cyan": "#50e3c2",
          "--ds-green-900": "hsla(133, 50%, 32%, 1)",
          "--ds-pink-900": "hsla(336, 65%, 45%, 1)",
          "--tw-enter-translate-x": "0",
          "--container-4xl": "56rem",
          "--ds-purple-1000-value": "276, 100%, 15%",
          "--ds-amber-800": "hsla(35, 100%, 52%, 1)",
          "--ds-green-700-value": "131, 41%, 46%",
          "--ds-amber-400-value": "42, 100%, 78%",
          "--preview-line-end": "#9a1fb8",
          "--ds-gray-alpha-500": "#00000036",
          "--ds-green-300": "hsla(120, 60%, 91%, 1)",
          "--animate-fadeInTooltipFaster": "fadeInTooltip .1s ease-in .1s forwards",
          "--ds-green-300-value": "120, 60%, 91%",
          "--ds-blue-900": "hsla(211, 100%, 42%, 1)",
          "--ds-gray-600": "hsla(0, 0%, 66%, 1)",
          "--ds-purple-500": "hsla(274, 70%, 82%, 1)",
          "--ds-pink-800": "hsla(336, 74%, 51%, 1)",
          "--ds-green-400": "hsla(122, 60%, 86%, 1)",
          "--ds-blue-500": "hsla(209, 100%, 80%, 1)",
          "--ds-green-900-value": "133, 50%, 32%",
          "--animate-blink": "blink 1s infinite",
          "--ds-amber-300-value": "43, 96%, 90%",
          "--ds-amber-400": "hsla(42, 100%, 78%, 1)",
          "--tw-enter-opacity": "1",
          "--ds-motion-overlay-scale": ".96",
          "--geist-form-height": "40px",
          "--container-md": "601px",
          "--header-height": "64px",
          "--aspect-video": "16 / 9",
          "--ds-teal-100": "hsla(169, 70%, 96%, 1)",
          "--ds-green-1000-value": "128, 29%, 15%",
          "--develop-line-end": "#019ae9",
          "--animate-loading": "loading 8s ease-in-out infinite",
          "--ds-blue-600": "hsla(208, 100%, 66%, 1)",
          "--tw-animation-delay": "0s",
          "--animate-marquee": "marquee 40s linear infinite",
          "--ds-green-800-value": "132, 43%, 39%",
          "--geist-success-light": "#3291ff",
          "--ds-amber-500-value": "38, 100%, 71%",
          "--tw-outline-style": "solid",
          "--geist-warning-light": "#f7b955",
          "--geist-cyan-dark": "#29bc9b",
          "--geist-success-dark": "#0761d1",
          "--geist-form-small-height": "32px",
          "--header-import-flow-background": "#fafafacc",
          "--ds-black": "lab(0% 0 0)",
          "--ds-pink-200-value": "340, 90%, 96%",
          "--ds-blue-200": "hsla(210, 100%, 96%, 1)",
          "--tw-gradient-from": "rgba(0, 0, 0, 0)",
          "--tw-gradient-to": "rgba(0, 0, 0, 0)",
          "--ds-pink-600": "hsla(341, 75%, 73%, 1)",
          "--ds-gray-800": "hsla(0, 0%, 49%, 1)",
          "--geist-violet-light": "#8a63d2",
          "--ds-teal-1000": "hsla(171, 80%, 13%, 1)",
          "--ds-gray-300": "hsla(0, 0%, 90%, 1)",
          "--ds-purple-600": "hsla(273, 72%, 73%, 1)",
          "--tw-gradient-via-position": "50%",
          "--ds-amber-1000": "hsla(20, 79%, 17%, 1)",
          "--ds-amber-200": "hsla(44, 100%, 92%, 1)",
          "--ds-teal-300-value": "168, 70%, 90%",
          "--default-transition-duration": ".15s",
          "--animate-pulse": "pulse 2s cubic-bezier(.4, 0, .6, 1) infinite",
          "--ds-pink-700-value": "336, 80%, 58%",
          "--container-xs": "20rem",
          "--ds-gray-1000": "hsla(0, 0%, 9%, 1)",
          "--ds-purple-200-value": "277, 87%, 97%",
          "--ds-teal-400-value": "170, 70%, 85%",
          "--ds-green-600-value": "125, 60%, 64%",
          "--banner-height": "0px",
          "--ds-red-200-value": "0, 100%, 96%",
          "--ds-blue-900-value": "211, 100%, 42%",
          "--default-transition-timing-function": "cubic-bezier(.4, 0, .2, 1)",
          "--tw-animation-iteration-count": "1",
          "--tw-exit-opacity": "1",
          "--ds-teal-500-value": "170, 70%, 72%",
          "--ds-motion-overlay-timing": "cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-800-value": "336, 74%, 51%",
          "--tw-translate-z": "0",
          "--tw-gradient-via": "rgba(0, 0, 0, 0)",
          "--ds-pink-400": "hsla(341, 76%, 91%, 1)",
          "--geist-violet-dark": "#4c2889",
          "--ai-chat-panel-width": "0px",
          "--container-3xl": "48rem",
          "--blur-xs": "4px",
          "--tw-translate-y": "0",
          "--ease-out": "cubic-bezier(0, 0, .2, 1)",
          "--ship-start-gradient": "#ff4d4d",
          "--ds-gray-100": "hsla(0, 0%, 95%, 1)",
          "--ds-page-width": "1400px",
          "--tw-content": "\"\"",
          "--ds-teal-100-value": "169, 70%, 96%",
          "--animate-thinking-loader": "thinking-loader 1.5s linear infinite",
          "--ds-purple-500-value": "274, 70%, 82%",
          "--ds-teal-300": "hsla(168, 70%, 90%, 1)",
          "--tw-translate-x": "0",
          "--tw-enter-rotate": "0",
          "--ds-gray-100-value": "0, 0%, 95%",
          "--ds-gray-alpha-1000": "#000000e8",
          "--geist-error-lighter": "#f7d4d6",
          "--animate-bounce": "bounce 1s infinite",
          "--ds-red-300": "hsla(0, 100%, 95%, 1)",
          "--ds-purple-900": "hsla(274, 71%, 43%, 1)",
          "--ds-background-100": "hsla(0, 0%, 100%, 1)",
          "--ds-gray-alpha-300": "#0000001a",
          "--animate-fadeInTooltip": "fadeInTooltip .1s ease-in .4s forwards",
          "--ds-red-400": "hsla(0, 90%, 92%, 1)",
          "--geist-marketing-gray": "#fafbfc",
          "--ds-red-600": "hsla(359, 90%, 71%, 1)",
          "--ds-blue-300-value": "210, 100%, 94%",
          "--ds-teal-900-value": "174, 91%, 25%",
          "--ds-motion-timing-swift": "cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-400-value": "341, 76%, 91%",
          "--ds-pink-1000-value": "333, 74%, 15%",
          "--ds-purple-400": "hsla(276, 71%, 92%, 1)",
          "--ds-blue-800": "hsla(212, 100%, 41%, 1)",
          "--ds-amber-900-value": "30, 100%, 32%",
          "--geist-form-large-height": "48px",
          "--geist-warning": "#f5a623",
          "--geist-error-dark": "#c50000",
          "--ds-motion-overlay-duration": ".3s",
          "--ds-purple-800-value": "272, 47%, 45%",
          "--ds-gray-alpha-900": "#000000b3",
          "--wv-red": "#ff4e42",
          "--ds-gray-900": "hsla(0, 0%, 30%, 1)",
          "--geist-violet": "#7928ca",
          "--ship-line-end": "#f9cb28",
          "--geist-console-header": "#efe7ed",
          "--geist-success-lighter": "#d3e5ff",
          "--ds-red-100-value": "0, 100%, 97%",
          "--geist-error-light": "#ff1a1a",
          "--animate-accordion-down": "accordion-down .2s ease-out",
          "--ds-purple-100-value": "276, 100%, 97%",
          "--tw-scale-z": "1",
          "--ds-red-800": "hsla(358, 70%, 52%, 1)",
          "--ds-purple-700-value": "272, 51%, 54%",
          "--ds-amber-300": "hsla(43, 96%, 90%, 1)",
          "--tw-scroll-snap-strictness": "proximity",
          "--ds-background-200-value": "0, 0%, 98%",
          "--ds-green-500": "hsla(124, 60%, 75%, 1)",
          "--container-lg": "961px",
          "--geist-highlight-yellow": "#fff500",
          "--ds-green-400-value": "122, 60%, 86%",
          "--ds-blue-700-value": "212, 100%, 48%",
          "--ds-pink-100": "hsla(330, 100%, 96%, 1)",
          "--geist-success": "#0070f3",
          "--ds-teal-600": "hsla(170, 70%, 57%, 1)",
          "--ds-green-500-value": "124, 60%, 75%",
          "--ds-gray-alpha-200": "#00000014",
          "--ds-gray-400": "hsla(0, 0%, 92%, 1)",
          "--ease-in-out": "cubic-bezier(.4, 0, .2, 1)",
          "--animate-cmdkFadeOut": "cmdkFadeOut .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--vaul-overlay-background": "255, 255, 255",
          "--ds-gray-600-value": "0, 0%, 66%",
          "--value": "0",
          "--animate-accordion-up": "accordion-up .2s ease-out",
          "--animate-sandbox-right": "sandbox-right .5s ease-in-out forwards",
          "--preview-start-gradient": "#7928ca",
          "--animate-logo-carousel": "logo-carousel ease-in-out infinite",
          "--ds-teal-900": "hsla(174, 91%, 25%, 1)",
          "--container-5xl": "64rem",
          "--ds-amber-100": "hsla(39, 100%, 95%, 1)",
          "--animate-sandbox-right-reverse": "sandbox-right-reverse .5s ease-in-out forwards",
          "--footer-height": "79px",
          "--ds-red-900": "hsla(358, 66%, 48%, 1)",
          "--geist-background": "#fff",
          "--perspective-distant": "1200px",
          "--ds-red-600-value": "359, 90%, 71%",
          "--ds-background-100-value": "0, 0%, 100%",
          "--geist-selection": "hsla(0, 0%, 9%, 1)",
          "--ds-teal-400": "hsla(170, 70%, 85%, 1)",
          "--ds-purple-700": "hsla(272, 51%, 54%, 1)",
          "--animate-spin": "spin 1s linear infinite",
          "--geist-warning-dark": "#ab570a",
          "--ds-gray-800-value": "0, 0%, 49%",
          "--ds-blue-100-value": "212, 100%, 97%",
          "--tw-divide-y-reverse": "0",
          "--ds-teal-200": "hsla(167, 70%, 94%, 1)",
          "--tw-exit-scale": "1",
          "--container-2xl": "1400px",
          "--ds-purple-200": "hsla(277, 87%, 97%, 1)",
          "--ds-amber-200-value": "44, 100%, 92%",
          "--tw-scale-x": "1",
          "--tw-enter-translate-y": "0",
          "--animate-dialogFadeOut": "",
          "--ds-teal-600-value": "170, 70%, 57%",
          "--ds-green-200-value": "120, 60%, 95%",
          "--ship-end-gradient": "#f9cb28",
          "--ds-red-100": "hsla(0, 100%, 97%, 1)",
          "--geist-violet-background": "#fff",
          "--ds-pink-600-value": "341, 75%, 73%",
          "--ds-teal-800": "hsla(173, 83%, 30%, 1)",
          "--blur-sm": "8px",
          "--animate-cmdkLoading": "cmdkLoading 1.1s cubic-bezier(.455, .03, .515, .955) infinite",
          "--rhythm-section": "12rem",
          "--rhythm-subsection": "1.5rem",
          "--rhythm-heading-to-body": "0.75rem",
          "--rhythm-body-to-cta": "1rem",
          "--rhythm-intra-list": "1.5rem",
          "--stack-heading-size": "12px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "12px",
          "--stack-body-size": "14px",
          "--stack-body-weight": "400",
          "--stack-body-line-height": "21px"
        },
        "meta": {
          "extractedAt": "2026-05-09T08:04:28.411Z"
        }
      },
      "dark": {
        "colors": {
          "background": "hsl(0, 0%, 0%)",
          "foreground": "hsl(0, 0%, 93%)",
          "primary": "hsl(210, 100%, 66%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(208, 100%, 66%)",
          "secondary-foreground": "hsl(0, 0%, 0%)",
          "accent": "hsl(212, 100%, 48%)",
          "accent-foreground": "hsl(0, 0%, 100%)",
          "border": "hsl(0, 0%, 12%)"
        },
        "allVars": {
          "--color-primary": "#0068d6",
          "--color-secondary": "#52aeff",
          "--color-accent": "#0072f5",
          "--color-neutral-50": "#171717",
          "--color-neutral-100": "#ebebeb",
          "--color-neutral-200": "#4d4d4d",
          "--color-neutral-300": "#fafafa",
          "--color-neutral-400": "#666666",
          "--color-neutral-500": "#000000",
          "--color-neutral-600": "#a8a8a8",
          "--color-neutral-700": "lab(27.036% 0 0)",
          "--color-neutral-800": "lab(15.204% 0 -.00000596046)",
          "--color-neutral-900": "#ebf5ff",
          "--color-bg": "#fafafa",
          "--color-bg-1": "#ffffff",
          "--color-text": "#171717",
          "--color-text-1": "#0072f5",
          "--color-text-2": "#4d4d4d",
          "--color-text-3": "#ffffff",
          "--color-text-4": "#0068d6",
          "--font-sans": "\"Geist\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
          "--font-mono": "\"Geist Mono\", Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace",
          "--font-size-48": "48px",
          "--font-size-40": "40px",
          "--font-size-32": "32px",
          "--font-size-24": "24px",
          "--font-size-20": "20px",
          "--font-size-18": "18px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-13": "13px",
          "--font-size-12": "12px",
          "--font-size-8": "8px",
          "--spacing-1": "1px",
          "--spacing-24": "24px",
          "--spacing-32": "32px",
          "--spacing-36": "36px",
          "--spacing-40": "40px",
          "--spacing-44": "44px",
          "--spacing-48": "48px",
          "--spacing-85": "85px",
          "--spacing-90": "90px",
          "--spacing-96": "96px",
          "--spacing-135": "135px",
          "--spacing-144": "144px",
          "--spacing-161": "161px",
          "--radius-xs": "2px",
          "--radius-sm": "5px",
          "--radius-md": "8px",
          "--radius-lg": "16px",
          "--radius-full": "9999px",
          "--shadow-sm": "rgba(0, 0, 0, 0.04) 0px 2px 2px 0px",
          "--shadow-xs": "rgba(0, 0, 0, 0.04) 0px 1px 2px 0px",
          "--ds-shadow-border-large": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0px 8px 16px -4px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-orange-600": "lab(57.1026% 64.2584 89.8886)",
          "--geist-console-text-color-default": "#000",
          "--tw-inset-ring-shadow": "0 0 #0000",
          "--geist-secondary-lighter": "#eaeaea",
          "--header-border-bottom": "0 1px 0 0 #0000001a",
          "--geist-secondary-dark": "#333",
          "--ds-focus-ring": "0 0 0 2px hsla(0, 0%, 100%, 1), 0 0 0 4px hsla(212, 100%, 48%, 1)",
          "--accents-3": "#999",
          "--geist-selection-text-color": "hsla(0, 0%, 95%, 1)",
          "--accents-8": "#111",
          "--color-zinc-900": "lab(8.30603% .618205 -2.16572)",
          "--accents-2": "#eaeaea",
          "--color-gray-950": "lab(1.90334% .278696 -5.48866)",
          "--ds-shadow-border-small": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-blue-50": "lab(96.492% -1.14644 -5.11479)",
          "--color-violet-50": "lab(96.2416% 2.28849 -5.51657)",
          "--tw-ring-shadow": "0 0 #0000",
          "--color-yellow-600": "lab(62.7799% 22.4197 86.1544)",
          "--ds-shadow-background-border": "0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-foreground-rgb": "0, 0, 0",
          "--geist-console-text-color-blue": "#0070f3",
          "--tw-ring-offset-width": "0px",
          "--accents-4": "#888",
          "--color-violet-700": "lab(35.2783% 67.9912 -88.793)",
          "--tw-ring-offset-shadow": "0 0 #0000",
          "--geist-secondary-light": "#999",
          "--ds-motion-popover-timing": "cubic-bezier(.175, .885, .32, 1.1)",
          "--color-violet-100": "lab(93.0838% 4.35197 -9.88284)",
          "--ds-motion-popover-duration": ".2s",
          "--ds-shadow-border-medium": "0 0 0 1px #00000014, 0px 2px 2px #0000000a, 0px 8px 8px -8px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--color-zinc-100": "lab(96.1634% .0993311 -.364041)",
          "--color-slate-500": "lab(48.0876% -2.03595 -16.5814)",
          "--accents-6": "#444",
          "--color-slate-300": "lab(84.7652% -1.94535 -7.93337)",
          "--ds-shadow-border": "0 0 0 1px #00000014, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-violet-background-secondary": "#291c3a",
          "--ds-overlay-backdrop-color": "hsla(0, 0%, 98%, 1)",
          "--ds-shadow-border-base": "0 0 0 1px #00000014",
          "--ds-shadow-border-inset": "inset 0 0 0 1px #00000014",
          "--color-zinc-600": "lab(35.1166% 1.78212 -6.1173)",
          "--tw-border-style": "solid",
          "--animate-fadeOutPopover": "fadeOut cubic-bezier(.175, .885, .32, 1.1) .2s",
          "--ds-focus-color": "hsla(212, 100%, 48%, 1)",
          "--accents-7": "#333",
          "--color-gray-50": "lab(98.2596% -.247031 -.706708)",
          "--geist-console-text-color-purple": "#7928ca",
          "--tw-ring-offset-color": "#fff",
          "--geist-console-text-color-pink": "#eb367f",
          "--accents-1": "#fafafa",
          "--color-indigo-600": "lab(38.4009% 52.6132 -92.3857)",
          "--geist-secondary": "#666",
          "--ds-focus-border": "0 0 0 1px #00000057, 0px 0px 0px 4px #00000029",
          "--accents-5": "#666",
          "--geist-foreground": "#000",
          "--color-red-50": "lab(96.5005% 4.18508 1.52328)",
          "--color-gray-200": "hsla(0, 0%, 92%, 1)",
          "--next-icon-border": "#000",
          "--geist-link-color": "hsla(212, 100%, 48%, 1)",
          "--color-amber-50": "lab(98.6252% -.635922 8.42309)",
          "--geist-space-64x": "256px",
          "--geist-space-small-negative": "-32px",
          "--tw-space-x-reverse": "0",
          "--spacing-fluid-24-40": "clamp(1.5rem, -.2143rem + 2.8571vi, 2.5rem)",
          "--geist-space-16x": "64px",
          "--geist-space-large-negative": "-48px",
          "--geist-space-gap-half-negative": "-12px",
          "--geist-gap-half": "12px",
          "--geist-space-24x": "96px",
          "--spacing-fluid-16-24": "clamp(1rem, .1429rem + 1.4286vi, 1.5rem)",
          "--geist-space-2x-negative": "-8px",
          "--geist-space-gap-quarter-negative": "-8px",
          "--geist-space-large": "48px",
          "--geist-gap-half-negative": "-12px",
          "--geist-space-32x-negative": "-128px",
          "--tw-space-y-reverse": "0",
          "--geist-space-8x-negative": "-32px",
          "--geist-gap-quarter": "8px",
          "--geist-space-3x": "12px",
          "--geist-gap-quarter-negative": "-8px",
          "--geist-space-small": "32px",
          "--geist-gap": "24px",
          "--geist-space-48x-negative": "-192px",
          "--font-space-grotesk": "Space Grotesk, \"Geist\", Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--geist-space-negative": "-4px",
          "--ds-page-width-with-margin": "calc(1400px + calc(2 * 24px))",
          "--geist-page-width-with-margin": "calc(1200px + calc(2 * 24px))",
          "--geist-gap-double": "48px",
          "--geist-space-16x-negative": "-64px",
          "--geist-space-gap": "24px",
          "--geist-space-gap-negative": "-24px",
          "--geist-space-4x": "16px",
          "--geist-space-medium": "40px",
          "--geist-space-gap-quarter": "8px",
          "--geist-space-24x-negative": "-96px",
          "--geist-space-48x": "192px",
          "--geist-gap-section": "32px",
          "--spacing": ".25rem",
          "--geist-space-gap-half": "12px",
          "--spacing-fluid-20-24": "clamp(1.25rem, .8214rem + .7143vi, 1.5rem)",
          "--geist-space": "4px",
          "--geist-gap-negative": "-24px",
          "--geist-space-32x": "128px",
          "--geist-gap-double-negative": "-48px",
          "--geist-page-margin": "24px",
          "--geist-space-6x": "24px",
          "--geist-space-8x": "32px",
          "--geist-space-4x-negative": "-16px",
          "--geist-space-64x-negative": "-256px",
          "--spacing-fluid-20-32": "clamp(1.25rem, -.0357rem + 2.1429vi, 2rem)",
          "--geist-space-10x": "40px",
          "--geist-space-medium-negative": "-40px",
          "--geist-space-2x": "8px",
          "--ship-text": "#ff5b4f",
          "--text-base--line-height": "calc(1.5 / 1)",
          "--tracking-wider": ".05em",
          "--text-fluid-24-32": "clamp(1.5rem, .6429rem + 1.4286vi, 2rem)",
          "--text-fluid-24-28": "clamp(1.5rem, 1.0714rem + .7143vi, 1.75rem)",
          "--text-fluid-16-28": "clamp(1rem, -.2857rem + 2.1429vi, 1.75rem)",
          "--text-sm": ".875rem",
          "--geist-form-small-font": ".875rem",
          "--font-weight-thin": "100",
          "--geist-form-large-font": "1rem",
          "--text-fluid-14-24": "clamp(.875rem, -.1964rem + 1.7857vi, 1.5rem)",
          "--text-lg": "1.125rem",
          "--geist-form-small-line-height": ".875rem",
          "--text-fluid-18-24": "clamp(1.125rem, .4821rem + 1.0714vi, 1.5rem)",
          "--default-font-family": "\"Geist\", Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--tracking-tighter": "-.05em",
          "--develop-text": "#0a72ef",
          "--text-fluid-14-20": "clamp(.875rem, .2321rem + 1.0714vi, 1.25rem)",
          "--font-weight-extrabold": "800",
          "--text-sm--line-height": "calc(1.25 / .875)",
          "--text-3xl--line-height": "calc(2.25 / 1.875)",
          "--text-3xl": "1.875rem",
          "--text-xs": ".75rem",
          "--font-weight-medium": "500",
          "--font-weight-normal": "400",
          "--font-sans-fallback": "\"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
          "--text-base": "1rem",
          "--default-mono-font-family": "\"Geist Mono\", ui-monospace, SFMono-Regular, Roboto Mono, Menlo, Monaco, Liberation Mono, DejaVu Sans Mono, Courier New, monospace, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
          "--preview-text": "#de1d8d",
          "--text-fluid-32-64": "clamp(2rem, -1.4286rem + 5.7143vi, 4rem)",
          "--geist-text-gradient": "linear-gradient(180deg, #000c 0%, #000 100%)",
          "--text-fluid-64-128": "clamp(4rem, -2.8571rem + 11.4286vi, 8rem)",
          "--text-fluid-20-28": "clamp(1.25rem, .3929rem + 1.4286vi, 1.75rem)",
          "--font-weight-bold": "700",
          "--text-xs--line-height": "calc(1 / .75)",
          "--text-fluid-20-32": "clamp(1.25rem, -.0357rem + 2.1429vi, 2rem)",
          "--text-xl": "1.25rem",
          "--leading-relaxed": "1.625",
          "--geist-form-line-height": "1.25rem",
          "--text-2xl--line-height": "calc(2 / 1.5)",
          "--text-xl--line-height": "calc(1.75 / 1.25)",
          "--font-mono-fallback": "\"Roboto Mono\", Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace",
          "--geist-form-font": ".875rem",
          "--leading-tight": "1.25",
          "--text-fluid-20-80": "clamp(1.25rem, -5.1786rem + 10.7143vi, 5rem)",
          "--geist-form-large-line-height": "1.5rem",
          "--text-fluid-14-16": "clamp(.875rem, .6607rem + .3571vi, 1rem)",
          "--tracking-tight": "-.025em",
          "--text-2xl": "1.5rem",
          "--text-fluid-16-20": "clamp(1rem, .5714rem + .7143vi, 1.25rem)",
          "--text-fluid-32-80": "clamp(2rem, -3.1429rem + 8.5714vi, 5rem)",
          "--text-5xl--line-height": "1",
          "--leading-normal": "1.5",
          "--text-lg--line-height": "calc(1.75 / 1.125)",
          "--font-weight-light": "300",
          "--font-weight-semibold": "600",
          "--font-pixel-square": "",
          "--tracking-normal": "0em",
          "--text-5xl": "3rem",
          "--tw-inset-shadow": "0 0 #0000",
          "--dropdown-box-shadow": "0 4px 4px 0 #00000005",
          "--tw-shadow-alpha": "100%",
          "--ds-shadow-large": "0px 2px 2px #0000000a, 0px 8px 16px -4px #0000000a",
          "--shadow-sticky": "0 12px 10px -10px #0000001f",
          "--tw-drop-shadow-alpha": "100%",
          "--shadow-large": "0 30px 60px #0000001f",
          "--ds-shadow-small": "0px 2px 2px #0000000a",
          "--shadow-medium": "0 8px 30px #0000001f",
          "--ds-shadow-xl": "0px 1px 1px #00000005, 0px 4px 8px -4px #0000000a, 0px 16px 24px -8px #0000000f",
          "--ds-shadow-modal": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--ds-shadow-medium": "0px 2px 2px #0000000a, 0px 8px 8px -8px #0000000a",
          "--tw-shadow": "0 0 #0000",
          "--shadow-hover": "0 30px 60px #0000001f",
          "--tw-inset-shadow-alpha": "100%",
          "--ds-shadow-2xl": "0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f",
          "--drop-shadow-lg": "0 4px 4px #00000026",
          "--shadow-smallest": "0px 2px 4px #0000001a",
          "--ds-shadow-tooltip": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 4px 8px #0000000a, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--ds-shadow-xs": "0px 1px 2px #0000000a",
          "--ds-shadow-2xs": "0px 1px 1px #0000000a",
          "--shadow-small": "0 5px 10px #0000001f",
          "--ds-shadow-fullscreen": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 8px 16px -4px #0000000a, 0px 24px 32px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--shadow-extra-small": "0px 4px 8px #0000001f",
          "--ds-shadow-menu": "0 0 0 1px #00000014, 0px 1px 1px #00000005, 0px 4px 8px -4px #0000000a, 0px 16px 24px -8px #0000000f, 0 0 0 1px hsla(0, 0%, 98%, 1)",
          "--geist-radius": "6px",
          "--geist-marketing-radius": "8px",
          "--radius-3xl": "1.5rem",
          "--banner-min-height": "64px",
          "--blur-lg": "16px",
          "--geist-cyan-lighter": "#aaffec",
          "--ds-amber-700": "hsla(39, 100%, 57%, 1)",
          "--ds-pink-300-value": "340, 82%, 94%",
          "--ease-in": "cubic-bezier(.4, 0, 1, 1)",
          "--geist-error": "#e00",
          "--ds-amber-900": "hsla(30, 100%, 32%, 1)",
          "--ds-green-200": "hsla(120, 60%, 95%, 1)",
          "--tw-enter-scale": "1",
          "--ds-red-800-value": "358, 70%, 52%",
          "--geist-violet-lighter": "#d8ccf1",
          "--ds-green-1000": "hsla(128, 29%, 15%, 1)",
          "--ds-red-1000": "hsla(355, 49%, 15%, 1)",
          "--wv-orange": "#ffa400",
          "--ds-amber-800-value": "35, 100%, 52%",
          "--ds-gray-alpha-600": "#00000057",
          "--animate-cmdkScaleIn": "cmdkScaleIn .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-300": "hsla(340, 82%, 94%, 1)",
          "--develop-start-gradient": "#007cf0",
          "--geist-violet-background-tertiary": "#eae5f4",
          "--ds-gray-alpha-100": "#0000000d",
          "--ds-teal-700-value": "173, 80%, 36%",
          "--tw-exit-translate-y": "0",
          "--ds-blue-1000": "hsla(211, 100%, 15%, 1)",
          "--tw-gradient-to-position": "100%",
          "--animate-sandbox-left-reverse": "sandbox-left-reverse .5s ease-in-out forwards",
          "--ds-white": "lab(100% 0 0)",
          "--ds-amber-600": "hsla(36, 90%, 62%, 1)",
          "--ds-background-200": "hsla(0, 0%, 98%, 1)",
          "--ds-red-500-value": "0, 82%, 85%",
          "--dropdown-triangle-stroke": "#fff",
          "--ds-blue-400": "hsla(209, 100%, 90%, 1)",
          "--animate-flip-front": "flip-front .5s cubic-bezier(.4, .04, .04, 1) forwards",
          "--ds-teal-700": "hsla(173, 80%, 36%, 1)",
          "--geist-highlight-magenta": "#eb367f",
          "--ds-red-200": "hsla(0, 100%, 96%, 1)",
          "--ds-green-800": "hsla(132, 43%, 39%, 1)",
          "--ds-purple-1000": "hsla(276, 100%, 15%, 1)",
          "--vh100-offset": "calc(64px + 0px)",
          "--ds-green-100-value": "120, 60%, 96%",
          "--ds-gray-500": "hsla(0, 0%, 79%, 1)",
          "--scroller-start": "#fff",
          "--ds-purple-800": "hsla(272, 47%, 45%, 1)",
          "--vaul-overlay-background-end": "#0006",
          "--ds-purple-300": "hsla(274, 78%, 95%, 1)",
          "--ds-amber-500": "hsla(38, 100%, 71%, 1)",
          "--tw-scale-y": "1",
          "--animate-cmdkFadeIn": "cmdkFadeIn .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--scroller-end": "#fff0",
          "--ds-red-700-value": "358, 75%, 59%",
          "--geist-background-rgb": "255, 255, 255",
          "--tw-exit-translate-x": "0",
          "--ds-blue-1000-value": "211, 100%, 15%",
          "--ds-pink-500-value": "340, 75%, 84%",
          "--ds-blue-200-value": "210, 100%, 96%",
          "--header-zindex": "75",
          "--ds-gray-500-value": "0, 0%, 79%",
          "--animate-blue-glow": "blue-glow 3s ease-in-out infinite",
          "--ds-blue-100": "hsla(212, 100%, 97%, 1)",
          "--ds-gray-700": "hsla(0, 0%, 56%, 1)",
          "--ds-teal-800-value": "173, 83%, 30%",
          "--animate-sandbox-left": "sandbox-left .5s ease-in-out forwards",
          "--ds-amber-700-value": "39, 100%, 57%",
          "--ds-teal-200-value": "167, 70%, 94%",
          "--animate-dialogFadeIn": "",
          "--ds-purple-400-value": "276, 71%, 92%",
          "--ds-contrast-fg": "#fff",
          "--tw-enter-blur": "0",
          "--animate-cmdkScaleOut": "cmdkScaleOut .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-amber-1000-value": "20, 79%, 17%",
          "--ds-red-700": "hsla(358, 75%, 59%, 1)",
          "--container-xl": "1200px",
          "--geist-highlight-purple": "#f81ce5",
          "--ds-red-400-value": "0, 90%, 92%",
          "--ds-teal-500": "hsla(170, 70%, 72%, 1)",
          "--geist-code": "#000",
          "--ds-gray-1000-value": "0, 0%, 9%",
          "--ds-teal-1000-value": "171, 80%, 13%",
          "--ds-blue-800-value": "212, 100%, 41%",
          "--geist-warning-lighter": "#ffefcf",
          "--tw-animation-direction": "normal",
          "--ds-blue-400-value": "209, 100%, 90%",
          "--ds-pink-900-value": "336, 65%, 45%",
          "--animate-feedbackFadeIn": "feedbackFadeIn .1s cubic-bezier(.16, 1, .3, 1)",
          "--geist-page-width": "1200px",
          "--ds-purple-100": "hsla(276, 100%, 97%, 1)",
          "--ds-gray-200-value": "0, 0%, 92%",
          "--ds-red-500": "hsla(0, 82%, 85%, 1)",
          "--tw-divide-x-reverse": "0",
          "--ds-blue-600-value": "208, 100%, 66%",
          "--animate-slide-in": "slide-in 1.25s cubic-bezier(.4, .04, .04, 1) forwards",
          "--preview-end-gradient": "#ff0080",
          "--tw-exit-rotate": "0",
          "--develop-end-gradient": "#00dfd8",
          "--ds-purple-600-value": "273, 72%, 73%",
          "--ds-blue-700": "hsla(212, 100%, 48%, 1)",
          "--ds-purple-300-value": "274, 78%, 95%",
          "--ds-amber-600-value": "36, 90%, 62%",
          "--container-sm": "401px",
          "--ds-green-100": "hsla(120, 60%, 96%, 1)",
          "--animate-feedbackAppear": "feedbackAppear .5s .1s ease forwards",
          "--ds-gray-alpha-800": "#00000082",
          "--animate-loading-skeleton": "loading-skeleton 1.5s ease-in-out infinite reverse",
          "--ds-gray-900-value": "0, 0%, 30%",
          "--header-sub-menu-height": "46px",
          "--ds-gray-200": "hsla(0, 0%, 92%, 1)",
          "--ds-overlay-backdrop-opacity": ".8",
          "--ds-blue-500-value": "209, 100%, 80%",
          "--animate-flip-back": "flip-back .5s cubic-bezier(.4, .04, .04, 1) forwards",
          "--ds-green-700": "hsla(131, 41%, 46%, 1)",
          "--ds-amber-100-value": "39, 100%, 95%",
          "--ds-pink-200": "hsla(340, 90%, 96%, 1)",
          "--tw-gradient-from-position": "0%",
          "--ds-pink-700": "hsla(336, 80%, 58%, 1)",
          "--ds-blue-300": "hsla(210, 100%, 94%, 1)",
          "--wv-green": "#0cce6b",
          "--ds-gray-700-value": "0, 0%, 56%",
          "--ds-gray-alpha-700": "#00000070",
          "--ds-gray-300-value": "0, 0%, 90%",
          "--ds-pink-1000": "hsla(333, 74%, 15%, 1)",
          "--ds-red-300-value": "0, 100%, 95%",
          "--ds-gray-alpha-400": "#00000014",
          "--animate-thinking-loader-fast": "thinking-loader .85s linear infinite",
          "--geist-console-purple": "#7928ca",
          "--ds-purple-900-value": "274, 71%, 43%",
          "--ds-gray-400-value": "0, 0%, 92%",
          "--tw-animation-fill-mode": "none",
          "--tw-exit-blur": "0",
          "--animate-feedbackFadeOut": "feedbackFadeOut .2s cubic-bezier(.16, 1, .3, 1) forwards",
          "--ds-red-900-value": "358, 66%, 48%",
          "--ds-pink-500": "hsla(340, 75%, 84%, 1)",
          "--ds-pink-100-value": "330, 100%, 96%",
          "--geist-highlight-pink": "#ff0080",
          "--geist-cyan-light": "#79ffe1",
          "--ds-green-600": "hsla(125, 60%, 64%, 1)",
          "--ds-red-1000-value": "355, 49%, 15%",
          "--vaul-overlay-background-start": "#0000",
          "--ds-green-900": "hsla(133, 50%, 32%, 1)",
          "--geist-cyan": "#50e3c2",
          "--ds-pink-900": "hsla(336, 65%, 45%, 1)",
          "--tw-enter-translate-x": "0",
          "--container-4xl": "56rem",
          "--ds-purple-1000-value": "276, 100%, 15%",
          "--ds-amber-800": "hsla(35, 100%, 52%, 1)",
          "--ds-green-700-value": "131, 41%, 46%",
          "--preview-line-end": "#9a1fb8",
          "--ds-amber-400-value": "42, 100%, 78%",
          "--ds-gray-alpha-500": "#00000036",
          "--ds-green-300": "hsla(120, 60%, 91%, 1)",
          "--animate-fadeInTooltipFaster": "fadeInTooltip .1s ease-in .1s forwards",
          "--ds-green-300-value": "120, 60%, 91%",
          "--ds-blue-900": "hsla(211, 100%, 42%, 1)",
          "--ds-gray-600": "hsla(0, 0%, 66%, 1)",
          "--ds-purple-500": "hsla(274, 70%, 82%, 1)",
          "--ds-green-400": "hsla(122, 60%, 86%, 1)",
          "--ds-pink-800": "hsla(336, 74%, 51%, 1)",
          "--ds-blue-500": "hsla(209, 100%, 80%, 1)",
          "--ds-green-900-value": "133, 50%, 32%",
          "--ds-amber-300-value": "43, 96%, 90%",
          "--animate-blink": "blink 1s infinite",
          "--ds-amber-400": "hsla(42, 100%, 78%, 1)",
          "--tw-enter-opacity": "1",
          "--ds-motion-overlay-scale": ".96",
          "--geist-form-height": "40px",
          "--container-md": "601px",
          "--header-height": "64px",
          "--aspect-video": "16 / 9",
          "--ds-teal-100": "hsla(169, 70%, 96%, 1)",
          "--ds-green-1000-value": "128, 29%, 15%",
          "--develop-line-end": "#019ae9",
          "--animate-loading": "loading 8s ease-in-out infinite",
          "--ds-blue-600": "hsla(208, 100%, 66%, 1)",
          "--tw-animation-delay": "0s",
          "--animate-marquee": "marquee 40s linear infinite",
          "--ds-green-800-value": "132, 43%, 39%",
          "--ds-amber-500-value": "38, 100%, 71%",
          "--geist-success-light": "#3291ff",
          "--tw-outline-style": "solid",
          "--geist-warning-light": "#f7b955",
          "--geist-cyan-dark": "#29bc9b",
          "--geist-success-dark": "#0761d1",
          "--geist-form-small-height": "32px",
          "--header-import-flow-background": "#fafafacc",
          "--ds-black": "lab(0% 0 0)",
          "--ds-pink-200-value": "340, 90%, 96%",
          "--ds-blue-200": "hsla(210, 100%, 96%, 1)",
          "--tw-gradient-from": "rgba(0, 0, 0, 0)",
          "--tw-gradient-to": "rgba(0, 0, 0, 0)",
          "--ds-pink-600": "hsla(341, 75%, 73%, 1)",
          "--ds-gray-800": "hsla(0, 0%, 49%, 1)",
          "--geist-violet-light": "#8a63d2",
          "--ds-teal-1000": "hsla(171, 80%, 13%, 1)",
          "--ds-gray-300": "hsla(0, 0%, 90%, 1)",
          "--ds-purple-600": "hsla(273, 72%, 73%, 1)",
          "--tw-gradient-via-position": "50%",
          "--ds-amber-1000": "hsla(20, 79%, 17%, 1)",
          "--ds-amber-200": "hsla(44, 100%, 92%, 1)",
          "--ds-teal-300-value": "168, 70%, 90%",
          "--default-transition-duration": ".15s",
          "--animate-pulse": "pulse 2s cubic-bezier(.4, 0, .6, 1) infinite",
          "--ds-pink-700-value": "336, 80%, 58%",
          "--container-xs": "20rem",
          "--ds-gray-1000": "hsla(0, 0%, 9%, 1)",
          "--ds-purple-200-value": "277, 87%, 97%",
          "--ds-teal-400-value": "170, 70%, 85%",
          "--ds-green-600-value": "125, 60%, 64%",
          "--banner-height": "0px",
          "--ds-red-200-value": "0, 100%, 96%",
          "--ds-blue-900-value": "211, 100%, 42%",
          "--default-transition-timing-function": "cubic-bezier(.4, 0, .2, 1)",
          "--tw-animation-iteration-count": "1",
          "--tw-exit-opacity": "1",
          "--ds-teal-500-value": "170, 70%, 72%",
          "--ds-motion-overlay-timing": "cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-800-value": "336, 74%, 51%",
          "--tw-translate-z": "0",
          "--tw-gradient-via": "rgba(0, 0, 0, 0)",
          "--ds-pink-400": "hsla(341, 76%, 91%, 1)",
          "--geist-violet-dark": "#4c2889",
          "--ai-chat-panel-width": "0px",
          "--container-3xl": "48rem",
          "--blur-xs": "4px",
          "--tw-translate-y": "0",
          "--ease-out": "cubic-bezier(0, 0, .2, 1)",
          "--ship-start-gradient": "#ff4d4d",
          "--ds-gray-100": "hsla(0, 0%, 95%, 1)",
          "--ds-page-width": "1400px",
          "--tw-content": "\"\"",
          "--ds-teal-100-value": "169, 70%, 96%",
          "--animate-thinking-loader": "thinking-loader 1.5s linear infinite",
          "--ds-purple-500-value": "274, 70%, 82%",
          "--ds-teal-300": "hsla(168, 70%, 90%, 1)",
          "--tw-translate-x": "0",
          "--tw-enter-rotate": "0",
          "--ds-gray-100-value": "0, 0%, 95%",
          "--ds-gray-alpha-1000": "#000000e8",
          "--geist-error-lighter": "#f7d4d6",
          "--animate-bounce": "bounce 1s infinite",
          "--ds-red-300": "hsla(0, 100%, 95%, 1)",
          "--ds-purple-900": "hsla(274, 71%, 43%, 1)",
          "--ds-background-100": "hsla(0, 0%, 100%, 1)",
          "--ds-gray-alpha-300": "#0000001a",
          "--animate-fadeInTooltip": "fadeInTooltip .1s ease-in .4s forwards",
          "--ds-red-400": "hsla(0, 90%, 92%, 1)",
          "--geist-marketing-gray": "#fafbfc",
          "--ds-red-600": "hsla(359, 90%, 71%, 1)",
          "--ds-blue-300-value": "210, 100%, 94%",
          "--ds-teal-900-value": "174, 91%, 25%",
          "--ds-motion-timing-swift": "cubic-bezier(.175, .885, .32, 1.1)",
          "--ds-pink-400-value": "341, 76%, 91%",
          "--ds-pink-1000-value": "333, 74%, 15%",
          "--ds-purple-400": "hsla(276, 71%, 92%, 1)",
          "--ds-blue-800": "hsla(212, 100%, 41%, 1)",
          "--ds-amber-900-value": "30, 100%, 32%",
          "--geist-form-large-height": "48px",
          "--geist-warning": "#f5a623",
          "--geist-error-dark": "#c50000",
          "--ds-motion-overlay-duration": ".3s",
          "--ds-purple-800-value": "272, 47%, 45%",
          "--ds-gray-alpha-900": "#000000b3",
          "--wv-red": "#ff4e42",
          "--ds-gray-900": "hsla(0, 0%, 30%, 1)",
          "--geist-violet": "#7928ca",
          "--ship-line-end": "#f9cb28",
          "--geist-console-header": "#efe7ed",
          "--geist-success-lighter": "#d3e5ff",
          "--ds-red-100-value": "0, 100%, 97%",
          "--geist-error-light": "#ff1a1a",
          "--animate-accordion-down": "accordion-down .2s ease-out",
          "--ds-purple-100-value": "276, 100%, 97%",
          "--tw-scale-z": "1",
          "--ds-red-800": "hsla(358, 70%, 52%, 1)",
          "--ds-purple-700-value": "272, 51%, 54%",
          "--ds-amber-300": "hsla(43, 96%, 90%, 1)",
          "--tw-scroll-snap-strictness": "proximity",
          "--ds-background-200-value": "0, 0%, 98%",
          "--container-lg": "961px",
          "--ds-green-500": "hsla(124, 60%, 75%, 1)",
          "--geist-highlight-yellow": "#fff500",
          "--ds-green-400-value": "122, 60%, 86%",
          "--ds-blue-700-value": "212, 100%, 48%",
          "--ds-pink-100": "hsla(330, 100%, 96%, 1)",
          "--geist-success": "#0070f3",
          "--ds-teal-600": "hsla(170, 70%, 57%, 1)",
          "--ds-green-500-value": "124, 60%, 75%",
          "--ds-gray-alpha-200": "#00000014",
          "--ds-gray-400": "hsla(0, 0%, 92%, 1)",
          "--ease-in-out": "cubic-bezier(.4, 0, .2, 1)",
          "--animate-cmdkFadeOut": "cmdkFadeOut .3s cubic-bezier(.175, .885, .32, 1.1)",
          "--vaul-overlay-background": "255, 255, 255",
          "--ds-gray-600-value": "0, 0%, 66%",
          "--value": "0",
          "--animate-accordion-up": "accordion-up .2s ease-out",
          "--animate-sandbox-right": "sandbox-right .5s ease-in-out forwards",
          "--preview-start-gradient": "#7928ca",
          "--animate-logo-carousel": "logo-carousel ease-in-out infinite",
          "--ds-teal-900": "hsla(174, 91%, 25%, 1)",
          "--container-5xl": "64rem",
          "--ds-amber-100": "hsla(39, 100%, 95%, 1)",
          "--animate-sandbox-right-reverse": "sandbox-right-reverse .5s ease-in-out forwards",
          "--footer-height": "79px",
          "--ds-red-900": "hsla(358, 66%, 48%, 1)",
          "--geist-background": "#fff",
          "--ds-red-600-value": "359, 90%, 71%",
          "--perspective-distant": "1200px",
          "--ds-background-100-value": "0, 0%, 100%",
          "--geist-selection": "hsla(0, 0%, 9%, 1)",
          "--ds-teal-400": "hsla(170, 70%, 85%, 1)",
          "--ds-purple-700": "hsla(272, 51%, 54%, 1)",
          "--animate-spin": "spin 1s linear infinite",
          "--geist-warning-dark": "#ab570a",
          "--ds-gray-800-value": "0, 0%, 49%",
          "--ds-blue-100-value": "212, 100%, 97%",
          "--tw-divide-y-reverse": "0",
          "--ds-teal-200": "hsla(167, 70%, 94%, 1)",
          "--tw-exit-scale": "1",
          "--container-2xl": "1400px",
          "--ds-purple-200": "hsla(277, 87%, 97%, 1)",
          "--ds-amber-200-value": "44, 100%, 92%",
          "--tw-scale-x": "1",
          "--tw-enter-translate-y": "0",
          "--animate-dialogFadeOut": "",
          "--ds-teal-600-value": "170, 70%, 57%",
          "--ds-green-200-value": "120, 60%, 95%",
          "--ship-end-gradient": "#f9cb28",
          "--ds-red-100": "hsla(0, 100%, 97%, 1)",
          "--geist-violet-background": "#fff",
          "--ds-pink-600-value": "341, 75%, 73%",
          "--ds-teal-800": "hsla(173, 83%, 30%, 1)",
          "--blur-sm": "8px",
          "--animate-cmdkLoading": "cmdkLoading 1.1s cubic-bezier(.455, .03, .515, .955) infinite",
          "--rhythm-section": "12rem",
          "--rhythm-subsection": "1.5rem",
          "--rhythm-heading-to-body": "0.75rem",
          "--rhythm-body-to-cta": "1rem",
          "--rhythm-intra-list": "1.5rem",
          "--stack-heading-size": "12px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "12px",
          "--stack-body-size": "14px",
          "--stack-body-weight": "400",
          "--stack-body-line-height": "21px"
        },
        "meta": {
          "extractedAt": "2026-05-09T09:11:08.045Z"
        }
      }
    },
    "defaultMode": "light"
  },
  {
    "slug": "workos",
    "name": "WorkOS",
    "source": "https://workos.com",
    "radius": "5px",
    "fonts": {
      "body": {
        "name": "Untitled Sans",
        "fallback": "sans-serif"
      }
    },
    "modes": {
      "light": {
        "colors": {
          "background": "hsl(0, 0%, 100%)",
          "foreground": "hsl(0, 0%, 0%)",
          "primary": "hsl(240, 78%, 66%)",
          "primary-foreground": "hsl(0, 0%, 100%)",
          "secondary": "hsl(242, 50%, 55%)",
          "secondary-foreground": "hsl(0, 0%, 100%)",
          "muted": "hsl(0, 0%, 100%)",
          "muted-foreground": "hsl(231, 6%, 57%)",
          "border": "hsl(216, 12%, 92%)"
        },
        "allVars": {
          "--color-primary": "#6665ec",
          "--color-secondary": "#5753c6",
          "--color-neutral-50": "#e5e7eb",
          "--color-neutral-100": "#000000",
          "--color-neutral-200": "#202020",
          "--color-neutral-300": "#ffffff",
          "--color-bg": "#ffffff",
          "--color-text": "#000000",
          "--color-text-1": "#202020",
          "--color-text-2": "#ffffff",
          "--color-text-3": "#5753c6",
          "--font-body": "'Arial', sans-serif",
          "--font-heading": "'__interFont_6d6793', sans-serif",
          "--font-size-24": "24px",
          "--font-size-16": "16px",
          "--font-size-14": "14px",
          "--font-size-12": "12px",
          "--spacing-1": "1px",
          "--spacing-48": "48px",
          "--spacing-64": "64px",
          "--radius-sm": "5px",
          "--shadow-sm": "rgba(0, 0, 0, 0) 0px 0px 0px 1px inset",
          "--branded-link-text-decoration-color": "#5753c666",
          "--branded-button-color": "#FFFFFF",
          "--branded-link-color": "#5753C6",
          "--branded-button-box-shadow-color": "transparent",
          "--inter-variable-font": "\"__interFont_6d6793\",\"__interFont_Fallback_6d6793\"",
          "--bronze-a12": "#1d0600d4",
          "--violet-a6": "#3100fb35",
          "--ruby-a10": "#d2002cc4",
          "--olive-6": "#d7dad7",
          "--iris-11": "#5753c6",
          "--red-a7": "#df000356",
          "--green-a11": "#00713fde",
          "--amber-2": "#fefbe9",
          "--bronze-a11": "#3d0f00ab",
          "--mint-2": "#f2fbf9",
          "--cyan-2": "#f2fafb",
          "--indigo-a2": "#0040ff08",
          "--tomato-a1": "#ff000003",
          "--indigo-3": "#edf2fe",
          "--plum-a11": "#730086c1",
          "--blue-contrast": "#fff",
          "--jade-a4": "#00a85129",
          "--yellow-11": "#9e6c00",
          "--sage-track": "#868e8b",
          "--pink-a4": "#e2008b23",
          "--gold-9": "#978365",
          "--tomato-a11": "#cd2200ea",
          "--amber-12": "#4f3422",
          "--brown-12": "#3e332e",
          "--olive-a10": "#040e0082",
          "--ruby-7": "#efacb8",
          "--violet-contrast": "#fff",
          "--mauve-12": "#211f26",
          "--tomato-track": "#e54d2e",
          "--purple-a12": "#250049df",
          "--bronze-contrast": "#fff",
          "--orange-surface": "#fff5e9cc",
          "--plum-1": "#fefcff",
          "--tomato-a5": "#ff2e003d",
          "--white-a1": "hsla(0,0%,100%,.05)",
          "--lime-surface": "#f6f9f0cc",
          "--mint-a4": "#00cc9937",
          "--violet-a3": "#4400ee0f",
          "--orange-9": "#f76b15",
          "--crimson-a9": "#e2005bc2",
          "--orange-11": "#cc4e00",
          "--sky-7": "#8dcae3",
          "--green-a9": "#008f4acf",
          "--amber-contrast": "#21201c",
          "--purple-a9": "#5c00adb1",
          "--mint-a8": "#009e7fb3",
          "--amber-a12": "#341500dd",
          "--indigo-a10": "#002ec9cc",
          "--teal-indicator": "#12a594",
          "--cyan-a9": "#00a2c7",
          "--orange-1": "#fefcfb",
          "--mint-4": "#c8f4e9",
          "--slate-a10": "#00071b7f",
          "--sand-a6": "#19130029",
          "--plum-a10": "#7f0092bb",
          "--iris-a4": "#000bff19",
          "--amber-a8": "#da8a00c9",
          "--slate-a3": "#0000330f",
          "--cyan-a11": "#007491ef",
          "--crimson-a11": "#c4004fe2",
          "--bronze-7": "#d3bcb3",
          "--red-a4": "#ff000824",
          "--sage-a2": "#00402008",
          "--mauve-7": "#d0cdd7",
          "--orange-a1": "#c0400004",
          "--plum-11": "#953ea3",
          "--sand-6": "#dad9d6",
          "--lime-a6": "#72aa006e",
          "--jade-a2": "#00a3460b",
          "--yellow-a8": "#c99700c6",
          "--grass-surface": "#f3faf3cc",
          "--bronze-a4": "#80280020",
          "--orange-a11": "#cc4e00",
          "--indigo-a9": "#0031d2c1",
          "--crimson-a5": "#e5004f31",
          "--gray-a5": "#0000001f",
          "--indigo-9": "#3e63dd",
          "--cyan-a4": "#00bcd435",
          "--grass-4": "#daf1db",
          "--mint-1": "#f9fefd",
          "--cyan-contrast": "#fff",
          "--brown-a5": "#9f4d0035",
          "--purple-1": "#fefcfe",
          "--grass-2": "#f5fbf5",
          "--ruby-surface": "#fff5f6cc",
          "--sky-4": "#d1f0fa",
          "--olive-12": "#1d211c",
          "--amber-a3": "#ffde003d",
          "--violet-9": "#6e56cf",
          "--teal-12": "#0d3d38",
          "--yellow-indicator": "#ffdc00",
          "--mauve-a12": "#020008e0",
          "--gold-8": "#b9a88d",
          "--black-a1": "rgba(0,0,0,.05)",
          "--white-a10": "hsla(0,0%,100%,.8)",
          "--sage-contrast": "#fff",
          "--violet-a4": "#4300ff1b",
          "--jade-a9": "#00916bd6",
          "--jade-3": "#e6f7ed",
          "--plum-a4": "#c200c921",
          "--tomato-9": "#e54d2e",
          "--blue-9": "#0090ff",
          "--lime-a4": "#8fc60042",
          "--mint-8": "#4cbba5",
          "--lime-a10": "#8fdc00b3",
          "--iris-a2": "#0000ff07",
          "--red-contrast": "#fff",
          "--cyan-10": "#0797b9",
          "--ruby-8": "#e592a3",
          "--sand-a1": "#55550003",
          "--teal-11": "#008573",
          "--tomato-5": "#ffcdc2",
          "--yellow-7": "#e4c767",
          "--iris-a7": "#0008e647",
          "--gold-a12": "#130c00d4",
          "--amber-a2": "#f4d10016",
          "--ruby-a12": "#550016e8",
          "--tomato-3": "#feebe7",
          "--black-a10": "rgba(0,0,0,.8)",
          "--plum-a5": "#b700bd2e",
          "--iris-12": "#272962",
          "--ruby-a6": "#e4002440",
          "--blue-a10": "#0086f0fa",
          "--purple-a4": "#8d00e51d",
          "--iris-a1": "#0000ff02",
          "--blue-a4": "#009eff2a",
          "--indigo-a7": "#0037ed54",
          "--slate-a1": "#00005503",
          "--slate-a4": "#00002d17",
          "--teal-2": "#f3fbf9",
          "--olive-a12": "#010600e3",
          "--iris-8": "#9b9ef0",
          "--olive-a5": "#00180020",
          "--mauve-a10": "#0500197d",
          "--green-a6": "#00963c52",
          "--red-7": "#f4a9aa",
          "--slate-1": "#fcfcfd",
          "--white-a7": "hsla(0,0%,100%,.5)",
          "--branded-button-background": "#6665EC",
          "--amber-10": "#ffba18",
          "--mauve-a9": "#05001d73",
          "--blue-8": "#5eb1ef",
          "--brown-3": "#f6eee7",
          "--grass-a8": "#008d199a",
          "--slate-3": "#f0f0f3",
          "--olive-surface": "#ffffffcc",
          "--lime-track": "#bdee63",
          "--sky-a11": "#00749e",
          "--lime-a3": "#96c80029",
          "--purple-12": "#402060",
          "--ruby-a9": "#db002cb9",
          "--yellow-a10": "#ffdc00",
          "--red-a2": "#ff000008",
          "--brown-1": "#fefdfc",
          "--pink-3": "#fee9f5",
          "--slate-7": "#cdced6",
          "--grass-a1": "#00c00004",
          "--pink-a10": "#c2007ac7",
          "--iris-a10": "#0000b6ae",
          "--grass-5": "#c9e8ca",
          "--ruby-indicator": "#e54666",
          "--lime-a5": "#81bb0059",
          "--tomato-a2": "#ff200008",
          "--teal-a8": "#009783ac",
          "--olive-4": "#e7e9e7",
          "--pink-a1": "#ff00aa03",
          "--bronze-4": "#efe4df",
          "--mint-a2": "#00b18a0d",
          "--slate-a7": "#00062e32",
          "--bronze-surface": "#fdf5f3cc",
          "--amber-3": "#fff7c2",
          "--orange-4": "#ffdfb5",
          "--mauve-2": "#faf9fb",
          "--red-track": "#e5484d",
          "--lime-8": "#8db654",
          "--yellow-contrast": "#21201c",
          "--indigo-a12": "#001046e0",
          "--indigo-1": "#fdfdfe",
          "--bronze-track": "#a18072",
          "--jade-a12": "#002217e2",
          "--white-a6": "hsla(0,0%,100%,.4)",
          "--ruby-a7": "#ce002553",
          "--grass-6": "#b2ddb5",
          "--sand-a3": "#20100010",
          "--bronze-3": "#f6edea",
          "--black-a6": "rgba(0,0,0,.4)",
          "--gold-2": "#faf9f2",
          "--amber-a11": "#ab6400",
          "--bronze-a9": "#551a008d",
          "--plum-a9": "#89009eb5",
          "--teal-a3": "#00c69d1f",
          "--sand-a9": "#0f0f0079",
          "--sage-8": "#b8bcba",
          "--red-a6": "#f8000442",
          "--tomato-4": "#ffdcd3",
          "--olive-a8": "#040f0047",
          "--sage-a4": "#001f1519",
          "--olive-8": "#b9bcb8",
          "--mauve-track": "#8e8c99",
          "--ruby-1": "#fffcfd",
          "--jade-a1": "#00c08004",
          "--tomato-2": "#fff8f7",
          "--green-10": "#2b9a66",
          "--iris-a11": "#0600abac",
          "--bronze-5": "#e7d9d3",
          "--mauve-a2": "#2b005506",
          "--sky-a7": "#0089c172",
          "--lime-11": "#5c7c2f",
          "--sage-7": "#cbcfcd",
          "--olive-9": "#898e87",
          "--pink-10": "#cf3897",
          "--jade-1": "#fbfefd",
          "--purple-a7": "#6d00c350",
          "--brown-track": "#ad7f58",
          "--indigo-2": "#f7f9ff",
          "--yellow-3": "#fffab8",
          "--tomato-contrast": "#fff",
          "--gray-9": "#8d8d8d",
          "--sky-surface": "#eef9fdcc",
          "--yellow-5": "#ffe770",
          "--teal-3": "#e0f8f3",
          "--iris-a6": "#000aff34",
          "--violet-5": "#e1d9ff",
          "--grass-indicator": "#46a758",
          "--orange-a10": "#ef5f00",
          "--green-a4": "#00a83829",
          "--pink-1": "#fffcfe",
          "--gold-a2": "#9d8a000d",
          "--crimson-a6": "#d0004b41",
          "--cyan-5": "#b5e9f0",
          "--tomato-6": "#fdbdaf",
          "--orange-indicator": "#f76b15",
          "--sand-1": "#fdfdfc",
          "--crimson-a12": "#530026e9",
          "--mauve-a8": "#08003145",
          "--slate-11": "#60646c",
          "--amber-4": "#ffee9c",
          "--bronze-6": "#dfcdc5",
          "--sand-surface": "#ffffffcc",
          "--teal-9": "#12a594",
          "--iris-6": "#cbcdff",
          "--slate-6": "#d9d9e0",
          "--sand-8": "#bcbbb5",
          "--ruby-a8": "#c300286d",
          "--blue-a2": "#008cff0b",
          "--grass-9": "#46a758",
          "--violet-1": "#fdfcfe",
          "--indigo-5": "#d2deff",
          "--gray-4": "#e8e8e8",
          "--white-a11": "hsla(0,0%,100%,.9)",
          "--lime-2": "#f8faf3",
          "--iris-a9": "#0000c0a4",
          "--orange-a8": "#e35f00aa",
          "--mint-3": "#ddf9f2",
          "--branded-button-hover-background": "#5b59d7",
          "--iris-a12": "#000246d8",
          "--gold-5": "#e1dccf",
          "--brown-a2": "#aa550009",
          "--brown-indicator": "#ad7f58",
          "--gold-a10": "#492d00a1",
          "--olive-a2": "#00490007",
          "--indigo-contrast": "#fff",
          "--violet-a5": "#3600ff26",
          "--gray-2": "#f9f9f9",
          "--teal-7": "#83cdc1",
          "--yellow-6": "#f3d768",
          "--crimson-4": "#fedce7",
          "--mint-a5": "#00c0914c",
          "--gray-3": "#f0f0f0",
          "--orange-a3": "#ff9c0029",
          "--plum-9": "#ab4aba",
          "--plum-a8": "#9000a56e",
          "--orange-10": "#ef5f00",
          "--crimson-11": "#cb1d63",
          "--amber-7": "#e9c162",
          "--orange-3": "#ffefd6",
          "--violet-a7": "#2d01dd4a",
          "--plum-a1": "#aa00ff03",
          "--olive-a9": "#050f0078",
          "--mauve-a3": "#30004010",
          "--ruby-12": "#64172b",
          "--brown-2": "#fcf9f6",
          "--sage-6": "#d7dad9",
          "--sand-a5": "#1f180021",
          "--plum-a2": "#c000c008",
          "--iris-contrast": "#fff",
          "--orange-a9": "#f65e00ea",
          "--gray-track": "#8d8d8d",
          "--mauve-a5": "#20003820",
          "--grass-a2": "#0099000a",
          "--teal-10": "#0d9b8a",
          "--brown-9": "#ad7f58",
          "--gray-a12": "#000000df",
          "--jade-surface": "#f1faf5cc",
          "--lime-a12": "#1e2900e3",
          "--sage-a11": "#000a07a0",
          "--white-a12": "hsla(0,0%,100%,.95)",
          "--mint-a11": "#007763fd",
          "--amber-a9": "#ffb300c2",
          "--pink-a5": "#d1008331",
          "--ruby-a3": "#f3002515",
          "--orange-track": "#f76b15",
          "--green-a1": "#00c04004",
          "--red-a12": "#55000de8",
          "--grass-a12": "#002006df",
          "--gold-3": "#f2f0e7",
          "--mauve-5": "#e3dfe6",
          "--lime-a2": "#6b95000c",
          "--red-a3": "#f3000d14",
          "--purple-11": "#8145b5",
          "--blue-2": "#f4faff",
          "--sage-a12": "#000805e5",
          "--teal-a9": "#009e8ced",
          "--jade-a3": "#00ae4819",
          "--orange-a12": "#431200e2",
          "--blue-a3": "#008ff519",
          "--yellow-8": "#d5ae39",
          "--ruby-a11": "#c10030db",
          "--gold-surface": "#f9f8efcc",
          "--iris-5": "#dadcff",
          "--yellow-a12": "#2e2000e0",
          "--pink-12": "#651249",
          "--cyan-a2": "#009db10d",
          "--amber-5": "#fbe577",
          "--teal-4": "#ccf3ea",
          "--teal-a12": "#00332df2",
          "--iris-a8": "#0008d964",
          "--gray-6": "#d9d9d9",
          "--red-indicator": "#e5484d",
          "--red-a8": "#d2000571",
          "--sand-7": "#cfceca",
          "--mint-7": "#7ecfbd",
          "--slate-5": "#e0e1e6",
          "--gray-a7": "#00000031",
          "--black-a11": "rgba(0,0,0,.9)",
          "--brown-a1": "#aa550003",
          "--sand-3": "#f1f0ef",
          "--blue-12": "#113264",
          "--amber-6": "#f3d673",
          "--yellow-1": "#fdfdf9",
          "--cyan-6": "#9ddde7",
          "--indigo-11": "#3a5bc7",
          "--amber-a4": "#ffd40063",
          "--violet-a9": "#2400b7a9",
          "--amber-a10": "#ffb300e7",
          "--mauve-a11": "#0400119c",
          "--gray-8": "#bbb",
          "--cyan-a3": "#00c2d121",
          "--teal-a6": "#00a6855e",
          "--orange-contrast": "#fff",
          "--brown-11": "#815e46",
          "--indigo-4": "#e1e9ff",
          "--lime-a11": "#375f00d0",
          "--white-a4": "hsla(0,0%,100%,.2)",
          "--gray-contrast": "#fff",
          "--gold-12": "#3b352b",
          "--violet-a1": "#5500aa03",
          "--mauve-11": "#65636d",
          "--gray-a1": "#00000003",
          "--teal-a2": "#00aa800c",
          "--green-12": "#193b2d",
          "--sand-11": "#63635e",
          "--sand-contrast": "#fff",
          "--indigo-10": "#3358d4",
          "--ruby-10": "#dc3b5d",
          "--sand-4": "#e9e8e6",
          "--teal-8": "#53b9ab",
          "--olive-a7": "#000f0033",
          "--gold-track": "#978365",
          "--blue-a11": "#006dcbf2",
          "--mint-5": "#b3ecde",
          "--indigo-a11": "#002bb7c5",
          "--grass-12": "#203c25",
          "--gray-a8": "#00000044",
          "--blue-a9": "#0090ff",
          "--sage-4": "#e6e9e8",
          "--tomato-a3": "#f52b0018",
          "--green-a3": "#00a43319",
          "--iris-indicator": "#5b5bd6",
          "--green-a7": "#00914071",
          "--crimson-3": "#ffe9f0",
          "--olive-11": "#60655f",
          "--tomato-10": "#dd4425",
          "--red-a11": "#c40006d3",
          "--plum-10": "#a144af",
          "--yellow-a4": "#ffe3016b",
          "--sky-12": "#1d3e56",
          "--black-a12": "rgba(0,0,0,.95)",
          "--mint-10": "#7de0cb",
          "--brown-a12": "#140600d1",
          "--orange-6": "#ffc182",
          "--crimson-7": "#eaacc3",
          "--sky-a9": "#00c7fe83",
          "--brown-a4": "#9b4a0026",
          "--amber-a5": "#f8cf0088",
          "--teal-5": "#b8eae0",
          "--bronze-a8": "#671c0066",
          "--blue-4": "#d5efff",
          "--brown-10": "#a07553",
          "--cyan-a8": "#00a3c0c2",
          "--blue-a5": "#0093ff3d",
          "--brown-a6": "#a04e0048",
          "--slate-a5": "#0009321f",
          "--indigo-8": "#8da4ef",
          "--ruby-5": "#ffced6",
          "--gray-a6": "#00000026",
          "--crimson-9": "#e93d82",
          "--jade-a6": "#009a5753",
          "--cyan-a6": "#00a7c162",
          "--olive-2": "#f8faf8",
          "--jade-contrast": "#fff",
          "--sky-10": "#74daf8",
          "--jade-indicator": "#29a383",
          "--pink-11": "#c2298a",
          "--iris-surface": "#f6f6ffcc",
          "--violet-7": "#c2b5f5",
          "--gold-a5": "#60460030",
          "--mauve-a4": "#20003618",
          "--sky-a12": "#002540e2",
          "--mauve-indicator": "#8e8c99",
          "--purple-5": "#ead5f9",
          "--teal-track": "#12a594",
          "--crimson-indicator": "#e93d82",
          "--amber-surface": "#fefae4cc",
          "--gold-a8": "#633d0072",
          "--indigo-6": "#c1d0ff",
          "--cyan-12": "#0d3c48",
          "--sand-a2": "#25250007",
          "--green-surface": "#f1faf4cc",
          "--sand-a10": "#0c0c0083",
          "--mauve-9": "#8e8c99",
          "--cyan-9": "#00a2c7",
          "--tomato-8": "#ec8e7b",
          "--purple-a8": "#6600c06c",
          "--crimson-2": "#fef7f9",
          "--slate-4": "#e8e8ec",
          "--purple-track": "#8e4ec6",
          "--teal-a11": "#008573",
          "--cyan-3": "#def7f9",
          "--gold-a3": "#75600018",
          "--gold-10": "#8c7a5e",
          "--yellow-a3": "#ffee0047",
          "--ruby-4": "#ffdce1",
          "--red-1": "#fffcfc",
          "--crimson-8": "#e093b2",
          "--iris-track": "#5b5bd6",
          "--tomato-12": "#5c271f",
          "--yellow-a6": "#ebbc0097",
          "--slate-12": "#1c2024",
          "--violet-indicator": "#6e56cf",
          "--branded-button-active-background": "#4f4ac7",
          "--mint-11": "#027864",
          "--brown-4": "#f0e4d9",
          "--violet-12": "#2f265f",
          "--slate-2": "#f9f9fb",
          "--jade-a8": "#00976ea9",
          "--mauve-contrast": "#fff",
          "--crimson-a10": "#d70056cb",
          "--white-a9": "hsla(0,0%,100%,.7)",
          "--red-6": "#fdbdbe",
          "--tomato-a9": "#df2600d1",
          "--pink-a12": "#59003bed",
          "--purple-6": "#e0c4f4",
          "--sky-a8": "#0085bf9f",
          "--jade-a7": "#00945f74",
          "--red-a9": "#db0007b7",
          "--lime-5": "#d3e7a6",
          "--lime-6": "#c2da91",
          "--blue-indicator": "#0090ff",
          "--olive-3": "#eff1ef",
          "--lime-a1": "#66990005",
          "--jade-8": "#56ba9f",
          "--ruby-2": "#fff7f8",
          "--jade-a10": "#008764d9",
          "--lime-7": "#abc978",
          "--mint-indicator": "#86ead4",
          "--crimson-a7": "#bf004753",
          "--grass-1": "#fbfefb",
          "--bronze-2": "#fdf7f5",
          "--grass-a5": "#00930536",
          "--gold-a4": "#6b4e0024",
          "--amber-8": "#e2a336",
          "--bronze-a3": "#92250015",
          "--lime-4": "#e2f0bd",
          "--grass-8": "#65ba74",
          "--gold-4": "#eae6db",
          "--violet-track": "#6e56cf",
          "--sage-indicator": "#868e8b",
          "--indigo-a5": "#0044ff2d",
          "--jade-12": "#1d3b31",
          "--gold-6": "#d8d0bf",
          "--crimson-surface": "#fef5f8cc",
          "--slate-a11": "#0007149f",
          "--slate-track": "#8b8d98",
          "--mauve-surface": "#ffffffcc",
          "--grass-a6": "#008f0a4d",
          "--lime-9": "#bdee63",
          "--slate-a9": "#00051d74",
          "--pink-7": "#e7acd0",
          "--orange-a2": "#ff8e0012",
          "--green-9": "#30a46c",
          "--bronze-9": "#a18072",
          "--olive-10": "#7f847d",
          "--ak-logo-light-display": "block",
          "--slate-10": "#80838d",
          "--iris-9": "#5b5bd6",
          "--pink-5": "#f6cee7",
          "--violet-6": "#d4cafe",
          "--pink-4": "#fbdcef",
          "--sky-2": "#f1fafd",
          "--amber-1": "#fefdfb",
          "--crimson-12": "#621639",
          "--gold-a1": "#55550003",
          "--sage-surface": "#ffffffcc",
          "--brown-a8": "#9f4a0081",
          "--brown-7": "#dcbc9f",
          "--ruby-track": "#e54666",
          "--gray-a9": "#00000072",
          "--green-7": "#8eceaa",
          "--sage-2": "#f7f9f8",
          "--violet-4": "#ebe4ff",
          "--plum-2": "#fdf7fd",
          "--pink-contrast": "#fff",
          "--lime-contrast": "#1d211c",
          "--bronze-11": "#7d5e54",
          "--ruby-9": "#e54666",
          "--green-2": "#f4fbf6",
          "--brown-a10": "#723300ac",
          "--lime-a8": "#559200ab",
          "--white-a5": "hsla(0,0%,100%,.3)",
          "--crimson-track": "#e93d82",
          "--gray-a2": "#00000006",
          "--cyan-a7": "#009fbb82",
          "--violet-a12": "#0b0043d9",
          "--purple-4": "#f2e2fc",
          "--olive-track": "#898e87",
          "--pink-indicator": "#d6409f",
          "--blue-a12": "#002359ee",
          "--blue-track": "#0090ff",
          "--pink-a11": "#b60074d6",
          "--sage-a9": "#00110b79",
          "--grass-contrast": "#fff",
          "--blue-a8": "#0084e6a1",
          "--red-8": "#eb8e90",
          "--sage-a8": "#000f0847",
          "--purple-a11": "#52009aba",
          "--tomato-a7": "#e7280067",
          "--amber-track": "#ffc53d",
          "--ruby-a2": "#ff002008",
          "--lime-3": "#eef6d6",
          "--bronze-a6": "#7324003a",
          "--purple-a5": "#8000db2a",
          "--gray-10": "#838383",
          "--blue-3": "#e6f4fe",
          "--bronze-a2": "#cc33000a",
          "--violet-a10": "#2300abb2",
          "--olive-a4": "#00160018",
          "--jade-4": "#d6f1e3",
          "--sky-5": "#bee7f5",
          "--sky-a2": "#00a4db0e",
          "--teal-a7": "#0099807c",
          "--cyan-a10": "#0094b7f8",
          "--green-3": "#e6f6eb",
          "--red-10": "#dc3e42",
          "--red-12": "#641723",
          "--pink-2": "#fef7fb",
          "--sage-12": "#1a211e",
          "--teal-a4": "#00c39633",
          "--tomato-a4": "#ff35002c",
          "--sand-a11": "#080800a1",
          "--plum-12": "#53195d",
          "--sand-10": "#82827c",
          "--green-5": "#c4e8d1",
          "--pink-a9": "#c8007fbf",
          "--branded-page-background": "#FFFFFF",
          "--black-a3": "rgba(0,0,0,.15)",
          "--grass-7": "#94ce9a",
          "--purple-8": "#be93e4",
          "--gray-11": "#646464",
          "--green-a5": "#019c393b",
          "--plum-6": "#e9c2ec",
          "--ak-logo-dark-display": "none",
          "--lime-a7": "#61990087",
          "--iris-4": "#e6e7ff",
          "--violet-a8": "#2b00d066",
          "--cyan-11": "#107d98",
          "--amber-11": "#ab6400",
          "--grass-10": "#3e9b4f",
          "--blue-10": "#0588f0",
          "--brown-a9": "#823c00a7",
          "--crimson-10": "#df3478",
          "--sky-indicator": "#7ce2fe",
          "--tomato-surface": "#fff6f5cc",
          "--blue-surface": "#f1f9ffcc",
          "--brown-5": "#ebdaca",
          "--iris-a3": "#0011ee0f",
          "--crimson-a8": "#b6004a6c",
          "--pink-a6": "#c0007840",
          "--red-5": "#ffcdce",
          "--blue-6": "#acd8fc",
          "--mauve-a7": "#10003332",
          "--gray-12": "#202020",
          "--pink-8": "#dd93c2",
          "--tomato-1": "#fffcfc",
          "--mauve-4": "#eae7ec",
          "--gold-a11": "#362100b4",
          "--slate-a12": "#000509e3",
          "--gold-a7": "#63420055",
          "--pink-track": "#d6409f",
          "--cyan-surface": "#eff9facc",
          "--gray-5": "#e0e0e0",
          "--orange-7": "#f5ae73",
          "--gray-indicator": "#8d8d8d",
          "--ruby-3": "#feeaed",
          "--sand-track": "#8d8d86",
          "--tomato-a6": "#f92d0050",
          "--yellow-a2": "#f4dd0016",
          "--sage-1": "#fbfdfc",
          "--plum-surface": "#fdf5fdcc",
          "--iris-2": "#f8f8ff",
          "--green-a8": "#00924ba4",
          "--amber-a6": "#eab5008c",
          "--black-a4": "rgba(0,0,0,.2)",
          "--orange-a6": "#ff81007d",
          "--crimson-6": "#f3bed1",
          "--bronze-1": "#fdfcfc",
          "--sand-a12": "#060500e3",
          "--jade-7": "#8bceb6",
          "--pink-a2": "#e0008008",
          "--mint-a10": "#00c39982",
          "--blue-11": "#0d74ce",
          "--plum-contrast": "#fff",
          "--cyan-a5": "#01b4cc4a",
          "--indigo-a4": "#0044ff1e",
          "--ruby-a5": "#ff002a31",
          "--pink-a8": "#af006f6c",
          "--pink-6": "#efbfdd",
          "--tomato-7": "#f5a898",
          "--gold-a9": "#5332009a",
          "--pink-a3": "#f4008c16",
          "--olive-1": "#fcfdfc",
          "--black-a2": "rgba(0,0,0,.1)",
          "--grass-3": "#e9f6e9",
          "--mint-a1": "#00d5aa06",
          "--sky-3": "#e1f6fd",
          "--black-a9": "rgba(0,0,0,.7)",
          "--bronze-12": "#43302b",
          "--iris-7": "#b8baf8",
          "--blue-a7": "#0083eb71",
          "--jade-6": "#acdec8",
          "--slate-indicator": "#8b8d98",
          "--jade-5": "#c3e9d7",
          "--cyan-7": "#7dcedc",
          "--yellow-4": "#fff394",
          "--plum-track": "#ab4aba",
          "--purple-a2": "#8000e008",
          "--iris-a5": "#000eff25",
          "--purple-a3": "#8e00f112",
          "--indigo-7": "#abbdf9",
          "--red-4": "#ffdbdc",
          "--gray-a3": "#0000000f",
          "--gold-contrast": "#fff",
          "--sage-a1": "#00804004",
          "--purple-a6": "#7a01d03b",
          "--sage-a10": "#00100a83",
          "--teal-surface": "#f0faf8cc",
          "--bronze-8": "#c2a499",
          "--lime-indicator": "#bdee63",
          "--tomato-a12": "#460900e0",
          "--bronze-a5": "#7423002c",
          "--violet-3": "#f4f0fe",
          "--gold-11": "#71624b",
          "--grass-a7": "#018b0f6b",
          "--green-1": "#fbfefc",
          "--sage-a3": "#002d1e11",
          "--mauve-a1": "#55005503",
          "--slate-a6": "#00002f26",
          "--gray-7": "#cecece",
          "--yellow-12": "#473b1f",
          "--orange-2": "#fff7ed",
          "--yellow-surface": "#fefbe4cc",
          "--violet-a11": "#1f0099af",
          "--gray-a11": "#0000009b",
          "--purple-indicator": "#8e4ec6",
          "--green-6": "#adddc0",
          "--purple-2": "#fbf7fe",
          "--sky-11": "#00749e",
          "--grass-11": "#2a7e3b",
          "--gold-indicator": "#978365",
          "--yellow-a9": "#ffe100d6",
          "--jade-a5": "#00a2553c",
          "--blue-5": "#c2e5ff",
          "--lime-12": "#37401c",
          "--slate-surface": "#ffffffcc",
          "--sage-9": "#868e8b",
          "--pink-9": "#d6409f",
          "--yellow-a1": "#aaaa0006",
          "--brown-6": "#e4cdb7",
          "--mint-a12": "#00312ae9",
          "--green-a12": "#002616e6",
          "--violet-11": "#6550b9",
          "--purple-3": "#f7edfe",
          "--red-a10": "#d10005c1",
          "--tomato-indicator": "#e54d2e",
          "--yellow-10": "#ffdc00",
          "--sand-2": "#f9f9f8",
          "--mauve-10": "#84828e",
          "--sky-9": "#7ce2fe",
          "--jade-11": "#208368",
          "--red-a5": "#ff000632",
          "--gray-a4": "#00000017",
          "--sky-a1": "#00d5ff06",
          "--slate-a2": "#00005506",
          "--brown-a11": "#522100b9",
          "--slate-8": "#b9bbc6",
          "--jade-track": "#29a383",
          "--olive-a11": "#020a00a0",
          "--cyan-4": "#caf1f6",
          "--white-a8": "hsla(0,0%,100%,.6)",
          "--black-a7": "rgba(0,0,0,.5)",
          "--sky-a10": "#00bcf38b",
          "--mint-6": "#9ce0d0",
          "--indigo-track": "#3e63dd",
          "--plum-a12": "#40004be6",
          "--crimson-5": "#facedd",
          "--violet-a2": "#4900ff07",
          "--olive-5": "#dfe2df",
          "--olive-a1": "#00550003",
          "--purple-9": "#8e4ec6",
          "--grass-a9": "#008619b9",
          "--violet-2": "#faf8ff",
          "--teal-1": "#fafefd",
          "--mint-12": "#16433c",
          "--green-contrast": "#fff",
          "--amber-9": "#ffc53d",
          "--cyan-track": "#00a2c7",
          "--sand-12": "#21201c",
          "--green-8": "#5bb98b",
          "--teal-a10": "#009684f2",
          "--indigo-surface": "#f5f8ffcc",
          "--plum-3": "#fbebfb",
          "--olive-a6": "#00140028",
          "--grass-a3": "#00970016",
          "--purple-a1": "#aa00aa03",
          "--purple-10": "#8347b9",
          "--crimson-a2": "#e0004008",
          "--red-surface": "#fff5f5cc",
          "--jade-2": "#f4fbf7",
          "--plum-indicator": "#ab4aba",
          "--crimson-a4": "#f8005123",
          "--green-a10": "#008647d4",
          "--slate-9": "#8b8d98",
          "--bronze-indicator": "#a18072",
          "--indigo-indicator": "#3e63dd",
          "--jade-a11": "#007152df",
          "--amber-indicator": "#ffc53d",
          "--indigo-12": "#1f2d5c",
          "--brown-surface": "#fbf8f4cc",
          "--gray-surface": "#ffffffcc",
          "--teal-a5": "#00b49047",
          "--mint-track": "#86ead4",
          "--mauve-6": "#dbd8e0",
          "--mauve-a6": "#14003527",
          "--violet-10": "#654dc4",
          "--crimson-a1": "#ff005503",
          "--orange-8": "#ec9455",
          "--violet-8": "#aa99ec",
          "--cyan-1": "#fafdfe",
          "--orange-a4": "#ff91014a",
          "--sky-a4": "#00ace42e",
          "--ruby-11": "#ca244d",
          "--red-3": "#feebec",
          "--mint-contrast": "#1a211e",
          "--sand-a7": "#19140035",
          "--sky-track": "#7ce2fe",
          "--gold-1": "#fdfdfc",
          "--ruby-6": "#f8bfc8",
          "--cyan-a12": "#00323ef2",
          "--crimson-contrast": "#fff",
          "--sage-5": "#dfe2e0",
          "--black-a5": "rgba(0,0,0,.3)",
          "--red-11": "#ce2c31",
          "--sand-5": "#e2e1de",
          "--red-2": "#fff7f7",
          "--orange-12": "#582d1d",
          "--teal-contrast": "#fff",
          "--indigo-a6": "#003eff3e",
          "--brown-a3": "#a04b0018",
          "--plum-a6": "#a400b03d",
          "--lime-a9": "#93e4009c",
          "--gray-1": "#fcfcfc",
          "--crimson-1": "#fffcfd",
          "--purple-a10": "#53009eb8",
          "--plum-a7": "#9900a852",
          "--sky-1": "#f9feff",
          "--black-a8": "rgba(0,0,0,.6)",
          "--mint-a6": "#00b08663",
          "--ruby-a1": "#ff005503",
          "--tomato-11": "#d13415",
          "--sage-a6": "#00140d28",
          "--mint-a9": "#00d3a579",
          "--orange-a7": "#ed6c008c",
          "--green-11": "#218358",
          "--mauve-1": "#fdfcfd",
          "--jade-9": "#29a383",
          "--yellow-9": "#ffe629",
          "--mauve-8": "#bcbac7",
          "--sky-a5": "#00a1d841",
          "--pink-surface": "#fef5facc",
          "--brown-8": "#cea37e",
          "--sage-3": "#eef1f0",
          "--yellow-a5": "#ffd5008f",
          "--plum-4": "#f7def8",
          "--sand-a8": "#1915014a",
          "--grass-a10": "#007b17c1",
          "--red-a1": "#ff000003",
          "--tomato-a8": "#db250084",
          "--white-a2": "hsla(0,0%,100%,.1)",
          "--sage-a5": "#00180820",
          "--jade-10": "#26997b",
          "--crimson-a3": "#ff005216",
          "--orange-a5": "#ff8b0065",
          "--grass-track": "#46a758",
          "--yellow-2": "#fefce9",
          "--bronze-a7": "#6c1f004c",
          "--bronze-a10": "#4c150097",
          "--mint-9": "#86ead4",
          "--indigo-a8": "#0034dc72",
          "--yellow-a7": "#d2a10098",
          "--lime-10": "#b0e64c",
          "--sand-indicator": "#8d8d86",
          "--sky-6": "#a9daed",
          "--sky-8": "#60b3d7",
          "--violet-surface": "#f9f6ffcc",
          "--gold-7": "#cbc0aa",
          "--orange-5": "#ffd19a",
          "--sage-10": "#7c8481",
          "--mint-a7": "#00a17d81",
          "--bronze-10": "#957468",
          "--green-indicator": "#30a46c",
          "--amber-a7": "#dc9b009d",
          "--green-4": "#d6f1df",
          "--purple-7": "#d1afec",
          "--tomato-a10": "#d72400da",
          "--gold-a6": "#64440040",
          "--teal-6": "#a1ded2",
          "--plum-a3": "#cc00cc14",
          "--sky-contrast": "#1c2024",
          "--mint-a3": "#00d29e22",
          "--olive-a3": "#00200010",
          "--sage-a7": "#00140a34",
          "--iris-10": "#5151cd",
          "--plum-8": "#cf91d8",
          "--ruby-contrast": "#fff",
          "--plum-5": "#f2d1f3",
          "--grass-a11": "#006514d5",
          "--blue-a1": "#0080ff04",
          "--white-a3": "hsla(0,0%,100%,.15)",
          "--olive-indicator": "#898e87",
          "--blue-a6": "#0088f653",
          "--mauve-3": "#f2eff3",
          "--bronze-a1": "#55000003",
          "--blue-7": "#8ec8f6",
          "--green-a2": "#00a32f0b",
          "--purple-surface": "#faf5fecc",
          "--pink-a7": "#b6006f53",
          "--blue-1": "#fbfdff",
          "--green-track": "#30a46c",
          "--cyan-indicator": "#00a2c7",
          "--cyan-a1": "#0099cc05",
          "--sand-9": "#8d8d86",
          "--yellow-track": "#ffdc00",
          "--iris-1": "#fdfdff",
          "--indigo-a1": "#00008002",
          "--olive-7": "#cccfcc",
          "--lime-1": "#fcfdfa",
          "--indigo-a3": "#0047f112",
          "--cyan-8": "#3db9cf",
          "--red-9": "#e5484d",
          "--mint-surface": "#effaf8cc",
          "--olive-contrast": "#fff",
          "--yellow-a11": "#9e6c00",
          "--ruby-a4": "#ff002523",
          "--purple-contrast": "#fff",
          "--gray-a10": "#0000007c",
          "--brown-a7": "#a34e0060",
          "--grass-a4": "#009f0725",
          "--brown-contrast": "#fff",
          "--sand-a4": "#1f150019",
          "--teal-a1": "#00cc9905",
          "--sky-a3": "#00b3ee1e",
          "--iris-3": "#f0f1fe",
          "--amber-a1": "#c0800004",
          "--slate-contrast": "#fff",
          "--sky-a6": "#0092ca56",
          "--sage-11": "#5f6563",
          "--plum-7": "#deade3",
          "--slate-a8": "#00083046",
          "--rhythm-section": "7rem",
          "--rhythm-subsection": "3.5rem",
          "--rhythm-heading-to-body": "1rem",
          "--stack-heading-size": "20px",
          "--stack-heading-weight": "500",
          "--stack-heading-line-height": "24px",
          "--stack-heading-tracking": "-0.2px",
          "--stack-body-size": "16px",
          "--stack-body-weight": "400",
          "--stack-body-line-height": "24px"
        },
        "meta": {
          "extractedAt": "2026-05-08T22:40:12.037Z"
        }
      }
    },
    "defaultMode": "light",
    "notes": [
      "body font \"Untitled Sans\" not on Google Fonts — fallback to sans-serif"
    ]
  },
];

export const PRESETS_BY_SLUG: Record<string, BrandTheme> = Object.fromEntries(
  PRESETS.map((t) => [t.slug, t]),
);
